export default `directive @dateISO8601 on FIELD_DEFINITION | INPUT_FIELD_DEFINITION

directive @bigdecimal on FIELD_DEFINITION | INPUT_FIELD_DEFINITION

directive @yyyyMMddTHHmmssZZZZZ on FIELD_DEFINITION | INPUT_FIELD_DEFINITION

directive @yyyyMMdd on FIELD_DEFINITION | INPUT_FIELD_DEFINITION

directive @positive on INPUT_FIELD_DEFINITION

directive @length(len: Int = 0) on INPUT_FIELD_DEFINITION

directive @minLength(len: Int = 0) on INPUT_FIELD_DEFINITION

directive @phoneNumber on INPUT_FIELD_DEFINITION

directive @email on INPUT_FIELD_DEFINITION | ARGUMENT_DEFINITION

directive @paxName on INPUT_FIELD_DEFINITION

directive @city on INPUT_FIELD_DEFINITION

directive @cardNumber on INPUT_FIELD_DEFINITION

directive @address on INPUT_FIELD_DEFINITION

directive @zipCode on INPUT_FIELD_DEFINITION

directive @period on FIELD_DEFINITION

directive @authRequired on FIELD_DEFINITION

schema {
  query: Query
  mutation: Mutation
}

scalar Long

type Query {
  searchRoomAvailability(searchRoomAvailabilityRequest: SearchRoomAvailabilityRequest!): SearchRoomAvailabilityResponse!
  searchAccommodation(accommodationSearchRequest: AccommodationSearchRequest!): AccommodationSearchResponse!
  postBookingSearchAccommodation(accommodationPostBookingSearchRequest: AccommodationPostBookingSearchRequest!): AccommodationSearchResponse!
  searchAccommodationByDedupId(accommodationSearchByDedupIdRequest: AccommodationSearchByDedupIdRequest!): AccommodationSearchResponse! @deprecated(reason: "The query accommodationStaticContent is no longer used")
  accommodationStaticContent(accommodationStaticContentRequest: AccommodationStaticContentRequest!): AccommodationStaticContentResponse!
  accommodationSummary(accommodationSummaryRequest: AccommodationSummaryRequest!): AccommodationSummaryResponse!
  accommodationDetails(accommodationDetailsRequest: AccommodationDetailsRequest!): AccommodationDetailsResponse!
  accommodationSuggestion(accommodationSuggestionRequest: AccommodationSuggestionRequest!): AccommodationSuggestionResponse!
  searchRoomDetails(roomDetailsRequest: AccommodationDetailRequest!): AccommodationDetailResponse!
  roomDetailsStatic(roomDetailsRequest: RoomsDetailRequest!): RoomsDetailResponse!
  accommodationStaticMap(accommodationStaticMapRequest: AccommodationStaticMapRequest!): StaticMapResponse!
  accommodationCancellationOptions(bookingId: Long!, isPrime: Boolean!): AccommodationCancellationOption
  searchAccommodationBySearchId(accommodationSearchBySearchIdRequest: AccommodationSearchBySearchIdRequest!): AccommodationSearchResponse!
  recogniseUserForAccommodation: RecogniseUserForAccommodationResponse!
  searchAccommodationAsync(accommodationSearchAsyncRequest: AccommodationSearchAsyncRequest!): AccommodationSearchAsyncResponse!
  accommodationImages(accommodationImagesRequest: AccommodationImagesRequest!): AccommodationImagesResponse!
  activeCampaign: ActiveCampaignResponse!
  ancillaryOptions(bookingID: ID, flow: AncillaryFlowType!): AncillaryResponse!
  ancillaryProductSelection(productId: ProductIdRequest!): AncillarySelectionResponse!
  ancillariesRetailingEvaluation(request: AncillariesRetailingEvaluationRequest!): AncillariesRetailingEvaluationResponse! @deprecated
  ancillariesRetailingEvaluationNavigationTree(request: AncillariesRetailingEvaluationRequest!): AncillariesRetailingEvaluationNavigationTreeResponse!
  postBookingAncillaryBundleOffers(request: PostBookingAncillaryBundleOfferRequest!): PostBookingAncillaryBundleOffersResponse!
  ancillaryBundleProduct(request: AncillaryBundleProductRequest!): AncillaryBundleProduct!
  ancillaryBundlesByRelatedTripProduct(request: AncillaryBundlesByRelatedTripProductRequest!): AncillaryBundlesByRelatedTripProductResponse!
  getCarrierCustomerCredentials(request: CarrierCustomerCredentialsRequest!): CarrierCustomerCredentialsResponse! @deprecated(reason: "This query only supports credentials for one carrier")
  getCarriersCustomerCredentials(request: CarrierCustomerCredentialsRequest!): CarriersCustomerCredentialsResponse!
  getCarrierDocuments(request: CarrierDocumentsRequest!): CarrierDocumentsResponse!
  checkInsStatus(request: CheckInsStatusRequest!): CheckInsStatusResponse!
  checkInFunnel(request: CheckInFunnelRequest!): CheckInFunnelResponse!
  checkInFunnelTravellerForm(request: CheckInFunnelTravellerFormRequest!): CheckInFunnelTravellerFormResponse!
  checkinStatus(bookingID: ID): CheckinStatus @deprecated
  checkinAvailability(bookingID: ID, citizenship: String): CheckinAvailability
  boardingPasses(ids: [ID!]!): BoardingPassesResponse @deprecated
  retrieveUserPaymentInteraction(request: UserPaymentInteractionRequest): UserPaymentInteraction!
  checkUserPaymentInteraction(request: UserPaymentInteractionRequest): InteractionFinished!
  retrieveRedirect(request: UserPaymentInteractionRequest!): UserPaymentInteractionRedirect!
  addRedirect(request: UserPaymentInteractionRedirectRequest!): InteractionFinished!
  getApplePayPaymentSession(request: ApplePayPaymentSessionRequest!): ApplePayPaymentSession!
  decryptCrmUserTokenForAccommodation(request: DecryptCrmUserTokenForAccommodationRequest!): DecryptCrmUserTokenForAccommodationResponse!
  getCSFaqRecommendations(bookingId: Long!): FaqRecommendation!
  getCSQueue(queueRequest: QueueRequest!): GenesysInfo!
  deals(request: DealsRequest): [Deal!]!
  accommodationDeals(request: AccommodationDealRequest!): [AccommodationDeal!]! @deprecated(reason: "Use accommodationDealsV2 instead")
  accommodationDealsByDestination(request: AccommodationDealByDestinationRequest!): [AccommodationDeal!]! @deprecated(reason: "Use accommodationDealsV2 instead")
  accommodationDealsV2(request: AccommodationDealRequest!): AccommodationDealsResponse!
  postBookingURL(postBookingURLRequest: PostBookingURLRequest!): PostBookingURLResponse! @deprecated(reason: "Not used, will be removed in next iterations")
  accommodationPostBookingURL(postBookingURLRequest: AccommodationPostBookingURLRequest!): PostBookingURLResponse!
  accommodationSearchDeeplinkForAccommodationProduct(searchRequest: HsaSearchURLRequest!): HsaSearchURLResponse!
  accommodationSearchRoomURL(accommodationRoomSearchRequest: AccommodationSearchRoomURLRequest!): AccommodationSearchRoomURLResponse!
  getEmailSuggestions(email: String!): [String]!
  fareFamilies(fareFamilyRequest: FareFamilyRequest!): [FareFamily]!
  searchFastTracksByItinerary(request: SearchFastTracksByItineraryRequest!): SearchFastTracksByItineraryResponse!
  searchFastTrackOffers(request: SearchFastTrackOffersRequest!): SearchFastTrackOffersResponse!
  shoppingBasketFastTrackProducts(request: ShoppingBasketFastTrackProductsRequest!): ShoppingBasketFastTrackProductsResponse!
  getFastTrackAvailabilities(request: GetFastTrackAvailabilitiesRequest!): GetFastTrackAvailabilitiesResponse!
  favoriteAccommodationsLocation: FavoriteAccommodationsLocationResponse!
  favoriteAccommodationsByLocation(request: FavoriteAccommodationsByLocationRequest!): FavoriteAccommodationsByLocationResponse
  evaluateFeaturesEventTracking(feature: FeaturesEventTrackingRequest!): FeaturesEventTrackingResponse!
  featureVariationsWithVersion(aliases: [FeatureVariationRequestWithVersion!]!): [FeatureVariationResponse!]!
  featureVariations(aliases: [FeatureVariationRequest!]!): [FeatureVariationResponse!]!
  flexibleDatesPrices(flexibleDatesPricesRequest: FlexibleDatesPricesRequest): FlexibleDatesPricesResponse!
  flexibleDates(flexibleDatesSearchRequest: FlexibleDatesSearchRequest): FlexibleDatesSearchResponse!
  geolocationSuggestions(geolocationSuggestionsRequest: GeolocationSuggestionsRequest): GeolocationSuggestionsResponse!
  geolocationSuggestionsByLocation(geolocationSuggestionsByLocationRequest: GeolocationSuggestionsByLocationRequest): GeolocationSuggestionsByLocationResponse!
  getCountries(getCountriesRequest: GetCountriesRequest): GetCountriesResponse!
  getLocationByIp(ip: String): LocalizationByIpResponse!
  getGeoLocation(geoNodeId: Int!): GeoLocation!
  getLocations(locationsRequest: GeoServiceLocationsRequest!): GeoServiceLocationsResponse!
  getInsuranceOffers(request: InsuranceOffersRequest): InsuranceOffersResponse! @deprecated(reason: "Obsolete call. Not in use anymore.")
  getInvoicesByBookingId(bookingId: Long!): [Invoice]!
  getLastInvoiceRequestByBookingId(bookingInvoicesRequest: BookingInvoicesRequest!): LastInvoiceRequestedResponse
  getInvoiceDetailsById(bookingId: Long!, email: String!, invoiceId: String!): InvoiceDetails
  getInvoiceComponents(bookingId: Long!, email: String!): InvoiceComponents
  membership(membershipRequest: MembershipRequest): Membership
  tokenInfo(token: String): MembershipTokenResponse
  primeInfo(headers: Headers): PrimeInfo! @deprecated(reason: "Breaking this query into others, like: primeSiteProperties")
  membershipPages(membershipPagesRequest: MembershipPagesRequest): MembershipPagesResponse!
  membershipAccountProperties(email: String): MembershipAccountPropertiesResponse!
  primeSiteProperties: PrimeSitePropertiesResponse!
  membershipProduct(membershipProductRequest: GetMembershipProductRequest): MembershipSubscriptionResponse
  membershipChurnPrediction(membershipChurnPredictionRequest: MembershipChurnPredictionRequest!): MembershipChurnPredictionResponse!
  retentionInfo: RetentionFlowInfoResponse
  membershipRejoinOffers: MembershipRejoinOffersResponse!
  isModifiable(request: ModifiableRequest!): ModifiableResponse!
  getEligibility(bookingId: Long!, bookingItemId: Long!, providerBookingItemId: Long): EligibilityResponse!
  getEligibilityForIncident(eligibilityForIncidentRequest: EligibilityForIncidentRequest!): EligibilityForIncidentResponse!
  searchAlternativesForIncident(searchAlternativesForIncidentRequest: SearchAlternativesForIncidentRequest!): SearchAlternativesForIncidentResponse!
  searchItineraryAlternatives(itinerarySearchAlternativeRequest: ItinerarySearchAlternativeRequest!): ItinerarySearchAlternativeResponse!
  getFlexibleProductsApplicability(flexibleProductsApplicabilityRequest: FlexibleProductsApplicabilityRequest!): FlexibleProductsApplicabilityResponse!
  getMaximumReimbursementPrice(maximumReimbursementPriceRequest: MaximumReimbursementPriceRequest!): MaximumReimbursementPriceResponse!
  nativeItineraryCalendar(nativeItineraryCalendarRequest: NativeItineraryCalendarRequest): NativeItineraryCalendarResponse!
  nextDynpackFunnelPage(request: NextDynpackFunnelPageRequest!): NextFunnelPageResponse!
  nextItineraryFunnelPage(request: NextItineraryFunnelPageRequest!): NextFunnelPageResponse!
  availableNonEssentialProducts(request: NonEssentialProductsRequest!): NonEssentialProductsOfferResponse!
  availablePayWithProduct(request: PriceBreakDownRequest): NonEssentialPayWithProductResponse!
  getCreditCardBinDetails(bin: String!): CreditCardBinDetails!
  creditCardDateDetailsResponse(date: String!): CreditCardDateDetailsResponse!
  nonPciScopeCreditCard(request: NonPciScopeCreditCardRequest!): NonPciScopeCreditCardResponse!
  itineraryPriceFreezeOffer(offerRequest: PriceFreezeOfferRequest!): ItineraryPriceFreezeOffer
  itineraryPriceFreezeEligibility(priceFreezeEligibilityRequest: PriceFreezeEligibilityRequest!): PriceFreezeEligibility!
  itineraryPriceFreezeOffers(offerRequest: PriceFreezeOfferRequest!): [ItineraryPriceFreezeOffer!]!
  itineraryPriceFreeze(id: ID!): ItineraryPriceFreeze
  itineraryPriceFreezes(itineraryPriceFreezesRequest: ItineraryPriceFreezesRequest): [ItineraryPriceFreeze]! @authRequired
  itineraryPriceFreezeRedemption(itineraryPriceFreezeRedemptionRequest: ItineraryPriceFreezeRedemptionRequest): ItineraryPriceFreezeRedemption!
  itineraryPriceFreezeRevenueData(itineraryPriceFreezeRevenueDataRequest: ItineraryPriceFreezeRevenueDataRequest): ItineraryPriceFreezeRevenueData!
  getRecaptchaConfig: RecaptchaConfigResponse!
  residentDiscountZones(request: ResidentDiscountRequest): ResidentDiscountResponse!
  rData(request: RDataRequest!): RDataResponse!
  search(searchRequest: SearchRequest!): SearchResponse! @deprecated(reason: "Not used anymore since the payload reduction development rollout")
  itinerarySearch(searchRequest: SearchRequest!): ItinerarySearchResponse!
  searchCriteria(searchId: Long!): SearchCriteria!
  isReturningCustomer(request: SemIsReturningCustomerRequest!): SemIsReturningCustomerResponse!
  numberOfBookingsByToken(request: SemNumberOfBookingsByTokenRequest!): SemNumberOfBookingsByTokenResponse!
  semItinerarySearch(semItinerariesSearchRequest: SemItinerariesSearchRequest!): SemItinerariesSearchResponse!
  semSearch(semSearchRequest: SemSearchRequest!): SemSearchResponse!
  getShoppingBundle(request: ShoppingBundleRequest): ShoppingBundle!
  getShoppingBookingId(request: GetShoppingBookingIdRequest): ID!
  getShoppingSummary(request: ShoppingSummaryRequest!): ShoppingSummary!
  getSummaryInfo(request: ShoppingInfo!): ShoppingSummary!
  getShoppingCart(bookingId: Long!): ShoppingCart!
  canApplyItineraryDiscount(request: CanApplyItineraryDiscountRequest!): CanApplyItineraryDiscountResponse!
  priceAlert(priceAlertRequest: PriceAlertRequest!): Boolean!
  subscriptionOfferById(offerId: String!): SubscriptionResponse
  subscriptionOffers(request: SubscriptionOffersRequest): [SubscriptionResponse!]!
  calculateSubscriptionOffer(request: CalculateSubscriptionOfferRequest!): CalculateSubscriptionOfferResponse!
  topDestinations: [TopDestination]!
  getTravelPlans: TravelPlansResponse! @deprecated(reason: "Use getTravelPlansV2 instead.")
  getTravelPlansV2: TravelPlansResponseV2!
  findRelatedAccommodationTrip(findRelatedAccommodationTripRequest: FindRelatedAccommodationTripRequest!): FindRelatedAccommodationTripResponse! @deprecated(reason: "Use getTripV2 with support of baToken instead")
  getTrip(email: String!, bookingId: Long!, filter: TripFilter): TripResponse!
  getTripV2(filter: TripFilter): TripResponse! @deprecated(reason: "Use getTripV2 with support of baToken instead")
  getTripByToken(token: String!, filter: TripFilter): TripResponse!
  getTrips(filter: TripListFilter, pagination: PaginationValue): TripListResponse!
  getMinimalBookingInfo(request: MinimalBookingInfoRequest): MinimalBookingInfoResponse!
  trustpilotParams: TrustpilotParamsResponse!
  authenticationMethod: AuthenticationMethodResponse!
  getUser: User
  getTravellers: [UserTraveller!]
  getUserCreditCards: UserCreditCardsResponse
  userInfo: UserInfo
  getUserByToken(token: String!): User
  recogniseUser: RecogniseUserResponse
  userSegment: UserSegmentResponse
  listLoginSessions: ListLoginSessionsResponse!
  userAccount(userAccountRequest: UserAccountRequest): UserAccountResponse
  canAccessUserArea: UserAreaAccess
  variations(aliases: [String]!): [Int]!
  getVehicleRentalOffersByItineraryId(vehicleRentalSearchRequest: VehicleRentalSearchRequest!): VehicleRentalSearchResponse!
  getVehicleRentalOffersByItineraryIdV2(vehicleRentalSearchRequest: VehicleRentalSearchRequestV2!): VehicleRentalSearchResponse!
  getVehicleRentalOffersByAccommodationId(vehicleRentalSearchRequest: VehicleRentalSearchRequest!): VehicleRentalSearchResponse!
  getVehicleRentalOffersByAccommodationIdV2(vehicleRentalSearchRequest: VehicleRentalSearchRequestByAccommodationV2!): VehicleRentalSearchResponse!
  getVehicleRentalOffers(vehicleSearchCriteriaRequest: VehicleSearchCriteriaRequest!): VehicleRentalSearchResponse!
  findVehicleRentals(vehicleRentalFindFilter: VehicleRentalFindRequest!): VehicleRentalResponse!
  autoCompleteSearch(autoCompleteSearchRequest: AutoCompleteSearchRequest): AutoCompleteSearchResponse!
  autoCompleteSearchV2(autoCompleteSearchRequest: AutoCompleteSearchRequestV2!): AutoCompleteSearchResponseV2!
  searchAccommodationByGeoAccommodation(geoAccommodationRequest: GeoAccommodationSearchRequest): GeoAccommodationSearchResponse! @deprecated(reason: "InsteadOf direct call, we reach geo-accommodation by searchAccommodation")
  geoLocationByGeoAccommodation(geoAccommodation: GeoAccommodationRequest!): GeoLocation
  geoAccommodationLocation(geoAccommodationLocationRequest: GeoAccommodationLocationRequest!): GeoAccommodationLocationResponse!
  geoAccommodationAssociations(geoAccommodationAssociationsRequest: GeoAccommodationAssociationsRequest!): GeoAccommodationAssociationsResponse!
  geoAccommodationRelatedRegions(geoAccommodationRelatedRegionsRequest: GeoAccommodationRelatedRegionsRequest!): GeoAccommodationRelatedRegionsResponse!
  isAccommodationModifiable(isAccommodationModifiableRequest: AccommodationModificationOptionsRequest!): IsAccommodationModifiableResponse!
  accommodationModificationOptions(accommodationModificationOptionsRequest: AccommodationModificationOptionsRequest!): AccommodationModificationOptionsResponse!
  retrieveAccommodationPriceAlertImage(priceAlertImageRequest: PriceAlertImageRequest!): PriceAlertImageResponse! @deprecated(reason: "InsteadOf direct call, we get imageUrl by geoAccommodationLocation query")
  getAccommodationRecommendationsByIataCode(accommodationRecommendationByIataCodeRequest: AccommodationRecommendationByIataCodeRequest): AccommodationRecommendationByIataCodeResponse!
  accommodationRecommendation(accommodationRecommendationRequest: AccommodationRecommendationRequest!): AccommodationRecommendationResponse!
  tripadvisorReview(tripadvisorReviewRequest: TripadvisorReviewRequest!): TripadvisorReviewResponse!
  accommodationSearchHistory(accommodationSearchHistoryRequest: AccommodationSearchHistoryRequest!): AccommodationSearchHistoryResponse!
  convertSecretHotelId(convertSecretHotelIdRequest: ConvertSecretHotelIdRequest!): ConvertSecretHotelIdResponse!
  touchPointMessaging: TouchPointMessagingResponse!
  isCancellable(request: CancellableRequest!): CancellableResponse!
  getEstimatedRefundAmount(bookingId: Long!, email: String!): RefundAmountResponse!
  retrieveVoluntaryCancellationOptions(request: VoluntaryCancellationOptionsRetrievementRequest!): VoluntaryCancellationOptionsRetrievementResponse!
  retrievePrimeFreeCancellationCompensation(request: PrimeFreeCancellationRequest!): PrimeFreeCancellationResponse!
  getFlashOffers: GetFlashOffersResponse!
  shoppingBasketUserPaymentInteraction(request: ShoppingBasketUserPaymentInteractionRequest!): ShoppingBasketUserPaymentInteractionResponse!
  shoppingBasketUserStoredCreditCards(request: ShoppingBasketUserStoredCreditCardsRequest!): ShoppingBasketUserStoredCreditCardsResponse!
  recurringCollection(recurringCollectionId: ID!): RecurringCollectionResponse!
  accommodationInsurances(request: AccommodationInsurancesRequest!): AccommodationInsurancesResponse!
  membershipStandaloneCampaign(request: MembershipStandaloneCampaignRequest): MembershipStandaloneCampaignResponse
  membershipStandaloneCheckoutStatus(request: MembershipStandaloneCheckoutStatusRequest): MembershipStandaloneCheckoutStatusResponse
  membershipStandalonePersonalData(request: MembershipStandalonePersonalDataRequest): MembershipStandalonePersonalDataResponse
  membershipStandaloneOfferDetails(request: MembershipStandaloneOfferDetailsRequest): MembershipStandaloneOfferDetailsResponse
  retrievePaypalStandaloneEligibility: RetrievePaypalStandaloneEligibilityResponse!
  retrieveUnchainedMembershipPostBookingEligibility(request: RetrieveUnchainedMembershipPostBookingEligibilityRequest!): RetrieveUnchainedMembershipPostBookingEligibilityResponse!
  retrievePostBookingSubscriptionCheckoutDetails(request: RetrieveSubscriptionCheckoutDetailsRequest!): RetrieveSubscriptionCheckoutDetailsResponse!
  retrieveSubscriptionEligibilityOfferDetails(request: RetrieveSubscriptionEligibilityOfferDetailsRequest!): RetrieveSubscriptionEligibilityOfferDetailsResponse! @authRequired @deprecated
  calculatePrimeSubscriptionPostPurchaseOffers(request: CalculatePrimeSubscriptionPostPurchaseOffersRequest!): CalculatePrimeSubscriptionPostPurchaseOffersResponse!
  retrieveReferralLinkToken: SelectReferralLinkTokenResponse!
  retrieveReferralLinkTokenV2: SelectReferralLinkTokenResponseV2!
  retrieveReferralLinkTokenV2CRMFlow(request: SelectReferralLinkTokenRequestV2CRMFlow!): SelectReferralLinkTokenResponseV2!
  selectMembershipStandaloneReferral(request: SelectMembershipStandaloneReferralRequest!): SelectMembershipStandaloneReferralResponse!
  calculateReferralsOffers(request: CalculateReferralsOffersRequest!): CalculateReferralsOffersResponse!
  getReferralReward(request: GetReferralRewardRequest!): GetReferralRewardResponse!
  getCartPriceBreakDown(request: PriceBreakDownRequest): CartPriceBreakDown!
  getSummaryPrice(request: ShoppingSummaryRequest!): PriceSummary!
  getShoppingBasketPrice(request: ShoppingBasketPriceRequest!): ShoppingBasketPriceResponse!
  decouplingPrimeSubscriptionFlowState(request: DecouplingPrimeSubscriptionFlowStateRequest!): DecouplingPrimeSubscriptionFlowStateResponse!
  calculatePrimeSubscriptionOffer(request: CalculatePrimeSubscriptionOfferRequest!): CalculatePrimeSubscriptionOfferResponse!
  primeSubscriptionPostPurchaseToken(request: PrimeSubscriptionPostPurchaseTokenRequest!): PrimeSubscriptionPostPurchaseTokenResponse!
  primeSubscriptionPostPurchaseOffer(request: PrimeSubscriptionPostPurchaseOfferRequest!): PrimeSubscriptionPostPurchaseOfferResponse!
  searchItinerary(searchItineraryRequest: SearchItineraryRequest!): SearchItineraryResponse!
  searchTrains(searchTrainsRequest: SearchTrainsRequest!): SearchItineraryResponse!
  getShoppingBasket(request: ShoppingBasketRequest): ShoppingBasketResponse!
  getAvailableCollectionMethods(request: AvailableCollectionMethodsRequest): AvailableCollectionMethodsResponse!
  getShoppingBasketByToken(shoppingBasketToken: String!): ShoppingBasketResponse!
  shoppingBasketIdToToken(membershipId: String!): ShoppingBasketToken!
  shoppingBasketTokenByPayByLinkContentId(shoppingBasketTokenByPayByLinkContentIdRequest: ShoppingBasketTokenByPayByLinkContentIdRequest!): ShoppingBasketTokenByPayByLinkContentIdResponse!
  getUniversalShoppingBasket(request: UniversalShoppingBasketRequest!): UniversalShoppingBasketResponse!
  getUniversalShoppingBasketCheckoutOptions(request: UniversalShoppingBasketCheckoutOptionsRequest!): UniversalShoppingBasketCheckoutOptionsResponse!
  getUniversalShoppingBasketByToken(request: UniversalShoppingBasketByTokenRequest!): UniversalShoppingBasketResponse!
  getUniversalShoppingBasketForTracking(request: UniversalShoppingBasketRequest!): UniversalShoppingBasketForTrackingResponse!
  getUniversalRevenueForTracking(request: UniversalRevenueForTrackingRequest!): UniversalRevenueForTrackingResponse!
  productsForTracking(request: ProductsForTrackingRequest!): ProductsForTrackingResponse! @deprecated(reason: "No longer in use")
  getShoppingBundleForTracking(request: ShoppingBundleForTrackingRequest): ShoppingBundleForTracking!
  getCancellationPolicies(request: GetCancellationPoliciesRequest!): GetCancellationPoliciesResponse!
  getAncillariesPurchaseState(request: GetAncillariesPurchaseStateRequest!): AncillariesPurchaseStateResponse! @deprecated
}

type Mutation {
  selectAccommodationOffer(request: SelectAccommodationOfferRequest!): SelectAccommodationOfferResponse!
  rebuildAccommodationOffer(request: RebuildAccommodationOfferRequest!): RebuildAccommodationOfferResponse!
  createAccommodationProduct(request: CreateAccommodationProductRequest!): CreateAccommodationProductResponse!
  cancelAccommodation(cancellationOptionId: ID!): AccommodationCancellation!
  selectAncillaries(request: SelectAncillariesRequest!): SelectedAncillariesResponse!
  selectAncillaryBundle(request: AncillaryBundleSelectionRequest!): AncillaryBundleProduct!
  createBankTransfer(bookingId: Long!, email: String!, iban: String!, bic: String!, accountHolder: String!): Boolean! @deprecated
  submitBankTransferRequest(bankTransferRequest: BankTransferRequest!): BankTransferResponse!
  joinChatbotBookingSession(joinChatbotBookingSessionRequest: JoinChatbotBookingSessionRequest!): ChatbotSession!
  sendChatbotEvent(chatbotEvent: ChatbotEvent!): ChatbotInteractionResponse!
  sendChatbotPageEvent(chatbotPageEvent: ChatbotPageEvent!): ChatbotInteractionResponse!
  sendChatbotText(chatbotText: ChatbotText!): ChatbotInteractionResponse!
  sendChatbotFeedback(chatbotFeedback: ChatbotFeedbackRequest!): ChatbotFeedbackResponse!
  identifyChatbotFlowByBooking(request: ChatbotFlowBookingIdentificationRequest!): ChatbotFlowBookingIdentificationResponse!
  createCheckInV2(request: CreateCheckInV2Request!): CreateCheckInV2Response!
  createCheckinRequest(checkinRequest: CheckinRequest): CreateCheckinResponse! @deprecated
  checkout(request: CheckoutRequest): CheckoutResponse!
  cancelCheckout(request: CancelCheckoutRequest!): CheckoutResponse!
  resumeCheckout(request: ResumeCheckoutRequest!): CheckoutResponse!
  addOutcome(request: AddOutcomeRequest!): AddOutcomeResponse!
  addUserCollectionTracking(request: UserCollectionTrackingRequest!): UserCollectionTrackingResponse
  storeSmsConsent(request: StoreSmsConsentRequest!): StoreSmsConsentResponse!
  selectFastTrackOfferForItinerary(request: SelectFastTrackOfferForItineraryRequest!): SelectFastTrackOfferForItineraryResponse!
  unselectFastTrack(request: UnselectFastTrackRequest!): UnselectFastTrackResponse!
  selectFastTrack(request: SelectFastTrackRequest!): SelectFastTrackResponse!
  addFavoriteAccommodation(request: AddFavoriteAccommodationRequest!): AddFavoriteAccommodationResponse!
  deleteFavoriteAccommodation(request: DeleteFavoriteAccommodationRequest!): DeleteFavoriteAccommodationResponse!
  favoriteAccommodationsByLocation(request: FavoriteAccommodationsByLocationRequest!): FavoriteAccommodationsByLocationResponse @deprecated(reason: "It is a query, not a mutation")
  selectInsuranceOffer(request: SelectInsuranceOfferRequest): SelectInsuranceOfferResponse!
  createInvoiceRequest(bookingId: Long!, email: String!, contactDetails: InvoiceContactDetails): Invoice!
  itinerarySearchAlternatives(itinerarySearchAlternativesRequest: ItinerarySearchAlternativesRequest!): ItinerarySearchResponse!
  sendLoginEmail(loginEmailRequest: LoginEmailRequest!): LoginEmailResponse!
  sendAuthenticationEmail(request: AuthenticationEmailRequest!): AuthenticationEmailResponse!
  sendReauthenticationEmail(request: ReauthenticationEmailRequest!): ReauthenticationEmailResponse!
  sendAuthenticationEmailAndJoinTripAroundTheWorldContest(request: AuthenticationEmailWithTripAroundTheWorldContestParticipationRequest!): AuthenticationEmailResponse!
  updateUserMembership(updateUserMembershipRequest: UpdateUserMembershipRequest): Membership
  updateUserMembershipPlan(updateUserMembershipPlanRequest: UpdateUserMembershipPlanRequest): Membership
  updateMembershipProduct(updateMembershipProductRequest: UpdateMembershipProductRequest): MembershipSubscriptionResponse
  updateSubscriptionProductBinBased(updateSubscriptionProductBinBasedRequest: UpdateSubscriptionProductBinBasedRequest!): MembershipSubscriptionResponse
  requestRetentionVoucher: RetentionVoucherResponse
  requestReactivationVoucher: ReactivationVoucherResponse
  membershipProductEvaluation(request: MembershipProductEvaluationRequest): MembershipProductEvaluationResponse
  createMembershipCancellationOptions: CreateMembershipCancellationOptionsResponse!
  calculateMembershipRetentionOptions: CalculateMembershipRetentionOptionsResponse!
  cancelMembership(cancelMembershipRequest: CancelMembershipRequest!): MembershipCancellation!
  cancelUnauthenticatedMembership(cancelUnauthenticatedMembershipRequest: CancelUnauthenticatedMembershipRequest!): CancelUnauthenticatedMembershipResponse!
  acceptMembershipRetentionOffer(membershipRetentionOfferAccepted: AcceptMembershipRetentionOfferRequest): AcceptMembershipRetentionOfferResponse
  addItineraryModification(addItineraryModificationRequest: AddItineraryModificationRequest!): AddItineraryModificationResponse!
  acceptAlternative(acceptAlternativeRequest: AcceptAlternativeRequest!): AcceptAlternativeResponse!
  acceptAgentAlternative(acceptAgentAlternativeRequest: AcceptAgentAlternativeRequest!): AcceptAgentAlternativeResponse!
  changeItinerary(changeItineraryRequest: ChangeItineraryRequest!): ChangeItineraryResponse!
  selectNonEssentialProducts(request: SelectNonEssentialProductsRequest!): SelectNonEssentialProductsResponse! @deprecated(reason: "unused")
  selectNonEssentialInsurancesProducts(request: SelectNonEssentialInsurancesProductsRequest!): NonEssentialProductsResponse!
  selectNonEssentialPostsellProducts(request: SelectNonEssentialPostsellProductsRequest!): NonEssentialProductsResponse!
  itineraryPriceFreeze(request: CreatePriceFreezeRequest!): ID!
  registerRecaptchaV3Token(request: RegisterRecaptchaV3TokenRequest!): RegisterRecaptchaV3TokenResponse!
  resendConfirmationEmail(bookingId: String!, email: String!): ResendConfirmationEmailResponse!
  semItinerarySelection(semItinerarySelectionRequest: SemItinerarySelectionRequest!): SemItinerarySelectionResponse!
  updatePromoCode(request: PromoCodeRequest): PromoCodeResponse!
  addPersonalInfo(request: AddPersonalInfoRequest!): AddPersonalInfoResponse!
  createShoppingBundle(request: CreateShoppingBundleRequest!): CreateShoppingBundleResponse!
  duplicateShoppingBundle(request: DuplicateShoppingBundleRequest!): DuplicateShoppingBundleResponse!
  changePaxNumber(request: ChangePaxNumberRequest!): ShoppingBundle!
  createShoppingCart(request: CreateShoppingCartRequest!): CreateShoppingCartResponse!
  subscribeToFdo(email: String!): SubscriptionFdoResponse!
  subscribeToNewsletter(request: NewsletterSubscriptionRequest!): NewsletterSubscriptionResponse!
  unsubscribe(request: UnsubscriptionRequest!): UnsubscriptionResponse!
  joinTripAroundTheWorldContest: JoinTripAroundTheWorldContestResponse!
  importBookingInTravelPlans(request: TravelPlansImportBookingRequest!): TravelPlansImportBookingResponse! @deprecated(reason: "Use importBookingInTravelPlansV2 instead.")
  importBookingInTravelPlansByTripDetailsToken(request: TravelPlansImportBookingByTripDetailsTokenRequest!): TravelPlansImportBookingResponse! @deprecated(reason: "Use importBookingInTravelPlansByTripDetailsTokenV2 instead.")
  importBookingInTravelPlansV2(request: TravelPlansImportBookingRequest!): TravelPlansImportBookingResponseV2!
  importBookingInTravelPlansByTripDetailsTokenV2(request: TravelPlansImportBookingByTripDetailsTokenRequest!): TravelPlansImportBookingResponseV2!
  importTrip(email: String!, bookingId: Long!): Trip!
  importTripByTripDetailsToken(token: String!): Trip!
  importTripsForLoggedInUser: [Trip!]!
  applyItineraryCancellationPerk(request: ItineraryCancellationApplicationRequest!): ItineraryCancellationApplicationResponse!
  generateTripToken(email: String!, bookingId: Long!): TripToken!
  generateBaToken(email: String!, bookingId: Long!): GenerateBaTokenResponse!
  requestPrimeBookingFreeCancellation(primeBookingFreeCancellationRequest: PrimeBookingFreeCancellationRequest!): PrimeBookingFreeCancellationResponse!
  passwordLogin(request: PasswordLoginRequest!): LoginResponse!
  emailLogin(request: EmailLoginRequest!): LoginResponse!
  facebookLogin(request: FacebookLoginRequest!): LoginResponse!
  googleLogin(request: GoogleLoginRequest!): LoginResponse!
  googleAccessTokenLogin(request: GoogleAccessTokenLoginRequest!): LoginResponse!
  logout: LogoutResponse!
  logoutFromSession(request: LogoutFromSessionRequest!): LogoutResponse!
  logoutFromOtherSessions: LogoutResponse!
  recoverPassword(request: RecoverPasswordRequest!): RecoverPasswordResponse!
  changePassword(request: ChangePasswordRequest!): ChangePasswordResponse!
  sendSetPasswordEmail(request: SendSetPasswordEmailRequest!): SendSetPasswordEmailResponse!
  isLoginVerified(request: IsLoginVerifiedRequest!): LoginResponse! @deprecated(reason: "Use isLoginVerifiedV2 instead")
  isLoginVerifiedV2(request: IsLoginVerifiedRequest!): LoginResponse!
  deleteCreditCard(request: DeleteUserCreditCardRequest!): User
  addCreditCard(request: SaveUserCreditCardRequest!): User
  updateCreditCard(request: SaveUserCreditCardRequest!): User
  loginTokenValidation(request: LoginTokenValidationRequest!): LoginTokenValidationResponse!
  passwordSignup(request: PasswordSignupRequest!): SignupResponse!
  activateUserByToken(request: ActivateTokenUserRequest!): SignupResponse!
  deleteUserPaymentInstrument(request: DeleteUserPaymentInstrumentRequest): DeleteUserPaymentInstrumentResponse
  markUserPaymentInstrumentAsPreferred(request: MarkUserPaymentInstrumentAsPreferredRequest!): MarkUserPaymentInstrumentAsPreferredResponse!
  deleteUserAccount: DeleteUserAccountResponse
  trackJavaScriptSnippetExecutionStarted(userPaymentInteractionId: String!): Boolean!
  trackJavaScriptSnippetExecutionFinalized(userPaymentInteractionId: String!): Boolean! @deprecated(reason: "Use trackJavaScriptSnippetFinalized instead of this to track the error reason")
  trackJavaScriptSnippetFinalized(request: TrackJavaScriptSnippetFinalizedRequest!): TrackJavaScriptSnippetResponse!
  applyAccommodationModification(applyAccommodationModificationRequest: ApplyAccommodationModificationRequest!): AccommodationModificationOption!
  subscribeAccommodationSearchPriceAlertNewsletter(accommodationSearchPriceAlertNewsletterRequest: AccommodationSearchPriceAlertNewsletterRequest!): AccommodationSearchPriceAlertNewsletterResponse!
  deleteAccommodationSearchHistory(deleteRequest: DeleteAccommodationSearchHistoryRequest!): DeleteAccommodationSearchHistoryResponse!
  updateConsent(updateConsentRequest: UpdateConsentRequest!): UpdateConsentResponse!
  createItineraryVoluntaryCancellation(itineraryVoluntaryCancellationRequest: ItineraryVoluntaryCancellationRequest!): ItineraryVoluntaryCancellation!
  applyCancellationOption(applyCancellationOptionRequest: ApplyCancellationOptionRequest!): ItineraryVoluntaryCancellation!
  selectFlashOffer(request: SelectFlashOfferRequest!): SelectFlashOfferResponse!
  rejectFlashOffers: RejectFlashOffersResponse!
  confirmSelectedFlashOffer(request: ConfirmFlashOfferRequest!): FlashOfferConfirmationProcessResponse!
  shoppingBasketCheckout(request: ShoppingBasketCheckoutRequest!): ShoppingBasketCheckoutResponse!
  shoppingBasketResume(request: ShoppingBasketResumeRequest!): ShoppingBasketCheckoutResponse!
  shoppingBasketAddUserPaymentInteractionOutcome(request: ShoppingBasketAddUserPaymentInteractionOutcomeRequest!): ShoppingBasketAddUserPaymentInteractionOutcomeResponse!
  shoppingBasketAddCreditCard(request: ShoppingBasketAddCreditCardRequest!): ShoppingBasketAddCreditCardResponse!
  shoppingBasketAddRedirect(request: ShoppingBasketAddRedirectRequest!): ShoppingBasketAddRedirectResponse!
  shoppingBasketAddUserCollectionTracking(request: ShoppingBasketUserCollectionTrackingRequest!): ShoppingBasketUserCollectionTrackingResponse
  addPaymentInstrumentToRecurringCollection(addPaymentInstrumentToRecurringCollectionRequest: UpdateRecurringCollectionRequest!): RecurringCollectionResponse!
  removePaymentInstrumentFromRecurringCollection(removePaymentInstrumentFromRecurringCollectionRequest: UpdateRecurringCollectionRequest!): RecurringCollectionResponse!
  markPaymentInstrumentAsDefault(markPaymentInstrumentAsDefaultRequest: UpdateRecurringCollectionRequest!): RecurringCollectionResponse!
  createRecurringPaymentInstrumentVerifierShoppingBasketForCrmToken(request: RecurringPaymentInstrumentVerifierShoppingBasketCreationRequest!): RecurringPaymentInstrumentVerifierShoppingBasketCreationResponse!
  createRecurringPaymentInstrumentVerifierShoppingBasketForLoggedInUser: RecurringPaymentInstrumentVerifierShoppingBasketCreationResponse!
  recurringPaymentInstrumentVerifierProductEvaluation(request: RecurringPaymentInstrumentVerifierProductEvaluationRequest!): RecurringPaymentInstrumentVerifierProductEvaluationResponse!
  selectAccommodationInsurance(request: SelectAccommodationInsuranceRequest!): SelectAccommodationInsuranceResponse!
  unselectAccommodationInsurance(request: UnselectAccommodationInsuranceRequest!): UnselectAccommodationInsuranceResponse!
  createMembershipStandaloneShoppingBasket(request: MembershipStandaloneShoppingBasketCreationRequest): MembershipStandaloneShoppingBasketCreationResponse
  membershipStandalonePostBooking(request: MembershipStandalonePostBookingRequest!): MembershipStandalonePostBookingResponse!
  selectUnchainedMembershipPostBooking(request: SelectUnchainedMembershipPostBookingRequest!): SelectUnchainedMembershipPostBookingResponse!
  selectUnchainedMembershipPostBookingV2(request: UnchainedMembershipOfferTokenInput!): SelectUnchainedMembershipPostBookingResponse!
  selectPostBookingSubscriptionOffer(postBookingSubscriptionToken: SelectPostBookingSubscriptionOfferRequest!): SelectPostBookingSubscriptionOfferResponse!
  createReferralSubscription(request: CreateReferralSubscriptionRequest!): CreateReferralSubscriptionResponse!
  confirmReferralSubscription(request: ConfirmReferralSubscriptionRequest!): ConfirmReferralSubscriptionResponse!
  initDecouplingPrimeSubscriptionFlow(request: InitDecouplingPrimeSubscriptionFlowRequest!): InitDecouplingPrimeSubscriptionFlowResponse!
  confirmDecouplingPrimeSubscriptionFlow(request: ConfirmDecouplingPrimeSubscriptionFlowRequest!): ConfirmDecouplingPrimeSubscriptionFlowResponse!
  primeSubscriptionPostPurchase(request: PrimeSubscriptionPostPurchaseRequest!): PrimeSubscriptionPostPurchaseResponse!
  createShoppingBasket(request: CreateShoppingBasketRequest): ShoppingBasketResponse!
  removeProductFromShoppingBasket(request: RemoveProductFromShoppingBasketRequest): Boolean!
  addProductToShoppingBasket(request: AddProductToShoppingBasketRequest): Boolean!
  updateProductsInShoppingBasket(request: UpdateProductsInShoppingBasketRequest): UpdateProductsInShoppingBasketResponse!
  addContactDetailsToShoppingBasket(request: AddContactDetailsToShoppingBasketRequest): Boolean!
  resumeShoppingBasket(request: ResumeShoppingBasketRequest): CheckoutResponse!
  cancelShoppingBasketCheckout(request: CancelShoppingBasketCheckoutRequest!): CheckoutResponse!
  addBookingBuyerToShoppingBasket(request: AddBookingBuyerToShoppingBasketRequest!): Boolean!
  addPromoCodeToShoppingBasket(request: AddShoppingBasketPromoCodeRequest!): AddShoppingBasketPromoCodeResponse!
  removePromoCodeFromShoppingBasket(request: RemoveShoppingBasketPromoCodeRequest!): RemoveShoppingBasketPromoCodeResponse!
  createUniversalShoppingBasket: UniversalShoppingBasketResponse!
  addProductToUniversalShoppingBasket(request: AddProductToUniversalShoppingBasketRequest!): UniversalShoppingBasketProductResponse!
  removeProductFromUniversalShoppingBasket(request: RemoveProductFromUniversalShoppingBasketRequest!): UniversalShoppingBasketProductResponse!
  addPromoCodeToUniversalShoppingBasket(request: AddUniversalShoppingBasketPromoCodeRequest!): UniversalShoppingBasketPromoCodeResponse!
  removePromoCodeFromUniversalShoppingBasket(request: RemoveUniversalShoppingBasketPromoCodeRequest!): UniversalShoppingBasketPromoCodeResponse!
  addContactDetailsToUniversalShoppingBasket(request: AddContactDetailsToUniversalShoppingBasketRequest!): UniversalContactDetailsResponse!
}

enum BoardType {
  RO
  HB
  AI
  BB
  FB
  SC
  UN
}

enum AccommodationSearchType {
  DYNPACK
  STANDALONE
  UPSELL
  POST_BOOKING
}

enum AccommodationType {
  APARTAMENT
  BED_AND_BREAKFAST
  GUEST_HOUSE
  HOSTEL
  HOTEL
  MOTEL
  RESIDENCE
  RESORT
  RYOKAN
  UNKNOWN
}

enum AccommodationImageType {
  AREA_INFORMATION
  ENTERTAINMENT
  FOOD
  GENERAL
  HOTEL
  POOL
  ROOM
  BALCONY
  BATHROOM
  DINING
  EXTERIOR
  GYM
  INTERIOR
  LIVING_AREA
  NEARBY
  PARKING
  ROOFTOP
  SPA_SAUNA
  WORKSPACE
  UKNOWN
}

enum AccommodationImageQuality {
  LOW
  MEDIUM
  HIGH
  UNKNOWN
}

enum AccommodationCategory {
  UNKNOWN
  STARS_0
  STARS_0_5
  STARS_1
  STARS_1_5
  STARS_2
  STARS_2_5
  STARS_3
  STARS_3_5
  STARS_4
  STARS_4_5
  STARS_5
  STARS_6
  STARS_7
}

enum RoomSmokingPreference {
  UNKNOWN
  INDIFFERENT
  NON_SMOKING
  SMOKING
}

enum ThreeValuedLogic {
  FALSE
  UNKNOWN
  TRUE
}

enum RefundType {
  FREE_REFUNDABLE
  PARTIALLY_REFUNDABLE
  NON_REFUNDABLE
  UNKNOWN
}

enum CancellationPenaltyType {
  NIGHT
  PERCENTAGE
  AMOUNT
}

enum StarRating {
  H0
  H0_5
  H1
  H1_5
  H2
  H2_5
  H3
  H3_5
  H4
  H4_5
  H5
  H5_5
  H7
}

enum CustomerPriceType {
  NO_PRIME
  PRIME
}

enum OfferType {
  REGULAR_TYPE
  STANDARD_PRIME
  PREMIUM_PRIME
}

enum AccommodationPolicyType {
  ADDITIONAL_INFORMATION
  CHECK_IN_INSTRUCTIONS
  FEES
}

enum AccommodationSortCriteria {
  HIGHER_SCORE
  HIGHER_DISCOUNT
}

enum PrimeDiscountType {
  HIDDEN
  NO_DISCOUNT
  VISIBLE
  SECRET
}

enum GoogleApiKey {
  HSA
  DYNPACK
  INTERMEDIATE
  DEVELOPMENT
}

enum CampaignType {
  UNKNOWN
  PRIME_DAYS
  HOTEL_SUPER_SALES
  SUMMER_SALES
  BLACK_FRIDAY
  TRAVEL_TUESDAY
  FLASH_SALE
  HOTEL_SAVINGS_FEST
  OC_ALWAYS_ON_PROMOTION
}

type AccommodationShoppingItem {
  accommodationDealInformation: AccommodationDealInformation
  roomGroupDeal: RoomGroupDeal
  roomDealLegend: [RoomDeal]
  id: Long
  price: Float @bigdecimal
}

type RoomGroupDeal {
  key: String
  roomsKeys: [String!]
  searchId: Long
}

type RoomDeal {
  key: String
  providerId: String
}

type SearchRoomAvailabilityResponse {
  searchId: Long!
  currency: String
  rooms: [Room]
  roomGroups: [RoomGroup!]
}

type RoomGroup {
  roomIds: [String!]!
}

type Room {
  key: String!
  roomGroupKey: String
  roomId: String!
  roomDetails: [RoomLegend!]!
  combinations: [RoomCombination]
  payInAdvance: Boolean
  priceBreakdown: PriceBreakdown
  cancellationFree: Boolean
  refundType: RefundType
  cancellationPolicy: String
  cancelPenalties: [CancelPenalty]!
  providerId: String
  debugInfo: String
  roomOffer: RoomOffer!
  hasMerchandisePrice: Boolean
}

type RoomCombination {
  index: Int
  counter: Int
}

type RoomLegend {
  type: String
  boardType: BoardType
  bedsDescription: String
  roomsLeft: Int
  mainImage: Image
  images: [Image]
  name: String
  description: String
  roomKey: String
  amenities: [RoomAmenity]
}

type RoomAmenity {
  category: String
  description: String
}

type CancelPenalty {
  startDate: String
  endDate: String
  type: CancellationPenaltyType
  value: Int
  nights: Int @deprecated(reason: "it will simplified and migrate to value")
  percentage: Int @deprecated(reason: "it will simplified and migrate to value")
}

type Image {
  url: String
  thumbnailUrl: String
}

type AccommodationSearchResponse {
  searchId: Long!
  accommodations: [Accommodation!]!
  currency: String!
  metadata: AccommodationSearchMetadata!
  providerIds: [String!]!
  accommodationResponse: AccommodationResponse! @deprecated
  numResults: Int!
}

type AccommodationResponse {
  accommodations: [Accommodation!]!
  currency: String
  metadata: AccommodationSearchMetadata
  providerIds: [String]
}

type Accommodation {
  key: String
  dedupId: Int!
  contentKey: String
  score: Float! @bigdecimal @deprecated
  priceBreakdown: PriceBreakdown
  accommodationFacilities: [String]
  accommodationDeal: AccommodationDealInformation!
  userReview: UserReview
  distanceFromCityCenter: Float
  roomsLeft: Int
  boardType: BoardType
  providerId: String
  debugInfo: String
  defaultSortingPosition: Int @deprecated
  insideDestination: Boolean
  favorite: Boolean!
  sortingLogic: AccommodationSortingLogic!
  roomOffer: RoomOffer!
  secretHotelId: String
  cancellationFreeAlternativeAvailable: Boolean!
}

type RetailStrategy {
  showAbsoluteDiscount: Boolean!
  showPercentageDiscount: Boolean!
  highlightedFlashSale: Boolean!
  showPrimeExclusive: Boolean!
  offerType: OfferType!
  hiddenDummyPrice: Money @deprecated
  primeDiscountType: PrimeDiscountType!
  isSavingFest: Boolean!
  isPromoCodeApplicable: Boolean!
  isHighlightedOC: Boolean
}

type RoomOffer {
  hasDiscount: Boolean!
  retailStrategy: RetailStrategy!
}

type UserReview {
  rating: Float
  totalReviews: Int
}

type AccommodationStaticContentResponse {
  accommodationsStaticContent: [AccommodationStaticContent] @deprecated(reason: "The query accommodationStaticContent is no longer used")
}

type AccommodationStaticContent {
  contentKey: String
  accommodationDeal: AccommodationDealInformation
}

type AccommodationSearchMetadata {
  priceMetadata: AccommodationPriceMetadata
  filtersMetadata: [AccommodationFilterMetadata]
}

type AccommodationPriceMetadata {
  maxPrice: Float @bigdecimal
  minPrice: Float @bigdecimal
  avgPrice: Float @bigdecimal
  maxDiscountPercentage: Float @bigdecimal
  pricePerNightRange: Float @bigdecimal
  histogramRange: Float @bigdecimal
  maxPricePerNight: Float @bigdecimal
  minPricePerNight: Float @bigdecimal
  avgPricePerNight: Float @bigdecimal
  maxSavingAmount: Float @bigdecimal
}

type AccommodationFilterMetadata {
  filterType: String
  filterName: String
  count: Int
}

type AccommodationDetail {
  accommodationDealInformation: AccommodationDealInformation
  stateProvince: String
  country: String
  postalCode: String
  mapUrls: [String]
  locationDescription: String
  surroundingAreaInfo: String
  checkInPolicy: String
  checkOutPolicy: String
  hotelPolicy: String
  policies: [AccommodationPolicy]
  creditCardTypes: [String]
  paymentMethod: String
  phoneNumber: String
  mail: String
  web: String
  fax: String
  images: [AccommodationImages]
  facilityGroups: [FacilityGroups]
  accommodationRoomServices: [AccommodationRoomService]
  numberOfRooms: String
  hotelType: AccommodationType
  distanceFromCityCenter: Float
  accommodationReview: AccommodationReview
  favorite: Boolean!
  accommodationFacilities: [String!]!
}

type AccommodationDealInformation {
  name: String!
  address: String
  cityName: String
  neighbourhood: String
  description: String
  location: String
  chain: String
  type: AccommodationType!
  mainAccommodationImage: AccommodationImage
  cancellationPolicyDescription: String
  coordinates: GeoCoordinates!
  category: AccommodationCategory!
  cancellationFree: ThreeValuedLogic!
  paymentAtDestination: Boolean!
  hasMerchandisePrice: Boolean!
  stars: Int
}

type AccommodationPolicy {
  type: AccommodationPolicyType!
  content: [String!]!
}

type AccommodationImage {
  url: String
  thumbnailUrl: String
  type: AccommodationImageType
  quality: AccommodationImageQuality
}

type AccommodationDetailResponse {
  accommodationDetail: AccommodationDetail
}

type AccommodationFacilityGroup {
  code: String
  description: String
}

type AccommodationRoomService {
  description: String
  type: String
}

type RoomsDetailResponse {
  roomsDetails: [StaticRoomDetails]
}

type StaticRoomDetails {
  roomId: String!
  providerRoomId: String!
  mainRoomImage: StaticRoomImage
  roomImages: [StaticRoomImage]
  roomName: String
  roomDescription: String
}

type StaticRoomImage {
  url: String
  thumbnailUrl: String
}

type AccommodationSummaryResponse {
  accommodationDetail: AccommodationDetail
  roomDeals: [RoomDealSummary]
  accommodationReview: AccommodationReview
  cancelPenalties: [CancelPenalty!]!
  checkInDate: String
  checkOutDate: String
  roomRequests: [RoomSearchCriteria!]!
}

type RoomDealSummary {
  roomId: String
  roomKey: String
  description: String
  bedsDescription: String
  cancelPolicy: String
  smokingPreference: RoomSmokingPreference
  providerId: String
  isCancellationFree: Boolean
  depositRequired: Boolean
  boardType: BoardType
  paymentAtDestination: Boolean
  roomsLeft: Int
}

type AccommodationReview {
  dedupId: Int
  rating: Float
  totalReviews: Int
  providerCode: String
  providerReviewId: String
}

input SearchRoomAvailabilityRequest {
  searchId: Long!
  accommodationDealKey: Long!
  dedupId: Int
  buyPath: Int
}

input AccommodationSearchRequest {
  checkInDate: String!
  checkOutDate: String!
  destination: LocationRequest!
  roomRequests: [RoomRequest!]!
  mainProduct: MainProduct
  upsell: Boolean
  searchType: AccommodationSearchType!
  membershipFee: Boolean
  buyPath: Int
  maxResults: Int
  sortCriteria: AccommodationSortCriteria! = HIGHER_SCORE
  geoAccommodation: GeoAccommodationRequest
  polygon: GeoAccommodationPolygonRequest
  onlyRecommended: Boolean
  dealsRecommendedId: String
  searchId: Long
}

input GeoAccommodationRequest {
  geoId: String!
  geoType: GeoType!
}

input GeoAccommodationPolygonRequest {
  points: [GeoCoordinatesRequest!]!
  associatedGeoId: String
  geoType: GeoType
}

input AccommodationPostBookingSearchRequest {
  checkInDate: String!
  checkOutDate: String!
  destination: LocationRequest!
  roomRequests: [RoomRequest!]!
  membershipFee: Boolean
  buyPath: Int
  maxResults: Int
  bookingAuth: BookingAuth!
  geoAccommodation: GeoAccommodationRequest
  onlyRecommended: Boolean
}

input AccommodationSearchByDedupIdRequest {
  checkInDate: String!
  checkOutDate: String!
  destination: LocationRequest!
  roomRequests: [RoomRequest!]!
  mainProduct: MainProduct
  upsell: Boolean
  searchType: AccommodationSearchType
  bookingAuth: BookingAuth
  membershipFee: Boolean
  buyPath: Int
  dedupIds: [Int!]!
  geoAccommodation: GeoAccommodationRequest
}

input AccommodationStaticContentRequest {
  contentKeys: [String!]!
}

input AccommodationDetailsRequest {
  searchId: Long
  contentKey: String!
  dedupId: Int
  customerSearchGeoAccommodation: GeoAccommodationRequest
}

input RoomRequest {
  numAdults: Int!
  childrenAges: [Int]
}

input MainProduct {
  itinerarySelection: ItinerarySelection!
  searchId: Long!
}

input BookingAuth {
  bookingId: Long!
  buyerEmail: String!
}

input AccommodationSummaryRequest {
  bookingId: Long
  shoppingType: ShoppingType
  shoppingId: ID
}

input AccommodationDetailRequest {
  searchId: Long!
  accommodationDealKey: String!
}

input RoomsDetailRequest {
  supplierCode: String!
  supplierHotelId: String!
  roomIds: [String!]!
  locale: String!
}

type AccommodationDetailsResponse {
  accommodationDetail: AccommodationDetail
}

type FacilityGroups {
  code: String!
  description: String
  facilities: [AccommodationFacilityGroup]
}

type Discount {
  percentage: Float! @bigdecimal
  packageAmount: Float! @bigdecimal
  packageAmountRounded: Int!
  primeAmount: Float! @bigdecimal
  primeAmountRounded: Int!
}

type PriceBreakdown {
  price: Float! @bigdecimal
  priceRounded: Int!
  pricePerNight: Float! @bigdecimal
  pricePerNightRounded: Int!
  pricePerNightWithoutDiscount: Float! @bigdecimal
  pricePerNightWithoutDiscountRounded: Int!
  priceWithoutDiscount: Float! @bigdecimal
  priceWithoutDiscountRounded: Int!
  discount: Discount!
}

input SelectionRoomRequest {
  searchId: String!
  accommodationDealKey: String!
  roomDealKey: String!
}

input SelectAccommodationOfferRequest {
  searchId: String!
  accommodationDealKey: String!
  roomDealKey: String!
  selectedCustomerPriceType: CustomerPriceType!
}

input RebuildAccommodationOfferRequest {
  selectedCustomerPriceType: CustomerPriceType!
  checkInDate: String!
  checkOutDate: String!
  destination: LocationRequest!
  roomRequests: [RoomRequest!]!
  mainProduct: MainProduct
  upsell: Boolean
  buyPath: Int
  searchType: AccommodationSearchType!
  dedupId: Int!
  contentKey: String!
  roomGroupKey: String!
  userId: Long
}

input RoomRate {
  boardType: BoardType!
  freeCancellation: Boolean!
}

type SelectAccommodationOfferResponse {
  shoppingId: ID!
}

type RebuildAccommodationOfferResponse {
  searchId: Long
  responseType: RebuildAccommodationOfferResponseType!
  shoppingId: ID
}

enum RebuildAccommodationOfferResponseType {
  NO_ACCOMMODATION_AVAILABLE
  NO_ROOM_AVAILABLE
  NO_ROOM_RATE_AVAILABLE
  SUCCESS
}

input CreateAccommodationProductRequest {
  dealId: ID
  shoppingId: ID
  shoppingType: ShoppingType
  guests: [Guest!]!
  buyer: AccommodationBuyer!
  updateUserProfile: Boolean
}

type CreateAccommodationProductResponse {
  id: ProductId
  shoppingId: ID
  accommodationProduct: AccommodationProduct
}

type AccommodationProduct {
  id: ProductId
  name: String
  address: String
  cityName: String
  description: String
  checkIn: String
  checkOut: String
  images: [AccommodationImages]
  rooms: [AccommodationRoomProduct]
  productId: String
}

type AccommodationRoomProduct {
  description: String
  cancellationPolicy: String
}

type AccommodationImages {
  quality: AccommodationImageQuality
  sources: [AccommodationImage]
}

input Guest {
  travellerTypeName: String
  titleName: String
  name: String
  firstLastName: String
  secondLastName: String
  middleName: String
  gender: String
  dayOfBirth: Int
  monthOfBirth: Int
  yearOfBirth: Int
  nationalityCountryCode: String
  countryCodeOfResidence: String
  identification: String
  identificationTypeName: String
  identificationExpirationDay: Int
  identificationExpirationMonth: Int
  identificationExpirationYear: Int
  identificationIssueCountryCode: String
  localityCodeOfResidence: String
  mealName: String
}

input AccommodationBuyer {
  name: String
  lastNames: String
  mail: String
  identification: String
  buyerIdentificationTypeName: String
  address: String
  cityName: String
  stateName: String
  zipCode: String
  phoneNumber: String
  countryPhoneNumber: String
  typePhoneNumber: String
  countryCode: String
  cpf: String
  dayOfBirth: Int
  monthOfBirth: Int
  yearOfBirth: Int
  neighborhood: String
}

input AccommodationStaticMapRequest {
  contentKey: String!
  staticMapConfiguration: MapStaticConfiguration!
  apiKey: GoogleApiKey
}

type AccommodationPriceBreakDownItem implements PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  totalPriceOfferedInSearch: Money!
  pricePerNight: Money
  pricePerNightOfferedInSearch: Money
  nonDiscountedPricePerNight: Money
  nonDiscountedPricePerNightOfferedInSearch: Money
  nonDiscountedPrice: Money
  nonDiscountedPriceOfferedInSearch: Money
  discountedPrice: Money
  discountedPriceOfferedInSearch: Money
  type: PriceBreakDownItemType!
  quantity: Int!
  discountInfo: [DiscountInfo!]
  discountInfoOfferedInSearch: [DiscountInfo!]!
  tax: Money
  taxOfferedInSearch: Money
  payAtPropertyTax: PayAtDestinationTaxes
  providerId: String
  selectedCustomerPriceType: CustomerPriceType
}

type PackagePriceBreakDownItem implements PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
  providerFare: Money
  serviceFeeTaxes: Money
  taxes: Money
}

type AccommodationPriceSummary implements PriceSummary {
  amount: Money! @deprecated
  totalPrice: Money!
  totalPriceOfferedInSearch: Money!
  nonDiscountedPrice: Money
  nonDiscountedPriceOfferedInSearch: Money
  discountedPrice: Money
  discountedPriceOfferedInSearch: Money
  pricePerception: PricePerceptionConfig!
  discountInfo: [DiscountInfo!] @deprecated(reason: "This information will come in the corresponding items")
  nonDiscountedAmount: Money
  nonDiscountedAmountOfferedInSearch: Money
  discountedAmount: Money
  discountedAmountOfferedInSearch: Money
  totalDiscountPercentage: Int
  taxesAmount: Money
  taxesAmountOfferedInSearch: Money
  nonTaxesAmount: Money
  nonTaxesAmountOfferedInSearch: Money
  payAtPropertyTax: PayAtDestinationTaxes
  showAdditionalCharges: Boolean
  providerId: String
}

type PackagePriceSummary implements PriceSummary {
  amount: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  pricePerception: PricePerceptionConfig!
  pricePerPassenger: Money!
  nonDiscountedPricePerPassenger: Money
  nonDiscountedPricePrime: Money
}

type AccommodationInfoProduct implements Product {
  id: ProductId
  price: Money
  possibleDuplicatedBookingDetected: Boolean!
  productInfo: AccommodationSummaryResponse
}

type AccommodationCancellationOption {
  cancellationOptionId: ID!
  cancellationBasketId: ID
  refundAmount: Float! @bigdecimal
  refundCurrency: String!
}

type AccommodationCancellation {
  cancellationId: ID
  cancellationOptionId: ID
  cancellationBasketId: ID
}

input AccommodationSearchBySearchIdRequest {
  searchId: Long!
  maxResults: Int
  sortCriteria: AccommodationSortCriteria! = HIGHER_SCORE
}

type AccommodationSuggestionResponse {
  searchId: Long!
  accommodations: [Accommodation!]!
}

input AccommodationSuggestionRequest {
  accommodationSearchId: Long!
  selectedAccommodationContentKey: String!
}

type RecogniseUserForAccommodationResponse {
  recognised: Boolean!
  accommodationRecognisedUser: AccommodationRecognisedUser
}

type AccommodationRecognisedUser {
  name: String!
  email: String!
  prime: Boolean!
}

type AccommodationSortingLogic {
  defaultPosition: Int!
  personalisationApplied: Boolean!
}

input AccommodationSearchAsyncRequest {
  checkInDate: String!
  checkOutDate: String!
  roomRequests: [RoomRequest!]!
  mainProduct: MainProduct
  upsell: Boolean
  searchType: AccommodationSearchType!
  membershipFee: Boolean
  buyPath: Int
  maxResults: Int
  geoAccommodation: GeoAccommodationRequest!
}

type AccommodationSearchAsyncResponse {
  searchId: Long!
}

input AccommodationImagesRequest {
  contentKey: String!
}

type AccommodationImagesResponse {
  accommodationImages: [AccommodationImage!]!
}

type ActiveCampaignResponse {
  campaign: MarketingCampaign
}

type MarketingCampaign {
  type: CampaignType!
  """europe/madrid time zone"""
  endDate: String! @yyyyMMddTHHmmssZZZZZ
  """
  Due to business requirements, the campaign end date is not always aligned with the countdown that appears on the frontend.
  This field makes it possible to populate both concepts separately.
  do not include time zone
  """
  countdownEndDate: String!
  showBanner: Boolean!
  """
  Even though countdownEndDate is mandatory, there are business scenarios where showCountdown may be false and the countdown will not be displayed, despite countdownEndDate being present.
  """
  showCountdown: Boolean!
}

enum AncillaryProductType {
  SEAT
  BAG
  CABIN_BAG
}

enum AncillaryFlowType {
  ONLINE
  POST_BOOKING
}

enum CabinBagType {
  SMALL_BAG
  CABIN_BAG
  CABIN_BAG_AND_PRIORITY
}

enum AncillaryPriceType {
  NON_PRIME
  PRIME
}

enum AncillaryProductStatus {
  CONTRACT
  DIDNOTBUY
  INIT
  PENDING
  REQUEST
}

enum PriceUnit {
  PER_KG
}

enum CheckedBagOfferTag {
  BEST_DEAL_PER_KG
  MORE_FOR_LESS
}

type AncillaryResponse {
  seats: [SeatMapSegment]!
  seatsOfferable: Boolean!
  cabinBags: [CabinBag]!
  baggage: [BaggageConditions]!
  baggageOfferable: Boolean!
  sitTogetherOffers: [SitTogetherOffer!]!
  oneClickBagDeals: OneClickBagDeals!
}

type SelectedAncillariesResponse {
  code: String
  success: Boolean!
  products: [SelectedAncillaryProduct!]
  message: String
}

type SelectedAncillaryProduct {
  type: AncillaryProductType!
  id: ID!
}

input MoneyRequest {
  amount: Float!
  currency: String!
}

input SelectAncillariesRequest {
  bookingID: ID
  flow: AncillaryFlowType!
  shoppingBasketID: ID
  selection: AncillariesSelectionRequest!
}

input AncillariesSelectionRequest {
  seats: [PassengerSeatsSelectionRequest!]
  cabinBags: [CabinBagsRequest!]
  baggage: [BaggageRequest!]
}

type AncillariesProduct implements Product {
  id: ProductId
  price: Money
  productInfo: AncillariesProductInfo
}

type AncillariesProductInfo {
  cabinBagsSelections: [CabinBagsSelection!]!
  seatsSelections: [SeatsSelection!]!
  bagsSelections: [BaggageSelection!]!
}

type AncillaryPriceItem {
  type: AncillaryPriceType
  price: AncillaryPrice
}

type AncillaryPrice {
  amount: Money!
  breakdown: AncillaryPriceBreakdown
}

type PricePerUnit {
  price: Money!
  unit: PriceUnit!
  membershipType: AncillaryPriceType!
}

type AncillaryPriceBreakdown {
  items: [AncillaryPriceBreakdownItem!]!
}

type AncillaryPriceBreakdownItem {
  concept: String!
  price: AncillaryPrice!
}

type AncillarySelectionResponse {
  totalPrice: AncillaryPriceItem!
  products: [AncillariesProduct]!
  productSelectionType: AncillaryProductType!
  productSelectionStatus: AncillaryProductStatus!
}

type OneClickBagDeals {
  checkedBagDeals: OneClickCheckedBagDeals!
}

enum AncillaryBundlePriceType {
  NON_PRIME
  PRIME
}

enum AncillaryBundleStatus {
  INITIALIZED
  CONTRACTED
  CANCELLED
  ABORTED
}

enum AncillaryBundleItemType {
  INSURANCE
  FLIGHT_UPDATE_SMS
}

enum AncillaryBundleRelatedProductType {
  ITINERARY
}

enum AncillaryBundleRelatedProductIdType {
  LEGACY
}

input PostBookingAncillaryBundleOfferRequest {
  token: String!
  bundleTypes: [String!]!
}

input AncillaryBundleSelectionRequest {
  offerId: ID!
  shoppingBasketId: ID!
  customerPriceType: AncillaryBundlePriceType!
}

input AncillaryBundleProductRequest {
  productId: ID!
}

type PostBookingAncillaryBundleOffersResponse {
  offers: [AncillaryBundleOffer!]!
}

input AncillaryBundlesByRelatedTripProductRequest {
  token: String!
  relatedProductType: AncillaryBundleRelatedProductType!
  relatedProductIdType: AncillaryBundleRelatedProductIdType!
}

type AncillaryBundlesByRelatedTripProductResponse {
  products: [AncillaryBundleProduct!]!
}

type AncillaryBundleItemDescriptor {
  type: AncillaryBundleItemType!
  benefits: [AncillaryBundleItemBenefit!]!
}

type AncillaryBundlePriceBreakdownItem {
  concept: String!
  price: Price!
}

type AncillaryBundlePriceBreakdown {
  items: [AncillaryBundlePriceBreakdownItem!]!
}

type AncillaryBundlePrice {
  type: AncillaryBundlePriceType!
  price: Price!
  breakdown: AncillaryBundlePriceBreakdown
}

type AncillaryBundleTermsAndConditions {
  url: String!
}

type AncillaryBundleOffer {
  id: ID!
  type: String!
  bundleItems: [AncillaryBundleItemDescriptor!]!
  prices: [AncillaryBundlePrice!]!
  termsAndConditions: [AncillaryBundleTermsAndConditions!]!
}

type AncillaryBundleItem {
  id: ID!
  descriptor: AncillaryBundleItemDescriptor!
}

type AncillaryBundleItemBenefit {
  reference: String!
}

type AncillaryBundleProduct {
  id: ID!
  type: String!
  items: [AncillaryBundleItem!]!
  price: AncillaryBundlePrice!
  termsAndConditions: [AncillaryBundleTermsAndConditions!]!
  status: AncillaryBundleStatus!
}

input BankTransferRequest {
  bookingId: Long!
  email: String!
  bankAccount: BankAccount!
}

input BankAccount {
  country: String!
  iban: String
  holder: BankAccountHolder
  number: String
  transitNumber: String
  interbankCLABE: String
  bank: Bank
}

input Bank {
  name: String
  address: String
  bic: String
  sortCode: String
  ifsc: String
  bsb: String
  institutionNumber: String
}

input BankAccountHolder {
  name: String
  address: String
  birthdate: String
  clientNumber: String
}

type BankTransferResponse {
  successful: Boolean!
}

enum BuyerIdentificationType {
  NATIONAL_ID_CARD
  NIE
  CIF
  PASSPORT
  NIF
  BIRTH_DATE
}

type BuyerInformationDescription {
  identificationTypes: [BuyerIdentificationType!]
  needsName: RequiredFieldType!
  needsLastNames: RequiredFieldType!
  needsMail: RequiredFieldType!
  needsIdentification: RequiredFieldType!
  needsDateOfBirth: RequiredFieldType!
  needsCpf: RequiredFieldType!
  needsAddress: RequiredFieldType!
  needsCityName: RequiredFieldType!
  needsNeighborhood: RequiredFieldType!
  needsStateName: RequiredFieldType!
  needsZipCode: RequiredFieldType!
  needsPhoneNumber: RequiredFieldType!
  needsAlternativePhoneNumber: RequiredFieldType!
  needsCountryCode: RequiredFieldType!
}

type Buyer {
  phoneNumber: Phone
  alternativePhoneNumber: Phone
  name: String!
  lastNames: String
  mail: String!
  buyerIdentificationType: BuyerIdentificationType
  identification: String
  dateOfBirth: String @dateISO8601
  cpf: String
  address: String!
  cityName: String
  neighborhood: String
  stateName: String
  zipCode: String
  country: String
  idUser: ID
  userRegistered: Boolean
}

input BuyerInput {
  phoneNumber: PhoneInput
  alternativePhoneNumber: PhoneInput
  name: String! @paxName
  lastNames: String @paxName
  mail: String! @email
  buyerIdentificationType: BuyerIdentificationType
  identification: String
  dateOfBirth: String
  cpf: String
  address: String! @address
  cityName: String @city
  neighborhood: String
  stateName: String
  zipCode: String @zipCode
  country: String
  idUser: ID
  userRegistered: Boolean
  storedTravellerId: Long
}

type Phone {
  countryCode: String
  number: String
  type: String
}

input PhoneInput {
  countryCode: String
  number: String @phoneNumber
  type: String
}

type CampaignConfig {
  primeDayConfig: PrimeDayConfig
  airlineCampaignConfig: AirlineCampaignConfig @deprecated(reason: "Not used, will be removed in next iterations")
}

type AirlineCampaignConfig {
  hasAirlineCampaign: Boolean! @deprecated(reason: "Not used, will be removed in next iterations")
}

type PrimeDayConfig {
  isPrimeDayFare: Boolean!
  primeDayFareType: PrimeDayFareType
}

input CarrierCustomerCredentialsRequest {
  tripDetailsToken: String!
  bookingItemId: Long!
}

type CarrierCustomerCredentialsResponse {
  carrierCustomerCredentials: CarrierCustomerCredentials
}

type CarrierCustomerCredentials {
  email: String!
  password: String!
}

type CarriersCustomerCredentialsResponse {
  carriersCustomerCredentials: CarriersCustomerCredentials!
}

type CarriersCustomerCredentials {
  credentials: [CustomerCredentials!]!
}

type CustomerCredentials {
  providerBookingItemId: Long!
  email: String!
  password: String
}

input CarrierDocumentsRequest {
  tripDetailsToken: String!
  bookingItemId: Long!
}

type CarrierDocumentsResponse {
  carrierDocuments: [CarrierDocument]
}

type CarrierDocument {
  documentURL: String!
  itineraryBookingId: Long!
}

enum ConversationStatus {
  MANAGED_BY_BOT
  HANDOVER_REQUESTED
  MANAGED_BY_AGENT
  HANDOVER_FINISHED
}

enum ChatbotResponseMessageType {
  TEXT
  QUICK_REPLIES
  SURVEY
  CARD_LIST
  HANDOVER
  EDITTRAVELLERMODAL
}

enum ChatbotChannel {
  APP
  TEST_APP
  WEB
  TEST_WEB
}

enum ChatbotCardType {
  CHECKIN_SUMMARY
  SEATS_AND_BAGS
  REFUND
  CHANGE_NAME
}

enum ChatbotTripType {
  ROUND_TRIP
  ONE_WAY
  MULTI_DESTINATION
}

enum ChatbotSeatType {
  SEAT
}

enum ChatbotCabinBagType {
  CABIN_BAG
  SMALL_BAG
}

enum ChatbotTravellerTitle {
  MR
  MRS
  MS
}

enum ChatbotTravellerType {
  ADULT
  CHILD
  INFANT
}

enum ChatbotResponseMessageCategory {
  ALERT
}

enum ChatbotFeedback {
  THUMBS_UP
  THUMBS_DOWN
  UNKNOWN
}

input JoinChatbotBookingSessionRequest {
  bookingId: Long!
  email: String!
  channel: ChatbotChannel!
}

type ChatbotSession {
  sessionId: ChatbotSessionId!
  conversationStatus: ConversationStatus!
}

type ChatbotSessionId {
  id: String!
}

input ChatbotEvent {
  name: String!
  timezone: String!
  sessionId: String!
  channel: ChatbotChannel!
  context: ChatbotContext!
  message: String
}

input ChatbotPageEvent {
  name: String!
  timezone: String!
  sessionId: String!
  channel: ChatbotChannel!
  context: ChatbotContext!
}

input ChatbotText {
  text: String!
  timezone: String!
  sessionId: String!
  channel: ChatbotChannel!
  context: ChatbotContext!
}

input ChatbotContext {
  bookingId: Long
  email: String
  isPrimeUser: Boolean
  customParams: [ChatbotCustomParams!]
}

type ChatbotInteractionResponse {
  messages: [ChatbotResponseMessage!]!
}

type ChatbotResponseMessage {
  type: ChatbotResponseMessageType!
  disableTextArea: Boolean!
  category: ChatbotResponseMessageCategory
  textMessage: ChatbotTextMessage
  quickRepliesMessage: ChatbotQuickRepliesMessage
  surveyMessage: ChatbotSurveyMessage
  cardListMessage: ChatbotCardListMessage
  editTravellerModalMessage: ChatbotEditTravellerModalMessage
}

type ChatbotTextMessage {
  text: String!
  llm: Boolean
  messageId: String
}

type ChatbotQuickRepliesMessage {
  options: [ChatbotQuickReplyOption!]!
}

type ChatbotSurveyMessage {
  options: [ChatbotSurveyOption!]!
}

type ChatbotQuickReplyOption {
  title: String!
  payload: String!
  response: String!
}

type ChatbotSurveyOption {
  title: String!
  payload: String!
  response: String!
}

type ChatbotCardListMessage {
  cards: [ChatbotCard!]!
}

type ChatbotCard {
  type: ChatbotCardType!
  refundCard: ChatbotRefundCard
  checkinSummaryCard: ChatbotCheckinSummaryCard
  passengerSeatsAndBagsCard: ChatbotPassengerSeatsAndBagsCard
  changeNameCard: ChatbotChangeNameCard
}

type ChatbotRefundCard {
  refund: ChatbotRefund
}

type ChatbotRefund {
  date: String! @dateISO8601
  status: String!
  amount: Money!
}

type ChatbotCheckinSummaryCard {
  carrier: String! @deprecated(reason: "we are exposing the same value in carrierName")
  carrierName: String!
  carrierCode: String!
  origin: String!
  destination: String!
  callToActionLink: String!
  pnr: String!
  userEmail: String!
  virtualCredentials: ChatbotVirtualCredentials
  tickets: [ChatbotTicket!]!
}

type ChatbotVirtualCredentials {
  login: String!
  credential: String
}

type ChatbotTicket {
  passengerName: String
  number: String!
}

type ChatbotPassengerSeatsAndBagsCard {
  passengerName: String!
  tripType: ChatbotTripType!
  segments: [ChatbotSegment!]!
}

type ChatbotSegment {
  bags: [ChatbotCheckinBag!]!
  sections: [ChatbotSection!]!
}

type ChatbotSection {
  from: ChatbotAirport!
  to: ChatbotAirport!
  bags: [ChatbotCabinBag!]!
  seats: [ChatbotSeat!]!
}

type ChatbotAirport {
  cityName: String!
  iataCode: String!
}

type ChatbotSeat {
  type: ChatbotSeatType!
  assignedSeat: String!
}

type ChatbotCheckinBag {
  pieces: Int!
  kilos: Float!
}

type ChatbotCabinBag {
  type: ChatbotCabinBagType!
  pieces: Int!
  kilos: Float!
}

input ChatbotFlowBookingIdentificationRequest {
  tripDetailsToken: String!
  userInput: String!
  touchpoint: String
}

type ChatbotFlowBookingIdentificationResponse {
  flowInformation: ChatbotFlowInformation
}

type ChatbotFlowInformation {
  id: ID!
  flowName: String!
  escalationFlowPath: String!
  categoryTitleContentKey: String!
}

type ChatbotChangeNameCard {
  numPassenger: String!
  title: ChatbotTravellerTitle!
  name: String!
  surnames: String!
  type: ChatbotTravellerType!
}

type ChatbotEditTravellerModalMessage {
  element: ChatbotElement
}

type ChatbotElement {
  traveller: ChatbotTraveller
}

type ChatbotTraveller {
  numPassenger: Int
  title: ChatbotTravellerTitle
  name: String
  surnames: String
  type: ChatbotTravellerType
  pageEventName: String
}

input ChatbotCustomParams {
  key: String!
  value: String!
}

input ChatbotFeedbackRequest {
  sessionId: String!
  messageId: String!
  feedback: ChatbotFeedback!
}

type ChatbotFeedbackResponse {
  response: Boolean
}

enum BoardingPassStatus {
  NULL
  PENDING
  SUSPENDED
  SUCCESS
  FAILED
  UNAVAILABLE
  MISSED
  UNKNOWN
}

enum TravelDocumentType {
  NATIONAL_ID
  PASSPORT
}

enum VisaType {
  TOURIST
  BUSINESS
  PRIVATE
  STUDENT
  WORK
  AIRPORT_TRANSIT
  HUMANITARIAN
  VISITOR
  GOVERNMENT_CONTRACT
  BUSINESS_MEDIA
  CONFERENCE
  SCIENTIFIC_RESEARCH
  MISSIONARY
  CREW
  JOURNALIST
  EAST_AFRICA_BORDERLESS
  LOOSE_LEAF
  STR
  ENTRY
  MEDICAL
  TECHNICAL_ASSISTANCE
  NGO
}

enum BoardingPassFormat {
  PDF
  WALLET
}

enum CheckInStatusV2 {
  REQUESTED
  CUSTOMER_VERIFICATION_REQUIRED
  COMPLETED
  FAILED
}

type CheckinStatus {
  sections: [CheckinSection]!
}

type CheckinSection {
  id: Long!
  passengerName: String!
  status: BoardingPassStatus!
  boardingPass: BoardingPass!
}

type BoardingPass {
  id: String!
  url: String!
  flightCode: String!
  departure: Airport!
  arrival: Airport!
  carrierName: String!
  seat: String
}

type Airport {
  datetime: String! @dateISO8601
  boardingTime: String
  name: String!
  iata: String!
}

type CheckinAvailability {
  available: Boolean!
  checkinWindow: CheckinWindow
  paxInfo: RequiredAdvancedPaxInfo
  nationalId: RequiredTravelDocument
  passport: RequiredTravelDocument
  address: RequiredCheckinAddress
  travelPermissions: RequiredCheckinTravelPermissions
}

type CheckinWindow {
  closingTimeInMinutes: Long!
  openingTimeInMinutes: Long!
  dataSyncOffsetInMinutes: Long!
}

type RequiredAdvancedPaxInfo {
  gender: Boolean!
  dateOfBirth: Boolean!
  locale: Boolean!
  mobilePhone: Boolean!
  email: Boolean!
  citizenship: Boolean!
  countryOfResidence: Boolean!
  emergencyContact: RequiredEmergencyContact!
}

type RequiredEmergencyContact {
  fullName: Boolean!
  phone: Boolean!
  relation: Boolean!
}

type RequiredTravelDocument {
  type: TravelDocumentType!
  number: Boolean!
  issueDate: Boolean!
  expirationDate: Boolean!
  issuingCountry: Boolean!
  monthsDocumentValidity: Long!
}

type RequiredCheckinAddress {
  state: Boolean!
  city: Boolean!
  address: Boolean!
  zip: Boolean!
}

type RequiredCheckinTravelPermissions {
  noVisaReason: Boolean!
  onwardTicket: RequiredOnwardTicket
  residentPermit: RequiredCheckinResidentPermit
  visaDetails: RequiredVisaDetails
}

type RequiredOnwardTicket {
  destination: Boolean!
  date: Boolean!
  id: Boolean!
}

type RequiredCheckinResidentPermit {
  expirationDate: Boolean!
  expires: Boolean!
  issuingCountry: Boolean!
  number: Boolean!
}

type RequiredVisaDetails {
  possibleTypes: [String]!
  number: Boolean!
  expirationDate: Boolean!
  issueCountry: Boolean!
  issueDate: Boolean!
}

input CheckinRequest {
  travellers: [CheckinTraveller]!
  bookingId: Long!
}

input CheckinTraveller {
  numPassenger: String!
  gender: TravellerGender
  birthDate: String
  mobilePhone: String
  email: String
  citizenship: String
  countryOfResidence: String
  contact: EmergencyContact
  address: CheckinAddress
  travelDocument: TravelDocument
  travelPermissions: CheckinTravelPermissions
}

input EmergencyContact {
  fullName: String
  phone: String
  relation: String
}

input CheckinAddress {
  state: String
  city: String
  address: String
  zip: String
}

input TravelDocument {
  type: TravelDocumentType
  number: String
  issueDate: String
  expirationDate: String
  issuingCountry: String
}

input CheckinTravelPermissions {
  noVisaReason: String
  onwardTicket: OnwardTicket
  residentPermit: CheckinResidentPermit
  visaDetails: VisaDetails
}

input OnwardTicket {
  destination: String
  date: String
  id: String
}

input CheckinResidentPermit {
  expirationDate: String
  expires: Boolean
  issuingCountry: String
  number: String
}

input VisaDetails {
  number: String
  expirationDate: String
  issueCountry: String
  issueDate: String
  type: VisaType
}

type CreateCheckinResponse {
  success: Boolean!
}

type BoardingPassResponseData {
  id: ID!
  bytes: String!
}

type BoardingPassesResponse {
  data: [BoardingPassResponseData!]!
}

input CreateCheckInV2Request {
  travellers: [CheckinTraveller!]!
  token: String!
}

type CreateCheckInV2Response {
  success: Boolean!
}

input CheckInsStatusRequest {
  token: String!
}

type CheckInsStatusResponse {
  checkIns: [CheckIn!]!
}

type CheckIn {
  section: TripSection!
  traveller: Traveller!
  status: CheckInStatusV2!
  boardingPasses: [BoardingPassV2!]!
}

type BoardingPassV2 {
  format: BoardingPassFormat!
  url: String!
  metadata: BoardingPassMetadata!
}

type BoardingPassMetadata {
  seat: String
}

input CheckInFunnelRequest {
  token: String!
}

type CheckInFunnelResponse {
  available: Boolean!
  url: String!
}

input CheckInFunnelTravellerFormRequest {
  token: String!
  citizenship: String!
  travellerIndex: Int!
}

type CheckInFunnelTravellerFormResponse {
  dateOfBirth: CheckInFunnelFormField!
  gender: CheckInFunnelFormField!
  nationalId: CheckInFunnelFormDocumentFields!
  passport: CheckInFunnelFormDocumentFields!
}

type CheckInFunnelFormDocumentFields {
  expirationDate: CheckInFunnelFormField!
  issueDate: CheckInFunnelFormField!
  issuingCountry: CheckInFunnelFormField!
  number: CheckInFunnelFormField!
}

type CheckInFunnelFormField {
  required: Boolean!
  defaultValue: String
}

enum CheckoutStatus {
  SUCCESS
  USER_PAYMENT_INTERACTION
  REPRICING
  FAILED
  STOP
  RETRY
}

enum CheckoutFailure {
  INVALID_PARAMETERS
  COLLECTION_OPTION_NOT_OFFERED
  INVALID_EXPIRATION_DATE
  PROFESSIONAL_INVOICING_INFO_NOT_INFORMED
  INVALID_SESSION
  VALIDATION_ERROR
  ERROR_IN_PROVIDER
  INTERNAL_ERROR
  PRODUCT_NOT_READY_FOR_CHECKOUT
  UNKNOWN
  CARD_DENIED
  CARD_TYPE_NOTMATCH
  FARE_CHANGED
  NOT_MATCHING_PRICE
  UNAVAILABLE_PROVIDER
  CONFIRMATION_ERROR
  PROVIDER_INTERNAL_ERROR
  INVALID_REQUEST_SENT_TO_PROVIDER
  EXPIRED_CARD_AT_CHECK_IN
  BOOKING_NOT_CONFIRMED
  DUPLICITY
  ERROR_PAYMENT_TYPE
  PROVIDER_PAYMENT_GATEWAY_DOWN
  CARD_TYPE_DEBIT_NOTMATCH
  EMPTY_COLLECTION_OPTIONS
  WRONG_BOOKING_DATA
  HIGH_FRAUD_RISK
  COLLECTION_DECLINED
  COLLECTION_WITH_3_D_DECLINED
  COLLECTION_ERROR
  REPRICING_ABOVE_THRESHOLD
}

enum FormSendType {
  GET
  POST
}

enum InteractionType {
  URL
  FORM_REDIRECTION
  HTML
  JAVASCRIPT
  APPLE_PAY
  GOOGLE_PAY
}

enum RedirectType {
  IFRAME
  PAGE
}

enum InterfaceType {
  WEB
  NATIVE
}

input CheckoutRequest {
  shoppingId: ID!
  shoppingType: ShoppingType!
  collectionMethod: CollectionMethodRequest!
  invoice: InvoiceRequest
  expectedPrice: Float @bigdecimal @positive
  specialRequirements: String
  saveCreditCard: Boolean = false
  accountCreationEnabled: Boolean = true
  userCollectionTrackingId: String
  origin: CheckoutOrigin
}

input CancelCheckoutRequest {
  shoppingId: ID!
  userPaymentInteractionIdInput: UserPaymentInteractionIdInput
}

input ResumeCheckoutRequest {
  shoppingInfo: ShoppingInfo!
  userPaymentInteractionIdInput: UserPaymentInteractionIdInput!
}

input ApplePayPaymentSessionRequest {
  displayName: String!
  validationUrl: String!
}

input InputParam {
  key: String!
  value: String!
}

input UserPaymentInteractionRequest {
  userPaymentInteractionId: UserPaymentInteractionIdInput!
}

input UserPaymentInteractionIdInput {
  id: ID!
}

input AddOutcomeRequest {
  userPaymentInteractionId: UserPaymentInteractionIdInput!
  outcome: [InputParam!]!
}

input UserCollectionTrackingRequest {
  shoppingInfo: ShoppingInfo!
  browserData: UserCollectionBrowser
}

input UserCollectionBrowser {
  height: String!
  width: String!
}

type UserCollectionTrackingResponse {
  userCollectionTrackingId: String
}

type ApplePayPaymentSession {
  sessionData: String!
}

type CheckoutResponse {
  status: CheckoutStatus! @deprecated(reason: "checkout refactor, use statusInfo instead")
  statusInfo: StatusInfo!
  repricing: RepricingInfo
  userInteraction: UserInteractionNeededResponse @deprecated(reason: "Use userPaymentInteractionId instead")
  userPaymentInteractionId: UserPaymentInteractionId
  myTripsRedirectionToken: String @deprecated(reason: "We have moved to myTripsRedirection")
  myTripsRedirection: MyTripsRedirection
  revenue: RDataResponse
  paymentPerception: PaymentPerception
  flashOffersAvailable: Boolean!
  shoppingCart: ShoppingCart
  shoppingBasket: ShoppingBasketResponse @deprecated(reason: "Use shoppingBundle instead")
  shoppingBundle: ShoppingBundle
}

type PaymentPerception {
  merchant: Boolean!
  merchantAmount: Money!
}

type UserPaymentInteractionId {
  id: ID!
}

type StatusInfo {
  status: CheckoutStatus!
  code: CheckoutFailure
  message: String
}

type RepricingInfo {
  newPrice: Money!
  oldPrice: Money!
  newPricePerTraveller: Money!
  oldPricePerTraveller: Money!
  difference: Float! @bigdecimal
}

type UserInteractionNeededResponse {
  interactionStep: Int!
  interactionType: InteractionType!
  formSendType: FormSendType!
  parameters: [Param!]
  htmlCode: String
  redirectUrl: String
  javascriptSnippet: String
  merchantId: String
  paypalToken: String
}

type UserPaymentInteraction {
  interactionStep: Int!
  interactionType: InteractionType!
  formSendType: FormSendType
  parameters: [Param!]
  htmlCode: String
  redirectUrl: String
  javascriptSnippet: String
  merchantId: String
  paypalToken: String
  initialRecurringCollection: Boolean!
}

type AddOutcomeResponse {
  success: Boolean!
}

type Param {
  key: String!
  value: String!
}

type MyTripsRedirection {
  token: String
  native: String
  rToken: String
}

type InteractionFinished {
  finished: Boolean!
}

input UserPaymentInteractionRedirectRequest {
  referenceId: String!
  redirectType: RedirectType!
  shoppingId: String!
  shoppingType: ShoppingType!
  interfaceType: InterfaceType!
}

type UserPaymentInteractionRedirect {
  referenceId: String
  redirectType: RedirectType
  shoppingId: String
  shoppingType: ShoppingType
  interfaceType: InterfaceType
}

enum GeoAccommodationDestinationType {
  CITY
  REGION
  ACCOMMODATION
}

enum GeoDestinationType {
  CITY
  REGION
  ACCOMMODATION
}

enum LocationType {
  AIRPORT
  CITY
  OTHER
  TRAIN_STATION
}

enum MapImageFormat {
  GIF
  JPG
  JPG_BASELINE
  PNG
  PNG32
  PNG8
}

enum MapType {
  HYBRID
  ROADMAP
  SATELLITE
  TERRAIN
}

enum NagType {
  CONTINUANCE
  REJECT
}

enum PricePerceptionType {
  INCLUDED
  PERPAX
  PERPAX_WITHTAX
  PERPLAN
  PERSEGMENT
  TOTAL
}

enum ShoppingType {
  BASKET_V2
  BASKET_V3
  CART
}

input GeoAccommodationDestination {
  id: String!
  type: GeoAccommodationDestinationType!
}

input GeoDestination {
  id: Int!
  geoDestinationType: GeoDestinationType
}

input GeoNode {
  id: Int!
  type: GeoDestinationType!
}

input GeoNodeId {
  id: Int!
}

input DateRange {
  startDate: String!
  endDate: String!
}

input MapParam {
  property: String
  value: String
}

input MapStaticConfiguration {
  size: Size!
  zoom: Int
  markerUrl: String
  scale: Int
  format: MapImageFormat
  mapType: MapType
  additionalParams: [MapParam]
}

type NextFunnelPageResponse {
  nextPage: Page
}

input NumberRange {
  start: Int!
  end: Int!
}

type Page {
  url: String!
}

input PageInput {
  url: String!
}

type Price {
  value: Money!
  perception: PricePerception!
}

type PricePerception {
  type: PricePerceptionType!
}

input ShoppingInfo {
  shoppingId: ID!
  shoppingType: ShoppingType!
}

input Size {
  height: Int!
  width: Int!
}

type StaticMapResponse {
  image: String!
}

input DecryptCrmUserTokenForAccommodationRequest {
  token: String!
}

type DecryptCrmUserTokenForAccommodationResponse {
  email: String!
  displayName: String!
  isPrime: Boolean
}

type FaqInformation {
  trackingId: String!
  title: String!
  link: String!
}

type FaqRecommendation {
  faqs: [FaqInformation!]!
}

enum QueueRequestType {
  HSA_MMB
}

input QueueRequest {
  type: QueueRequestType!
  bookingId: Long
}

enum QueueStatus {
  OPEN
  OUTSIDE_WORKING_HOURS
}

type Queue {
  status: QueueStatus!
  id: String!
  name: String!
}

type GenesysInfo {
  queue: Queue
}

enum DealsTripType {
  ONE_WAY
  ROUND_TRIP
  MULTI_DESTINATION
}

enum AccommodationDealFilterType {
  MIN_DISCOUNT
  MIN_STARS
  MIN_SCORING
  MAX_DISTANCE_FROM_CENTER
}

enum DealsSortingType {
  LOWEST_PRICE
  MOST_POPULAR
}

enum DealsSearchPriority {
  UPCOMING_TRIP
  SEARCHED_DESTINATION
  DEALS_ON_DEMAND
}

input DealsRequest {
  departure: Int!
  departureDateRange: DateRange!
  arrivalDateRange: DateRange
  durationDays: NumberRange
  tripType: DealsTripType = ROUND_TRIP
  sortBy: DealsSortingType = LOWEST_PRICE
  numAdults: Int = 1
  latestSearches: [LatestSearch] = []
}

input LatestSearch {
  originIata: String!
  destinationIata: String!
  departureDate: String!
  arrivalDate: String
  timestamp: Long
  numAdults: Int = 1
}

type ApparentPrice {
  id: ID!
  price: Money!
}

enum HottestDealType {
  REGULAR
  BEST_DISCOUNT
  BEST_PRICE
}

type Deal {
  departureDate: String!
  arrivalDate: String!
  destination: City!
  apparentPricesByPax: [ApparentPrice!]!
  discount: Float!
  hottestDealType: HottestDealType
}

input AccommodationDealRequest {
  checkInDateRange: DateRange @deprecated(reason: "Use checkInDate instead")
  checkOutDateRange: DateRange @deprecated(reason: "Use checkOutDate instead")
  durationDays: NumberRange @deprecated
  destinations: [GeoNodeId] @deprecated(reason: "Use destination instead")
  roomRequest: RoomRequest
  maxResults: Int
  filters: AccommodationDealFilters
  checkInDate: String
  checkOutDate: String
  destination: GeoDestination @deprecated(reason: "Use either itineraryDestination accommodationDestination or instead")
  searchPriority: DealsSearchPriority = UPCOMING_TRIP
  itineraryDestination: GeoNode
  accommodationDestination: GeoAccommodationDestination
}

input AccommodationDealFilters {
  minDiscount: Float
  minStars: Int
  minUserScore: Float
  maxDistanceFromCenter: Float
}

input AccommodationDealByDestinationRequest {
  checkInDateRange: DateRange!
  checkOutDateRange: DateRange!
  durationDays: NumberRange
  destination: GeoNodeId!
  isAccommodationRecommendation: Boolean = false
  roomRequest: RoomRequest
  maxResults: Int
  filters: AccommodationDealFilters
}

type AccommodationDeal {
  checkInDate: String!
  checkOutDate: String!
  destination: City!
  price: Money!
  priceNonPrime: Money!
  discount: Float!
  discountAbsolute: Money!
  dedupId: Int!
  accommodationInfo: AccommodationDetailsResponse!
  images: [AccommodationImages!]!
  requestedDestination: Boolean
  matchedFilters: [AccommodationDealFilterType!]!
}

type AccommodationDealsResponse {
  deals: [AccommodationDeal!]!
  dealsId: String
  isAlternativeDates: Boolean
}

enum PostBookingParameterType {
  OPEN_RESULTS_MAP_VIEW
  SELECTED_PROPERTY_ID
}

input PostBookingURLRequest {
  bookingId: Long!
  email: String! @email
  buyPath: Int!
}

input AccommodationPostBookingURLRequest {
  bookingId: Long!
  email: String! @email
  buyPath: String!
  parameters: [PostBookingParameter!]
}

input HsaSearchURLRequest {
  accommodationProductId: String!
  email: String! @email
  buyPath: String!
}

type HsaSearchURLResponse {
  url: String!
}

type PostBookingURLResponse {
  url: String!
}

input StoreSmsConsentRequest {
  shoppingId: ID!
  email: String! @email
  webSiteCode: String!
  consent: Boolean!
}

type StoreSmsConsentResponse {
  success: Boolean!
}

input AccommodationSearchRoomURLRequest {
  checkInDate: String!
  checkOutDate: String!
  destination: LocationRequest!
  dedupId: Long!
  roomRequests: [RoomRequest!]!
  buyPath: Int
}

type AccommodationSearchRoomURLResponse {
  url: String!
}

input PostBookingParameter {
  key: PostBookingParameterType!
  value: String!
}

input FareFamilyRequest {
  searchId: Long!
  fareItineraryKey: String!
  segmentKeys: [String!]!
  carrierIds: [ID!]!
  passengers: Int
}

type FareFamilyPerk {
  description: String!
  availability: String!
  fareUpgradePerkType: String!
  fareUpgradePerkTypeGroup: String!
  units: Int
  weight: Int
  visibility: String
}

type FareFamily {
  name: String!
  cabinClass: String!
  fareFamilyPerks: [FareFamilyPerk!]!
  totalPrice: Money!
  price: Money!
  providerItineraryIndex: Int!
}

input SearchFastTrackOffersRequest {
  sections: [FastTrackSection!]!
}

input FastTrackSection {
  airportCode: String!
  flightNumber: String
  entryDateTime: String
}

type FastTrackProduct {
  flightNumber: String!
  productId: String!
  totalPrice: Money!
  entryDateTime: String!
  airportCode: String!
  pricePerception: FastTrackProductPricePerception
}

type SearchFastTrackOffersResponse {
  offers: [FastTrackPostBookingOffer!]!
}

type FastTrackPostBookingOffer {
  offerId: String!
  price: Money!
  airportIataCode: String!
}

input ItineraryId {
  email: String!
  id: ID!
}

input FastTrackPostBookingOfferInput {
  flightNumber: String @deprecated(reason: "moved to SearchFastTrackOffersRequest")
  entryDateTime: String @deprecated(reason: "moved to SearchFastTrackOffersRequest")
  offerId: String!
}

input SelectFastTrackOfferForItineraryRequest {
  itineraryId: ItineraryId!
  offers: [FastTrackPostBookingOfferInput!]!
}

type SelectFastTrackOfferForItineraryResponse {
  products: [FastTrackProduct!]!
}

input SearchFastTracksByItineraryRequest {
  itineraryId: ItineraryId!
}

type SearchFastTracksByItineraryResponse {
  products: [FastTrackProduct!]!
}

type FastTrackProductPricePerception {
  totalPricePerPassenger: Money!
}

type FastTrackShoppingBasketProduct {
  productId: ID!
}

input ShoppingBasketFastTrackProductsRequest {
  fastTracksIds: [ID!]!
  shoppingBasketId: ID!
}

type ShoppingBasketFastTrackProductsResponse {
  products: [FastTrackProduct!]!
}

enum FastTrackFlightDirection {
  INBOUND
  OUTBOUND
}

type FastTrackOffer {
  id: String!
  unitaryPrice: Money!
}

type FastTrackAvailability {
  airportName: String
  airportCityName: String!
  airportCode: String!
  airportCountryName: String!
  airlineCode: String!
  flightNumber: String!
  flightDirection: FastTrackFlightDirection!
  entryDateTime: String!
  offer: FastTrackOffer
  available: Boolean!
  selected: Boolean!
  purchased: Boolean!
  productId: ID
}

input GetFastTrackAvailabilitiesRequest {
  bookingId: Long
  shoppingBasketId: ID
  itineraryId: ItineraryId!
}

type GetFastTrackAvailabilitiesResponse {
  availabilities: [FastTrackAvailability!]!
}

input UnselectFastTrackRequest {
  productId: ID!
  bookingId: Long
  shoppingBasketId: ID
}

type UnselectFastTrackResponse {
  productId: ID
}

input SelectFastTrackRequest {
  itineraryId: ItineraryId!
  bookingId: Long
  shoppingBasketId: ID
  offersIds: [String!]!
}

type SelectFastTrackResponse {
  productIds: [ID!]!
}

input AddFavoriteAccommodationRequest {
  propertyMappingId: Long!
  contentKey: String
  providerId: String
  accommodationProviderId: String
  checkInDate: String
  checkOutDate: String @deprecated
  geoNodeId: Int
  roomRequests: [FavoriteRoomRequest!]!
}

input FavoriteRoomRequest {
  numAdults: Int!
  childrenAges: [Int!]!
}

input FavoriteAccommodationsByLocationRequest {
  geoId: String!
}

type FavoriteRoom {
  numAdults: Int!
  childrenAges: [Int!]!
}

input DeleteFavoriteAccommodationRequest {
  propertyMappingId: Long!
}

type AddFavoriteAccommodationResponse {
  success: Boolean!
}

type DeleteFavoriteAccommodationResponse {
  success: Boolean!
}

type FavoriteAccommodationsLocationResponse {
  locations: [FavoriteAccommodationsLocation!]!
}

type FavoriteAccommodationsLocation {
  geoId: String!
  cityName: String!
  countryName: String!
  count: Int!
  checkInDate: String!
  checkOutDate: String!
  rooms: [FavoriteRoom!]!
}

type FavoriteAccommodationsByLocationResponse {
  checkInDate: String!
  checkOutDate: String!
  rooms: [FavoriteRoom!]!
  accommodationSearchResponse: AccommodationSearchResponse!
}

input FeatureVariationRequestWithVersion {
  name: String!
  version: Int
}

input FeatureVariationRequest {
  name: String!
}

type FeatureVariationResponse {
  name: String!
  index: Int!
  evaluable: Boolean
}

input FeaturesEventTrackingRequest {
  name: String!
  variation: Int!
  evaluable: Boolean
}

type FeaturesEventTrackingResponse {
  success: Boolean!
}

enum RequiredFieldType {
  MANDATORY
  OPTIONAL
  NOT_REQUIRED
  CONDITIONAL_REQUIRED
}

enum FieldValidatorType {
  EMAIL_REGEX
  SECOND_EMAIL_VALIDATOR
  SECOND_EMAIL_VALIDATOR_CASE_INSENSITIVE
  NIF_REGEX
  NIE_REGEX
  IDENTIFICATION_VALIDATOR
  IDENTIFICATION_VALIDATOR_ES
  PASSPORT_REGEX
  INVOICE_NAME_REGEX
  COUNTRY_CODE_REGEX
  ADDRESS_REGEX
  FFC_CODE_REGEX
  NUMBER_ONLY_REGEX
  NUMBER_OR_LETTER_EXCLUDING_SYMBOLS_REGEX
  NOT_EMPTY
  EXPIRATION_DATE_VALIDATOR
  ADULT_DATE_VALIDATOR
  CHILD_DATE_VALIDATOR
  INFANT_DATE_VALIDATOR
  REQUIRED_STRING_VALIDATOR
  NO_BLANK_SPACES_BEFORE_STRING_VALIDATOR
  PHONE_NUMBER_REGEX
  PHONE_NUMBER_ALLOWING_SPACES_REGEX
  ZIP_CODE_REGEX
  PAX_NAME_REGEX
  CITY_REGEX
  ZIP_CODE_VALIDATOR
  CVV_REGEX
  CVV_REGEX3
  CVV_REGEX4
  UTF8_REGEX
  PETS_OPTIONS_VALIDATOR
}

enum FieldTypeValue {
  TEXT_FIELD
  COMBO_BOX
  DATE_FIELD
  RADIO_BUTTON
  DATE_FIELD_3SELECTS
  DATE_FIELD_1SELECT_2INPUT
}

enum FieldSize {
  S
  M
  L
  XL
}

enum FieldSpace {
  NOSPACE
  S
  M
  L
  XL
}

type FormGroups {
  travellerFields: [FormFields!]!
  buyerFields: FormFields!
}

type FormFields {
  fields: [[FieldObject!]!]!
  additionalFields: [[FieldObject!]]
}

type FieldObject {
  attributes: Attributes
  dataId: String!
  dataName: String!
  fieldType: FieldTypeValue!
  mandatory: RequiredFieldType
  options: [FieldValueOptions!]
  style: Style
  position: Position!
}

type Position {
  row: Int!
  column: Int!
}

type Style {
  size: FieldSize
  space: FieldSpace
}

type Attributes {
  validator: Validator
  autoComplete: Boolean
  autoCapitalize: Boolean
  autoCorrect: Boolean
}

type Validator {
  type: FieldValidatorType!
  regex: String
}

type FieldValueOptions {
  option: String
  value: String
}

enum FlexibleDatesTripType {
  ROUND_TRIP
  ONE_WAY
}

enum InterfaceClientType {
  ONE_FRONT_SMARTPHONE
}

enum SearchPriceType {
  SEARCH_PRICE
  ITINERARY_PRICING_STATS
}

input FlexibleDatesPricesRequest {
  originGeoNode: Int!
  destinationGeoNode: Int!
  departureDate: String!
  interfaceClient: InterfaceClientType!
  tripType: FlexibleDatesTripType!
  numberOfFutureDaysDep: Int
  numberOfFutureDaysArr: Int
  searchStrategy: SearchPriceType
  priceFreshnessDays: Int
  adults: Int
  children: Int
  infants: Int
}

union FlexibleDatesPricesUnion = FlexibleDatesDayPrice | FlexibleDatesReturnTripPrices

type FlexibleDatesDayPrice {
  date: String!
  price: Float @bigdecimal
}

type FlexibleDatesReturnTripPrices {
  date: String!
  priceList: [FlexibleDatesDayPrice]
}

type FlexibleDatesPricesResponse {
  currency: String
  prices: [FlexibleDatesPricesUnion]
}

input FlexibleDatesSearchRequest {
  originGeoNode: Int!
  destinationGeoNode: Int!
  departureDate: String!
  returnDate: String
  tripType: FlexibleDatesTripType!
  numberOfDaysFlexibility: Int
  searchStrategy: SearchPriceType
  priceCalculationCriteria: String
  priceFreshnessDays: Int
  adults: Int @deprecated(reason: "it won't be used")
  children: Int @deprecated(reason: "it won't be used")
  infants: Int @deprecated(reason: "it won't be used")
}

type FlexibleDatesApparentPrice {
  apparentPrice: Money!
  apparentPriceCriteria: String!
}

type FlexibleDatesMatrixData {
  matrixRow: Int!
  matrixColumn: Int!
  departureDate: String!
  returnDate: String
  timestamp: String!
  apparentPrices: [FlexibleDatesApparentPrice!]!
}

type FlexibleDatesSearchResponse {
  originGeoNode: Int!
  destinationGeoNode: Int!
  firstOriginDate: String!
  lastOriginDate: String!
  firstReturnDate: String
  lastReturnDate: String
  numberOfColumns: Int!
  numberOfRows: Int!
  matrixEntries: [FlexibleDatesMatrixData!]!
}

enum GeolocationSuggestionsInputType {
  DEPARTURE
  ARRIVAL
}

enum GeolocationSuggestionsProductType {
  FLIGHT
  TRAIN
  BUS
  HOTEL
}

enum GeolocationDistanceUnitType {
  KM
  ML
}

input GeolocationSuggestionsRequest {
  searchWord: String! @minLength(len: 3)
  inputType: GeolocationSuggestionsInputType!
  productType: GeolocationSuggestionsProductType!
  includeCountry: Boolean!
  includeRegion: Boolean!
  includeNearestLocations: Boolean!
  includeRelatedLocations: Boolean!
  includeCitiesOnly: Boolean
}

input GeolocationSuggestionsByLocationRequest {
  latitude: Float @bigdecimal
  longitude: Float @bigdecimal
  radius: Int!
  filter: Boolean!
  productType: GeolocationSuggestionsProductType! = FLIGHT
}

input GeoCoordinatesRequest {
  latitude: Float! @bigdecimal
  longitude: Float! @bigdecimal
}

type GeolocationSuggestionsResponse {
  geolocationSuggestions: [GeolocationSuggestion!]!
}

type GeolocationSuggestion {
  geoNodeId: Int!
  iataCode: String
  cityName: String
  regionName: String
  countryName: String
  geoNodeType: String
  name: String
  distance: Int
  distanceUnit: GeolocationDistanceUnitType
  coordinates: GeoCoordinates
  relatedLocations: [GeolocationSuggestion]
}

type GeolocationSuggestionsByLocationResponse {
  geolocationDescriptionsSorted: [GeolocationDescriptionSorted!]!
}

type GeolocationDescriptionSorted {
  geolocationSuggestion: GeolocationSuggestion!
  coordinates: GeoCoordinates
  type: String!
  name: String!
  matchName: String
  countryCode: String
  locationNames: [String]!
  distance: Int
  distanceUnit: GeolocationDistanceUnitType
  relatedLocations: [GeolocationDescriptionSorted]
}

type City {
  id: Int
  name: String!
  iata: String
  coordinates: GeoCoordinates
}

input LocationRequest {
  iata: String
  geoNodeId: Int
}

input GetCountriesRequest {
  locale: String!
}

type GetCountriesResponse {
  countries: [Country]
}

type Country {
  id: Int!
  name: String!
  code: String!
  phonePrefix: String!
}

type GeoCoordinates {
  latitude: Float @bigdecimal
  longitude: Float @bigdecimal
}

type GeoLocation {
  geoNodeCoordinates: GeoCoordinates
  city: City
  country: Country
}

type LocalizationByIpResponse {
  countryCode: String
  countryName: String
  language: String!
  domainCountryCode: String!
}

input GeoServiceLocationsRequest {
  geoNodeIds: [Int!]!
  iatas: [String!]!
}

type GeoServiceLocationsResponse {
  locations: [GeoServiceLocation]!
}

type Continent {
  name: String!
  id: Int!
}

type GeoServiceLocation {
  type: LocationType!
  geoNodeId: Int!
  geoNodeType: String
  iataCode: String
  countryName: String
  countryCode: String
  cityName: String
  cityGeoNodeId: Int
  name: String!
  regionName: String
  continent: Continent
  coordinates: GeoCoordinates
}

enum InsuranceUrlType {
  SIMPLE
  EXTENDED
}

input InsuranceOffersRequest {
  bookingId: Long!
  products: [ProductIdRequest]
}

type InsuranceOffersResponse {
  insurances: [InsuranceOfferType]
}

type InsuranceOfferType {
  offerId: InsuranceOfferId!
  offerKey: String!
  price: Money!
  conditionUrls: [InsuranceUrl]
}

type InsuranceOfferId {
  id: String!
  version: String!
}

type InsuranceUrl {
  type: InsuranceUrlType!
  url: String!
}

type InsuranceProduct {
  productId: String!
  offerKey: String!
  price: Money!
}

input SelectInsuranceOfferRequest {
  offerId: OfferId!
  shoppingBasketId: ShoppingBasketId!
}

input OfferId {
  id: String!
  version: String!
}

input ShoppingBasketId {
  id: Long!
}

type SelectInsuranceOfferResponse {
  productId: ProductId!
}

input InvoiceRequest {
  invoiceAddress: String!
  invoiceCity: String!
  invoiceCountryCode: String!
  invoiceId: String
  invoiceMail: String
  invoiceName: String!
  invoiceRequired: Boolean
  invoiceZipCode: String!
  professional: Boolean!
}

enum ContactType {
  PROFESSIONAL
  PRIVATE
}

enum InvoiceRequestStatus {
  REQUESTED
  ISSUED
  ERROR
  NOT_IN_AXAPTA_SYSTEM
}

type Invoice {
  id: String!
  requestDate: String! @yyyyMMddTHHmmssZZZZZ
  requester: String!
  status: InvoiceRequestStatus!
  issuanceDate: String @yyyyMMddTHHmmssZZZZZ
  todId: Long
}

type InvoiceDetails {
  name: String!
  address: String!
  city: String!
  zipCode: String!
  countryCode: String!
  identification: String
  email: String!
  contactType: ContactType!
}

type LastInvoiceRequestedResponse {
  requestDetails: Invoice!
  customerDetails: InvoiceDetails
}

type InvoiceComponents {
  currency: String!
  collectedAmount: Float!
  collectedAmountExcludingMembershipDiscount: Float!
  itineraryComponents: ItineraryInvoiceComponents
  accommodationComponents: AccommodationInvoiceComponents
  additionalServicesAndFees: Float!
  totalMembershipDiscount: Float
  totalAmountPaid: Float! @deprecated(reason: "misleading name, use collectedAmount instead")
  totalPrice: Float!
}

type ItineraryInvoiceComponents {
  airFare: Float!
  airlineTaxes: Float!
  airlineChargesAmounts: [AirlineChargesAmounts!]!
}

type AccommodationInvoiceComponents {
  roomPrice: Float!
}

type AirlineChargesAmounts {
  airlineCode: String!
  airlineName: String!
  chargedAmount: Float!
}

input InvoiceContactDetails {
  name: String
  address: String
  city: String
  zipCode: String
  countryCode: String
  identification: String
  email: String
  contactType: ContactType
}

input BookingInvoicesRequest {
  bookingId: Long!
  email: String!
}

enum CabinClass {
  BUSINESS
  FIRST
  TOURIST
  PREMIUM_ECONOMY
  ECONOMIC_DISCOUNTED
}

enum BaggageCondition {
  CHECKIN_INCLUDED
  CABIN_INCLUDED
  BASED_ON_AIRLINE
}

enum TransportType {
  PLANE
  TRAIN
}

enum InsurancePolicy {
  ODIGEO_GUARANTEE
  EXTERNAL_INSURANCE
  OTHER
}

enum PrimeDayFareType {
  GOLD
  SILVER
  BRONZE
}

enum TripType {
  ONE_WAY
  ROUND_TRIP
  MULTIPLE_DESTINATIONS
}

type Itinerary {
  freeCancellation: String @dateISO8601
  legs: [Leg!]
  transportTypes: [TransportType!]
  ticketsLeft: Int!
  tripType: TripType!
  searchId: Long
  id: ID!
  key: String!
  meRating: Float! @bigdecimal
  hotelXSellingEnabled: Boolean!
  hasFreeRebooking: Boolean!
  hasReliableCarriers: Boolean!
  hasRefundCarriers: Boolean!
  isFareUpgradeAvailable: Boolean!
  primeDayConfig: PrimeDayConfig @deprecated(reason: "You can find the same information in Itinerary.campaignConfig.primeDayConfig")
  carbonFootprint: CarbonFootprint
  fees: [Fee!]!
  perks: Perks
  campaignConfig: CampaignConfig
  freeCancellationLimit: FreeCancellationLimit
}

type Leg {
  segments: [Segment!]!
  segmentKeys: [Int!]! @deprecated(reason: "onefront integration")
}

type Segment {
  id: ID!
  carrier: Carrier!
  sections: [Section!]!
  baggageCondition: BaggageCondition!
  transportTypes: [TransportType!]!
  duration: Long @deprecated(reason: "old data structure, use originalDurationInMinutes instead")
  originalDurationInMinutes: Long
  updatedDurationInMinutes: Long
  seats: Int
  stops: Int
  technicalStops: Int
  allStops: Int
}

type Section {
  id: ID!
  departureDate: String! @dateISO8601
  arrivalDate: String! @dateISO8601
  departure: Location!
  destination: Location!
  carrier: Carrier!
  operatingCarrier: Carrier
  commercialBrand: CommercialBrand
  cabinClass: CabinClass
  flightCode: String!
  arrivalTerminal: String
  departureTerminal: String
  technicalStops: [TechnicalStop!]!
  vehicleModel: String
  insuranceOffer: InsuranceOffer
  transportType: TransportType
  isHub: Boolean!
  duration: Long @deprecated(reason: "old data structure, use originalDurationInMinutes instead")
  originalDurationInMinutes: Long
  updatedDurationInMinutes: Long
  key: String
  baggageAllowance: Int
  flightNumber: String
  providerCode: String
  stopDuration: Long
}

type InsuranceOffer {
  id: ID!
  url: String!
  policy: InsurancePolicy!
}

type Location {
  id: ID!
  name: String
  cityName: String!
  countryName: String!
  iata: String
  cityIata: String
  locationType: LocationType!
  countryCode: String
  timeZone: String
}

type Carrier {
  id: ID!
  name: String!
  supportUrl: String
}

type CommercialBrand {
  id: ID!
  name: String!
}

type TechnicalStop {
  location: Location!
  departureDate: String! @dateISO8601
  arrivalDate: String! @dateISO8601
  stopDuration: Long
}

type FreeCancellationLimit {
  limitTime: Long
  hoursApart: Long
}

input ItinerarySelection {
  fareItineraryKey: String!
  segmentKeys: [String!]!
}

type CarbonFootprint {
  isEco: Boolean
  ecoPercentageThanAverage: Int
  totalCo2Kilos: Float @bigdecimal
  totalCo2eKilos: Float @bigdecimal
}

type SearchCode {
  code: String!
  message: String!
}

type Fee {
  price: Money!
  type: FeeType!
}

type FeeType {
  id: ID!
  name: String
  paymentMethod: PaymentMethod
}

type Money {
  amount: Float! @bigdecimal
  currency: String!
}

input ExternalSelectionRequest {
  searchId: Long!
  fareItineraryKey: String!
  segmentKeys: [String!]!
  collectionMethodId: Int
  displayedPrice: Float @bigdecimal
  displayedCurrency: String
}

input SegmentRequest {
  date: String!
  departure: LocationRequest!
  destination: LocationRequest!
}

type ItineraryProduct implements Product {
  id: ProductId
  price: Money
  productInfo: Itinerary
}

type ItineraryPriceSummary implements PriceSummary {
  amount: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  pricePerception: PricePerceptionConfig!
  pricePerPassenger: Money!
  nonDiscountedPricePerPassenger: Money
}

input ItinerarySearchAlternativesRequest {
  searchId: Long!
  itineraryId: ID!
  itineraryCarriers: [String!]!
  eligibleForDiscount: Boolean
  searchRequest: SearchRequest!
}

input LoginEmailRequest {
  email: String!
  recaptchaV2Response: String
}

type LoginEmailResponse {
  isAcknowledged: Boolean!
}

input AuthenticationEmailRequest {
  email: String!
  landingPagePath: String
  recaptchaV2Response: String
  newsletterSubscribed: Boolean
}

input AuthenticationEmailWithTripAroundTheWorldContestParticipationRequest {
  email: String!
  landingPagePath: String
  recaptchaV2Response: String
}

type AuthenticationEmailResponse {
  acknowledged: Boolean!
  multiSessionToken: String
}

input ReauthenticationEmailRequest {
  landingPagePath: String
  fallbackLandingPagePath: String
}

type ReauthenticationEmailResponse {
  acknowledged: Boolean!
}

enum MembershipPerksType {
  ITINERARY_PERKS
  ACCOMMODATION_PERKS
  ITINERARY_AND_ACCOMMODATION_PERKS
}

enum VoucherCodeType {
  VOUCHER_ALREADY_SENT
  VOUCHER_SENT
  ERROR
}

enum MembershipCancellationOptionType {
  PARTIAL_REFUND_ELIGIBLE
  FULL_REFUND_ELIGIBLE
}

enum MembershipDurationTimeUnit {
  DAYS
  MONTHS
}

type MembershipDuration {
  amount: Int!
  timeUnit: MembershipDurationTimeUnit!
}

input MembershipRequest {
  shoppingInfo: ShoppingInfo
}

type Membership {
  id: Long!
  name: String!
  lastNames: String!
  autoRenewalStatus: String
  memberAccountId: Long! @deprecated(reason: "Not used, will be removed in next iterations")
  expirationDate: String
  activationDate: String @deprecated(reason: "Not used, will be removed in next iterations")
  sourceType: String @deprecated(reason: "Not used, will be removed in next iterations")
  type: String
  status: String
  monthsDuration: Int! @deprecated(reason: "Deprecated to use the duration with timeUnit")
  totalPrice: Money
  renewalPrice: Money
  duration: MembershipDuration
  renewalDuration: MembershipDuration
  isFreeTrial: Boolean!
  isAutoApply: Boolean
  recurringCollectionId: ID
  cancellationDate: String
  partner: Partner
}

enum Partner {
  PAYPAL
}

type MembershipPerks {
  fee: Float @bigdecimal @deprecated(reason: "Perks will be included in each product")
  perks: [MembershipPerk!]!
}

type MembershipPerk {
  discount: Money!
  isApplied: Boolean!
  perkType: MembershipPerksType!
}

type PrimeInfo {
  isPrimeSite: Boolean! @deprecated(reason: "Use PrimeSitePropertiesResponse")
  isPrimeUser: Boolean! @deprecated(reason: "Use MembershipAccountPropertiesResponse")
  isPrimeUserFromCookie: Boolean! @deprecated(reason: "Use PrimeSitePropertiesResponse")
  isLoggedPrimeUser: Boolean! @deprecated(reason: "Use MembershipAccountPropertiesResponse")
}

enum UpdateUserMembershipAction {
  ACTIVATE_RENEWAL_STATUS
  DEACTIVATE_RENEWAL_STATUS
  ACTIVATE_RENEWAL_REMINDER
  DEACTIVATE_RENEWAL_REMINDER
  ACTIVATE_MEMBERSHIP
  DEACTIVATE_MEMBERSHIP
}

enum UpdateUserMembershipPlanAction {
  UPGRADE_MEMBERSHIP
  DOWNGRADE_MEMBERSHIP
}

input UpdateUserMembershipRequest {
  action: UpdateUserMembershipAction!
  shoppingInfo: ShoppingInfo
}

input UpdateUserMembershipPlanRequest {
  action: UpdateUserMembershipPlanAction!
  membershipUpdateInfo: MembershipUpdateInfo!
  shoppingInfo: ShoppingInfo
}

input MembershipUpdateInfo {
  offerId: String!
}

enum MembershipPageName {
  SUBSCRIPTION_MULTIPLE_OFFERS
  SUBSCRIPTION_SINGLE_OFFER
  SUBSCRIPTION_FTL
  RENEWAL_RECAPTURE
  RECONFIRM_REPEAT
}

input MembershipPagesRequest {
  shoppingInfo: ShoppingInfo!
}

type MembershipPagesResponse {
  pages: [MembershipPageName!]!
}

type MembershipAccountPropertiesResponse {
  isActiveLogged: Boolean
  isActive: Boolean
}

type PrimeActiveFunnels {
  flights: Boolean
  cars: Boolean
  hotels: Boolean
  dynpack: Boolean
}

type PrimeSitePropertiesResponse {
  primeActiveFunnels: PrimeActiveFunnels!
  activePrimeMarket: PrimeActiveFunnels! @deprecated
  isPrimeMarket: Boolean!
  isPrimeUserFromCookies: Boolean @deprecated(reason: "We're going to replace it with isPossibleReturningPrimeVisitor. Should be removed in next refactors")
  isPossibleReturningPrimeVisitor: Boolean
}

type PrimeMemberBuyerInfo {
  name: String
  lastNames: String
}

type MembershipSubscriptionResponse {
  offerAdded: SubscriptionResponse!
  primeMember: PrimeMemberBuyerInfo!
}

type MembershipTokenResponse {
  name: String
  email: String
}

enum MembershipSubscriptionActions {
  ADD
  REMOVE
  EDIT
}

input GetMembershipProductRequest {
  shoppingInfo: ShoppingInfo!
}

input UpdateMembershipProductRequest {
  action: MembershipSubscriptionActions!
  offerId: String!
  names: String!
  lastNames: String!
  email: String!
  shoppingInfo: ShoppingInfo!
}

input UpdateSubscriptionProductBinBasedRequest {
  action: MembershipSubscriptionActions!
  offerId: String!
  names: String!
  lastNames: String!
  email: String!
  creditCardBin: String!
  shoppingInfo: ShoppingInfo!
}

input MembershipProductEvaluationRequest {
  paymentInstrumentToken: String!
  creditCardBin: String!
  creditCardDate: String!
  shoppingInfo: ShoppingInfo!
}

type MembershipPriceBreakDownItem implements PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  type: PriceBreakDownItemType!
  quantity: Int!
  discountInfo: [DiscountInfo!]
  duration: MembershipDuration!
}

type MembershipSubscriptionProduct implements Product {
  id: ProductId
  price: Money
  productInfo: MembershipSubscriptionResponse
}

type RetentionVoucherResponse {
  code: VoucherCodeType!
}

type ReactivationVoucherResponse {
  code: VoucherCodeType!
}

type MembershipProductEvaluationResponse {
  code: MembershipProductEvaluationCode!
}

enum MembershipProductEvaluationCode {
  INVOLUNTARY_ABUSER
  VOLUNTARY_ABUSER
  BLOCKING_BIN
  RISKY_CREDIT_CARD
  NO_RISK
  YEARLY_REJECTED
  BOOKING_ABUSER
}

type MembershipCancellationOption {
  cancellationOptionId: ID!
  type: MembershipCancellationOptionType!
  refundAmount: Money
}

enum MembershipRetentionOfferPerkType {
  ITINERARY_CANCELLATION
}

enum MembershipRetentionOfferType {
  FLIGHT_CANCELLATION_OPTION
}

type MembershipRetentionOffer {
  id: ID!
  membershipOffers: [MembershipRetentionOfferType!]!
  membershipPerks: [MembershipRetentionOfferPerkType!]! @deprecated
}

type MembershipCancellation {
  cancellationId: ID!
  cancellationOptionId: ID!
  userAccount: UserAccountResponse
}

type CreateMembershipCancellationOptionsResponse {
  membershipCancellationOptions: [MembershipCancellationOption!]!
}

type CalculateMembershipRetentionOptionsResponse {
  membershipCancellationOptions: [MembershipCancellationOption!]!
  retentionUserAccount: UserAccountResponse
  membershipRetentionOffers: [MembershipRetentionOffer!]!
  membershipRewards: MembershipRewards!
}

input CancelMembershipRequest {
  cancellationOptionId: ID!
  buyerEmail: String!
}

type MembershipRenewalResponse {
  offerAdded: SubscriptionResponse!
  primeMember: PrimeMemberBuyerInfo!
}

type MembershipRenewalProduct implements Product {
  id: ProductId
  price: Money
  productInfo: MembershipRenewalResponse
}

input CancelUnauthenticatedMembershipRequest {
  recaptchaTokenV2: String
  email: String!
}

type CancelUnauthenticatedMembershipResponse {
  success: Boolean!
}

enum ChurnPredictionType {
  UNKNOWN
  LOW
  HIGH
}

input MembershipChurnPredictionRequest {
  shoppingId: ID!
}

type MembershipChurnPredictionResponse {
  prediction: ChurnPredictionType!
}

enum RetentionFlowType {
  DEFAULT
  UPCOMING_TRIP
}

enum RetentionRuleCodeType {
  RULE_APPLIED
  RULE_ALREADY_APPLIED
}

enum RetentionRuleFeatureType {
  CANCELLATION_RULE
  VOUCHER_RULE
}

enum RetentionFunnelStatus {
  AUTORENEWAL_CANCELED
  MEMBERSHIP_CANCELED
  TOKEN_EXPIRED
  VOUCHER_REQUESTED
  FREE_CANCELLATION_ADDED
  REMINDER_REQUESTED
  KEEP
}

enum RewardType {
  MONTHLY_PROMO_CODE_REWARD_FOR_YEARLY_SUBSCRIPTION
  WELCOME_PROMO_CODE_REWARD_THREE_MONTHS_CLAIMABLE
}

enum ProductToApply {
  ACCOMMODATION
  ITINERARY
}

type RetentionFlowUpcomingBooking {
  departureDate: String @dateISO8601
  arrivalCityName: String
}

type RetentionFlowInfoResponse {
  flowType: RetentionFlowType
  hasUpcomingBookings: Boolean
  upcomingBooking: RetentionFlowUpcomingBooking @deprecated(reason: "Use upcomingBookings instead")
  upcomingBookings: [RetentionFlowUpcomingBooking!]!
}

input AcceptMembershipRetentionOfferRequest {
  feature: RetentionRuleFeatureType
  offerId: ID
}

type AcceptMembershipRetentionOfferResponse {
  code: RetentionRuleCodeType! @deprecated
  success: Boolean!
}

type MembershipRejoinOffer {
  membershipRejoinOfferId: String!
  plan: MembershipPlan!
  basePrice: Money!
}

type MembershipRejoinOffersResponse {
  membershipRejoinOffers: [MembershipRejoinOffer!]!
}

type MembershipRewards {
  claimableRewards: [ClaimableReward!]!
  issuedRewards: [IssuedReward!]!
  totals: MembershipRewardsTotals
}

interface BaseMembershipReward {
  rewardType: RewardType!
  promoCodeRewards: [PromoCodeReward!]!
}

type ClaimableReward implements BaseMembershipReward {
  rewardType: RewardType!
  promoCodeRewards: [PromoCodeReward!]!
}

type IssuedReward implements BaseMembershipReward {
  rewardType: RewardType!
  promoCodeRewards: [PromoCodeReward!]!
}

type PromoCodeReward {
  productToApply: ProductToApply!
  discount: Money!
}

type MembershipRewardsTotals {
  claimableTotal: Money!
  issuedTotal: Money!
  overallTotal: Money!
}

enum EligibilityFlow {
  NOT_ELIGIBLE
  ELIGIBLE
  CHANGE_THROUGH_OLD_FLOW @deprecated
  ESTIMATED_PRICES
  THIRD_PARTY
  ELIGIBLE_COMPLETE_TRIP_AND_PARTIAL
  ELIGIBLE_ONLY_PARTIAL
  CALL
}

enum ModifiableResult {
  IMMEDIATE_DEPARTURE
  REQUEST_IN_PROGRESS
  TRIP_IN_THE_PAST
  INCIDENT_PRESENT
  NOT_CONFIRMED_BOOKING
  IMMEDIATE_DEPARTURE_ONLY_INBOUND_PROCESSABLE
  TRIP_IN_THE_PAST_ONLY_INBOUND_PROCESSABLE
  PROCESSABLE
}

enum LegToChange {
  OUTBOUND
  INBOUND
  WHOLE_TRIP
}

enum FlexibleProduct {
  WARRANTY_INTERNAL_FLEXSELF
  INSURANCE_REBOOKING_FLEXRB156
  INSURANCE_FLEXUK164
  INSURANCE_AXA_REBOOKING_FLEXRB160
  INSURANCE_FLEX_AX04
  UNKNOWN
}

type EligibilityResponse {
  eligibilityFlow: EligibilityFlow!
  hasPenalty: Boolean
  useAutocollection: Boolean
  estimated: Boolean
  bookingInfo: BookingInfo
}

type BookingInfo {
  feePerPassenger: Money
  totalFee: Money
}

input ModifiableRequest {
  bookingId: Long!
  bookingItemId: Long!
  email: String!
}

type ModifiableResponse {
  modifiable: ModifiableResult!
}

input EligibilityForIncidentRequest {
  bookingId: ID!
  providerBookingItemId: ID!
}

type EligibilityForIncidentResponse {
  eligible: Boolean!
}

input SearchAlternativesForIncidentRequest {
  bookingId: ID!
  bookingItemId: ID!
  providerBookingItemId: ID
  changeNewDepartureDate: String @dateISO8601
  changeNewReturnDate: String @dateISO8601
}

type SearchAlternativesForIncidentResponse {
  canSearchForAlternatives: Boolean!
  itineraryResults: [AlternativeItineraryForIncident!]!
}

type AlternativeItineraryForIncident {
  alternativeItineraryId: ID!
  legs: [TripLeg!]!
}

input AcceptAlternativeRequest {
  incidentId: ID!
  alternativeFlights: [AlternativeFlight!]!
}

input AlternativeFlight {
  flightNumber: String!
  bookingClass: String
  departureDate: String! @dateISO8601
  departureAirport: String!
  arrivalAirport: String!
}

type AcceptAlternativeResponse {
  success: Boolean!
}

type AcceptAgentAlternativeResponse {
  alternativeId: ID!
}

input AcceptAgentAlternativeRequest {
  incidentId: ID!
  alternativeId: ID!
}

input AddItineraryModificationRequest {
  tripDetailsToken: String!
  departureDate: String! @dateISO8601
  returnDate: String @dateISO8601
  bookingItemId: Long!
}

type AddItineraryModificationResponse {
  modificationId: ID!
}

input ItinerarySearchAlternativeRequest {
  bookingId: Long!
  bookingItemId: Long!
  departureDate: String @dateISO8601
  returnDate: String @dateISO8601
  departureIata: String
  destinationIata: String
  tripType: TripType!
  legToChange: LegToChange!
  passengerIndexes: [Int!]
}

type ItinerarySearchAlternativeResponse {
  alternativeFareItineraries: [AlternativeFareItinerary!]! @deprecated(reason: "changed name in field response due to frontend developers request")
  itineraryResults: [AlternativeFareItinerary!]!
}

type AlternativeFareItinerary {
  alternativeFareItineraryId: ID!
  price: ModificationPrice
  legs: [TripLeg!]!
}

type ModificationPrice {
  amount: Float @bigdecimal
  difference: Float @bigdecimal
  penalty: Float @bigdecimal
  fee: Float @bigdecimal
  currency: String
  estimated: Boolean
}

input ChangeItineraryRequest {
  alternativeFareItineraryId: ID!
}

type ChangeItineraryResponse {
  modificationId: ID!
  bookingId: Long
  discarded: Boolean!
  creationTime: Long
  lastUpdate: Long
  items: [Item!]!
  price: ModificationPrice
}

type Item {
  itemId: ID!
  bookingItemId: Long!
  todId: Long
}

input FlexibleProductsApplicabilityRequest {
  bookingId: Long!
}

type FlexibleProductsApplicabilityResponse {
  flexibleProductsApplicable: [FlexibleProduct!]!
  flexibleProductsNotApplicable: [FlexibleProduct!]!
}

input MaximumReimbursementPriceRequest {
  bookingId: Long!
  bookingItemId: Long!
}

type MaximumReimbursementPriceResponse {
  maximumReimbursementPrice: Money!
}

enum NativeItineraryCalendarTripType {
  ROUND_TRIP
  ONE_WAY
}

enum NativeItineraryCalendarPriceLevel {
  HIGH
  AVERAGE
  CHEAP
}

input NativeItineraryCalendarRequest {
  originGeoNode: Int!
  destinationGeoNode: Int!
  departureDate: String!
  tripType: NativeItineraryCalendarTripType!
  adults: Int
  children: Int
  infants: Int
  calendarDaysFromDepartureDate: Int
}

type NativeItineraryCalendarResponse {
  levels: [NativeItineraryCalendarDay!]!
  thresholds: NativeItineraryCalendarThresholds
}

type NativeItineraryCalendarDay {
  level: NativeItineraryCalendarPriceLevel!
  date: String!
  price: Money!
}

type NativeItineraryCalendarThresholds {
  cheapThreshold: Money
  highThreshold: Money
}

input NextDynpackFunnelPageRequest {
  shoppingCartId: Long!
  currentPage: PageInput!
}

input NextItineraryFunnelPageRequest {
  shoppingCartId: Long!
  currentPage: PageInput!
}

enum NonEssentialProductProviderType {
  AON
  EDREAMS_ODIGEO
  ACE
  COVERMORE_TRAVEL_INSURANCE
  EUROP_ASSISTANCE
  CSA_TRAVEL_PROTECTION
  INTERMUNDIAL
  ELVIA
  IPP
  NOSUPP
  AMI
  EURA
  COVER_GENIUS
}

enum NonEssentialProductsThemeType {
  DEFAULT
  HIGHLIGHT
}

enum NonEssentialProductUrlType {
  SIMPLE
  EXTENDED
  IPID
  IMPORTANT_PRODUCT_INFORMATION
  PRE_CONTRACTUAL_INFORMATION
  PRE_CONTRACTUAL_INFORMATION_SUMMARY
  STATUS_DISCLOSURE_INFORMATION
  INTERMEDIATION_SERVICE_AGREEMENT
}

enum NonEssentialProductsModalFeatureType {
  EXCLUSIONS
  BENEFITS
  ATTACHABLE
  DUAL_CONTRACT
}

enum SmsNotificationProductType {
  ITINERARY
  ACCOMMODATION
  DYNPACK
}

input NonEssentialProductsRequest {
  bookingId: Long!
  products: [NonEssentialProductsIdRequest]!
  feeSelected: FeeSelected = FULL_PRICE
}

input NonEssentialProductsIdRequest {
  id: String!
}

input SelectNonEssentialProductsRequest {
  products: [ProductSelection]!
  shoppingBasketId: ShoppingBasketId!
}

type NonEssentialProductsOfferResponse {
  insurances: [NonEssentialProductOffer]!
  rebooking: [NonEssentialProductOffer]!
  guarantees: [NonEssentialProductOffer]!
  disruptions: [NonEssentialProductOffer!]!
  serviceOptions: [ServiceOptionNonEssentialProductOffer]!
  additions: [ServiceOptionNonEssentialProductOffer]!
  fareRules: [ServiceOptionNonEssentialProductOffer]!
}

type NonEssentialInfoProduct implements Product {
  id: ProductId
  price: Money
  productInfo: NonEssentialProductsResponse
}

type NonEssentialProductsResponse {
  insurances: [NonEssentialProduct]!
  rebooking: [NonEssentialProduct]!
  guarantees: [NonEssentialProduct]!
  disruptions: [NonEssentialProduct!]!
  serviceOptions: [NonEssentialProduct]!
  additions: [NonEssentialProduct]!
  fareRules: [NonEssentialProduct]!
  fastTracks: [NonEssentialProductFastTrack!]!
}

type NonEssentialPayWithProductResponse {
  products: [PayWithProductOffer]!
}

type NonEssentialProductOffer {
  product: NonEssentialProduct
  uiConfig: NonEssentialProductsUIConfig
  mandatory: Boolean
}

type NonEssentialProductFastTrack {
  price: Price!
}

type ServiceOptionNonEssentialProductOffer {
  nonEssentialProduct: NonEssentialProductOffer
  innerProducts: [ServiceOptionProduct]
}

union ServiceOptionInnerProductUnion = SimpleProduct | MonitoringAlert | InnerInsurance | SmsNotification

type ServiceOptionProduct {
  order: Int
  innerProduct: ServiceOptionInnerProductUnion
}

type MonitoringAlert {
  id: String!
  monitoringAlertList: [String]
}

type SmsNotification {
  id: String!
  countries: [String]
  smsNotificationType: SmsNotificationProductType
}

type InnerInsurance {
  offerId: String!
  urls: [NonEssentialProductUrl]
  provider: NonEssentialProductProviderType
}

type SimpleProduct {
  id: String
  description: String
  provider: NonEssentialProductProviderType
}

type NonEssentialProduct {
  offerId: String!
  id: String
  provider: NonEssentialProductProviderType
  urls: [NonEssentialProductUrl]!
  price: Price!
  totalPrice: Price
  farePrice: Price
  compensation: Money
  totalCompensation: Money
  premiumTaxPercentage: Float @bigdecimal
}

type NonEssentialProductUrl {
  url: String!
  urlType: NonEssentialProductUrlType!
}

type NonEssentialProductsModal {
  active: Boolean!
  features: [NonEssentialProductsModalFeatureType]
}

type NonEssentialProductsUIConfig {
  prechecked: Boolean
  theme: NonEssentialProductsThemeType
  availableNags: [NagType]
  modal: NonEssentialProductsModal
  dualContractTerms: Boolean
  compensation: Money @deprecated
}

input ProductSelection {
  offerId: String!
}

type SelectNonEssentialProductsResponse {
  productId: [ProductId]!
}

type PayWithProductOffer {
  offerId: String!
  id: String!
  urls: [NonEssentialProductUrl]!
  price: Money!
  nonDiscountedPrice: Money!
}

input SelectNonEssentialInsurancesProductsRequest {
  shoppingId: String!
  productsToAdd: [String!]
  productsToRemove: [String!]
}

input SelectNonEssentialPostsellProductsRequest {
  shoppingId: String!
  buyerPhone: PhoneInput!
  productsToAdd: [PostsellToAdd!]
  productsToRemove: [String!]
}

input PostsellToAdd {
  offerId: String!
  monitoringAlertId: [String!]
  smsNotificationId: [String!]
}

enum PriceLogic {
  MINIMUM_PURCHASE_PRICE_WITH_DISCOUNT
  NO_PRICE
  FULL_PRICE
  BEST_PRICE
}

enum CreditCardsType {
  VISA_CREDIT
  MASTER_CARD_CREDIT
  DINERS_CLUB
  VISA_DEBIT
  MASTER_CARD_DEBIT
  AMEX
  VISA_ENTROPAY
  MASTER_CARD_EDREAMS
  MASTER_CARD_PREPAID_IT
  CARTA_EDREAMS
  MASTER_CARD_PREPAID
  MASTER_CARD_CONSUMER_DEBIT
  VISA_VUELING
  VISA_ELECTRON
  CARTE_BLUE
  VISA_DEBIT_DELTA
  MAESTRO
  JBC
  EDREAMS_PREPAID
  MASTER_CARD_SPANISH_CREDIT
  AMEX_CONSUMER_CARD
  VIABUY_PREPAY_MASTER_CARD
  COFINOGA
  COFINOGA_CARTE_OPODO
  NOT_FOUND
}

enum PaymentMethod {
  ALIPAY
  APPLEPAY
  BANKTRANSFER
  CASH
  CREDITCARD
  COFINOGA
  DOTPAY
  ELV
  GIROPAY
  GOOGLEPAY
  IDEAL
  INSTALLMENT
  KLARNA
  KLARNA_ACCOUNT
  MULTIBANCO
  PAYPAL
  PREPAY
  POLI
  SAMSUNGPAY
  SECURE3D
  SEPADD
  SOFORT
  TRAVEL_ACCOUNT
  TRUSTLY
  UNIONPAY
  UNKNOWN
}

enum MethodTypeCode {
  AD
  AX
  AB
  TA
  DL
  E1
  EA
  VD
  VI
  VV
  RV
  TV
  VE
  CA
  EC
  MD
  MC
  M6
  M4
  MP
  MF
  HS
  MI
  RM
  CM
  VB
  TE
  TF
  DM
  EY
  MA
  CB
  DC
  DS
  JC
  ER
  TD
  TP
  CF
  CO
  TC
}

enum IdealIssuerBankType {
  ABN_AMRO
  ASN
  BUNQ
  ING
  KNAB
  RABOBANK
  REGIOBANK
  REVOLUT
  SNS
  TRIODOS
  VAN_LANSCHOT
  YOURSAFE
  N26
  NATIONALE_NEDERLANDEN
}

type ShoppingCartPaymentInformation {
  collectionOptions: [CollectionMethod!]!
  priceLogic: PriceLogic!
}

type CollectionMethod {
  creditCardType: CreditCardType
  creditCardLevel: CreditCardLevel
  id: String!
  type: PaymentMethod
  fee: Float! @bigdecimal @deprecated
  feeMoney: Money!
  isChosenMethod: Boolean!
}

type CreditCardType {
  code: String
  name: String
}

type CreditCardLevel {
  code: String
}

type CreditCardBinDetails {
  creditCardBin: String!
  creditCardCountryCode: String
  creditCardLevel: String
  creditCardTypeCode: String
  isPrimeBlocking: Boolean
}

type CreditCardDateDetailsResponse {
  isValidDateForPrime: Boolean
}

type UserCreditCardsResponse {
  creditCards: [CreditCards!]
}

type CreditCards implements RecurringCollectionPaymentInstrument {
  id: Long
  creditCardNumber: String
  expirationDateMonth: String
  expirationDateYear: String
  owner: String
  creationDate: String
  modifiedDate: String
  lastUsageDate: String
  isDefault: Boolean
  creditCardTypeId: CreditCardsType
  creditCardCode: String
  paymentInstrumentTokenWithoutCvv: String!
}

type PaypalAccount implements RecurringCollectionPaymentInstrument {
  email: String!
  paymentInstrumentToken: ID!
  isDefault: Boolean
}

type IdealAccount implements RecurringCollectionPaymentInstrument {
  idealIssuerBank: IdealIssuerBankType!
  paymentInstrumentToken: ID!
  isDefault: Boolean
}

input CollectionMethodRequest {
  collectionMethodId: String
  paymentInstrumentToken: String!
  collectionMethodType: PaymentMethod!
  methodTypeCode: MethodTypeCode
  issuerBankType: IdealIssuerBankType
}

input CollectionMethodInfo {
  collectionMethodType: PaymentMethod
  collectionMethodCode: MethodTypeCode
}

type NonPciScopeCreditCard {
  last4NumberDigits: String!
}

type NonPciScopeCreditCardResponse {
  creditCard: NonPciScopeCreditCard!
}

input NonPciScopeCreditCardRequest {
  paymentInstrumentToken: String!
}

type ItineraryPriceFreezeOffer {
  searchCriteria: ItinerarySearchCriteria!
  itinerary: Itinerary! @deprecated(reason: "use itineraryPriceFreezeItinerary")
  itineraryPriceFreezeItinerary: ItineraryPriceFreezeItinerary!
  offer: PriceFreezeOffer
  available: Boolean! @deprecated(reason: "not used anymore")
}

type PriceFreezeOffer {
  id: ID!
  purchaseDate: String! @dateISO8601
  expirationDate: Long!
  frozenPrimePrice: Money! @deprecated(reason: "use frozenPrice")
  frozenPrice: Money!
  deposit: Money!
  cap: Money!
  offerType: PriceFreezeOfferType!
}

type PaxNumber {
  numAdults: Int!
  numChildren: Int!
  numInfants: Int!
}

input PriceFreezeEligibilityRequest {
  paxNumber: PaxNumberInput!
  tripType: TripType!
  departureDate: Long!
}

input PaxNumberInput {
  numAdults: Int!
  numChildren: Int!
  numInfants: Int!
}

type PriceFreezeEligibility {
  isEligible: Boolean!
  expirationDays: Int
}

input PriceFreezeOfferRequest {
  searchId: ID!
  fareItineraryKey: ID!
  segmentKeys: [Int!]!
}

type PriceFreezeShoppingBundleProduct implements Product {
  id: ProductId
  price: Money
  productInfo: PriceFreezeShoppingBundleProductInfo
}

type PriceFreezeShoppingBundleProductInfo {
  frozenPrice: Money
}

enum PriceFreezeOfferType {
  NON_PRIME
  PRIME
}

input CreatePriceFreezeRequest {
  itineraryPriceFreeze: CreateItineraryPriceFreezeRequest!
  shoppingBasketId: ID!
  contactDetails: PriceFreezeContactDetails!
}

input PriceFreezeContactDetails {
  email: String!
  phone: PhoneInput!
}

input CreateItineraryPriceFreezeRequest {
  offerId: ID!
  pax: [TravellerInput!]!
  buyerEmail: String!
  repricing: RepricingInformationInput
}

input RepricingInformationInput {
  totalPriceDifference: MoneyRequest
}

type ItineraryPriceFreeze {
  id: ID!
  bookingId: Long!
  feeContainerId: Long
  status: PriceFreezeStatus!
  itinerary: Itinerary @deprecated(reason: "use itineraryPriceFreezeItinerary")
  itineraryPriceFreezeItinerary: ItineraryPriceFreezeItinerary
  condition: FrozenCondition!
  itineraryPriceFreezeRedemptionId: ItineraryPriceFreezeRedemptionId
}

type ItineraryPriceFreezeItinerary {
  primePrice: Money!
  nonPrimePrice: Money
  primeAndNonPrimePricesDifference: Money
  numAdults: Int!
  numChildren: Int
  numInfants: Int!
  type: ItineraryPriceFreezeTripType!
  segments: [ItineraryPriceFreezeSegment]!
}

type ItineraryPriceFreezeSegment {
  referenceKey: String!
  sections: [ItineraryPriceFreezeSection]!
}

type ItineraryPriceFreezeSection {
  duration: Long!
  departureDate: String! @yyyyMMddTHHmmssZZZZZ
  arrivalDate: String! @yyyyMMddTHHmmssZZZZZ
  departureLocation: Location!
  destinationLocation: Location!
  marketingCarrierCode: String!
}

enum ItineraryPriceFreezeTripType {
  ONE_WAY
  ROUND_TRIP
  XFARING
  ONE_WAY_AS_A_ROUND_TRIP
  HUB
  MULTI_DESTINATION
}

input ItineraryPriceFreezesRequest {
  customerEmail: String!
}

type FrozenCondition {
  purchaseDate: String @yyyyMMddTHHmmssZZZZZ
  expirationDate: String! @yyyyMMddTHHmmssZZZZZ
  price: Money! @deprecated(reason: "use frozenPrice for consistency")
  frozenPrice: Money!
  deposit: Money!
  cap: Money!
  redemptionPolicy: RedemptionPolicy!
  primeMembershipActivationPolicy: PrimeMembershipActivationPolicy
}

type RedemptionPolicy {
  primeMembershipRequired: Boolean!
}

type PrimeMembershipActivationPolicy {
  primeMembershipActivationRequiredIfNotPrimeMember: PrimeMembershipType!
}

enum PrimeMembershipType {
  PLUS
}

enum PriceFreezeStatus {
  AVAILABLE
  EXPIRED
  REDEEMED
  CANCELLED
  SELECTED
}

type ItineraryPriceFreezeRedemption {
  itineraryPriceFreeze: ItineraryPriceFreeze!
  itineraryPriceFreezeRedemptionOption: ItineraryPriceFreezeRedemptionOption
  itineraryPriceFreezeRedemptionCalculatedParams: ItineraryPriceFreezeRedemptionMoneyCalculatedValues
}

input ItineraryPriceFreezeRedemptionRequest {
  id: ID!
}

type ItineraryPriceFreezeRedemptionMoneyCalculatedValues {
  minorItineraryPriceMinusDeposit: Money!
  itineraryPriceIncreasedAmount: Money!
  overTheCapAmount: Money!
}

type ItineraryPriceFreezeRedemptionOption {
  reference: ID!
  itineraryPriceFreezeFareItinerary: ItineraryPriceFreezeFareItinerary!
  sellingPrice: Money!
}

type ItineraryPriceFreezeFareItinerary {
  price: Money!
  segments: [ItineraryPriceFreezeSegment]!
}

type ItineraryPriceFreezeRedemptionId {
  id: ID
  itineraryPriceFreezeRedemptionType: ItineraryPriceFreezeRedemptionType
}

enum ItineraryPriceFreezeRedemptionType {
  ITINERARY
  REFUND
}

input ItineraryPriceFreezeRevenueDataRequest {
  itineraryPriceFreezeId: ID!
}

type ItineraryPriceFreezeRevenueData {
  itineraryPriceFreezeId: ID!
  revenue: Money!
  redemptionRate: Float!
}

type RecaptchaConfigResponse {
  recaptchaV2: RecaptchaConfigV2!
  recaptchaV3: RecaptchaConfigV3!
}

type RecaptchaConfigV2 {
  isEnabled: Boolean!
  siteKey: String!
}

type RecaptchaConfigV3 {
  isEnabled: Boolean!
  siteKey: String!
}

input RegisterRecaptchaV3TokenRequest {
  token: String!
  action: String!
}

type RegisterRecaptchaV3TokenResponse {
  success: Boolean!
}

type ResendConfirmationEmailResponse {
  isSuccessful: Boolean!
}

input ResidentDiscountRequest {
  departureIata: String!
  arrivalIata: String!
}

type ResidentDiscountResponse {
  zones: [ResidentGroup]!
}

input RDataRequest {
  products: [ProductIdRequest]!
}

type RDataResponse {
  rMarketing: Float! @bigdecimal
  rSem: Float! @bigdecimal
}

enum ItineraryResultPriceType {
  CHEAPEST
  MEMBER_PRICE_POLICY_DISCOUNTED
  MEMBER_PRICE_POLICY_UNDISCOUNTED
  MEMBER_PRICE_POLICY_DISCOUNTED_PLUS_COUPON
}

type ItinerarySearchResponse {
  searchId: Long!
  searchCode: SearchCode
  priceTypeDisplayed: ItineraryResultPriceType
  isRebookingAvailable: Boolean!
  carriersWithRebooking: [String!]
  itineraries: [ItinerarySearchResult!]!
  trackingInfo: TrackingInfo
  externalSelection: ExternalSelection
  freeCancellationItineraryIds: [String!]
  carriers: [CarrierValue!]!
  locations: [LocationValue!]!
  campaignConfigs: [CampaignConfigValue!]!
  fees: [FeeTypeValue!]!
  carbonFootprints: [CarbonFootprintValue!]!
  insuranceOffers: [InsuranceOfferValue!]!
  campaignsItineraryLists: [Campaign!]!
  itineraryAlternativesList: [ItineraryAlternativeList!]! @deprecated(reason: "No longer used on frontend")
}

type ItineraryAlternativeList {
  itineraryId: ID!
  alternativeItineraries: [AlternativeItinerary!]!
}

type AlternativeItinerary {
  id: ID!
  cashback: Money!
}

type ItinerarySearchResult {
  id: ID!
  key: String!
  ticketsLeft: Int!
  legs: [ItinerarySearchResultLeg!]
  transportTypes: [TransportType!]
  meRating: Float! @bigdecimal
  fees: [SearchResponseFee!]!
  perks: Perks
  carbonFootprintId: ID
  campaignConfigId: ID
  hotelXSellingEnabled: Boolean!
  isFareUpgradeAvailable: Boolean!
}

type InsuranceOfferValue {
  id: ID!
  insuranceOffer: InsuranceOffer!
}

type SearchResponseFee {
  price: Money!
  type: String!
}

type FeeTypeValue {
  id: String!
  type: FeeType!
}

type CampaignConfigValue {
  id: ID!
  campaignConfig: CampaignConfig!
}

type CarbonFootprintValue {
  id: ID!
  carbonFootprint: CarbonFootprint!
}

type CarrierValue {
  id: String!
  carrier: Carrier!
}

type LocationValue {
  id: ID!
  location: Location!
}

type ItinerarySearchResultLeg {
  segmentKeys: [Int!]!
  segments: [ItinerarySearchResultSegment!]!
}

type ItinerarySearchResultSegment {
  id: ID!
  carrierId: ID!
  duration: Long
  sections: [ItinerarySearchResultSection!]!
  baggageCondition: BaggageCondition!
  transportTypes: [TransportType!]!
}

type ItinerarySearchResultSection {
  id: ID!
  arrivalDate: String! @dateISO8601
  departureDate: String! @dateISO8601
  departureId: ID!
  destinationId: ID!
  arrivalTerminal: String
  departureTerminal: String
  carrierId: ID!
  operatingCarrierId: ID
  commercialBrandId: ID
  cabinClass: CabinClass
  flightCode: String!
  duration: Long
  insuranceOfferId: ID
  technicalStops: [TechnicalStop!]!
  transportType: TransportType
  vehicleModel: String
}

input SearchRequest {
  buyPath: Int
  tripType: TripType!
  itinerary: ItineraryRequest!
  headers: Headers
}

type SearchResponse {
  searchId: Long!
  searchCode: SearchCode
  defaultFeeType: FeeType
  isRebookingAvailable: Boolean!
  carriersWithRebooking: [String!]!
  itineraries: [Itinerary!]!
  trackingInfo: TrackingInfo
  externalSelection: ExternalSelection
  freeCancellationItineraryIds: [String!] @deprecated(reason: "You can find the same information in campaignsItineraryLists.campaignsItineraryLists")
  campaignsItineraryLists: [Campaign!]
  itineraryAlternativesList: [ItineraryAlternativeList!]! @deprecated(reason: "No longer used on frontend")
}

type Campaign {
  campaignKey: String!
  campaignItineraryIds: [String!]!
}

type SearchCriteria {
  accommodation: AccommodationSearchCriteria
  itinerary: ItinerarySearchCriteria
}

type ItinerarySearchCriteria {
  pax: PaxNumber!
  buyPath: Int
  cabinClass: String
  resident: Boolean
  segment: [SegmentSearchCriteria!]
  tripType: TripType
  metaSelectedCollectionMethod: Int
}

type SegmentSearchCriteria {
  date: String!
  departureGeoNode: Int!
  departureIata: String!
  destinationGeoNode: Int!
  destinationIata: String!
}

input Headers {
  visit: String
  ofJsession: String
}

type TrackingInfo {
  returningUserDeviceId: String!
  airlinePositionTracking: [AirlineTracking!]
  airlineSteeringTracking: [AirlineTracking!]
}

type AirlineTracking {
  carrier: String!
  sortingPosition: [TrackingPosition!]!
  preBoostingPosition: [TrackingPosition!]
}

type TrackingPosition {
  position: Int!
  crossFaring: Boolean!
  itineraryId: String!
}

type ExternalSelection {
  id: ID!
  segmentKeys: [String!]!
}

input ItineraryRequest {
  numAdults: Int!
  numChildren: Int!
  numInfants: Int!
  cabinClass: String
  resident: Boolean!
  mainAirportsOnly: Boolean!
  segments: [SegmentRequest!]!
  externalSelection: ExternalSelectionRequest
  excludeCarriers: Boolean
}

type Perks {
  primeDiscount: Money
  extraPrimeCoupon: Money
  alternativeItineraryDiscount: Money
  primeDiscountPerPassenger: Money
  extraPrimeCouponPerPassenger: Money
  alternativeItineraryDiscountPerPassenger: Money
}

type AccommodationSearchCriteria {
  checkInDate: String!
  checkOutDate: String!
  destination: LocationSearchCriteria!
  roomRequests: [RoomSearchCriteria!]!
  searchType: AccommodationSearchType
  isCurrentUserSearch: Boolean
}

type LocationSearchCriteria {
  iata: String
  geoNodeId: Int
}

type RoomSearchCriteria {
  numAdults: Int!
  childrenAges: [Int]
}

type ItinerarySearchCriteriaSelection {
  fareItineraryKey: String!
  segmentKeys: [String!]!
}

input SemIsReturningCustomerRequest {
  email: String!
  bookingId: Long!
}

type SemIsReturningCustomerResponse {
  isReturning: Boolean!
}

input SemNumberOfBookingsByTokenRequest {
  token: String!
}

type SemNumberOfBookingsByTokenResponse {
  numberOfBookings: Long!
}

input SemItinerariesSearchRequest {
  tripType: TripType!
  itinerary: SemItineraryRequest!
}

input SemSearchRequest {
  tripType: TripType!
  itinerary: SemItineraryRequest!
}

type SemSearchResponse {
  itineraries: [SemItinerary!]!
  priceTypeDisplayed: FeeType!
}

type SemItinerariesSearchResponse {
  itineraries: [SemItinerary!]!
  priceTypeDisplayed: FeeType!
}

input SemItineraryRequest {
  segments: [SemSegmentRequest!]!
}

input SemSegmentRequest {
  departure: LocationRequest!
  destination: LocationRequest!
}

type SemItinerary {
  legs: [SemLeg!]!
  transportTypes: [TransportType!]!
  ticketsLeft: Int!
  fees: [Fee!]!
}

type SemLeg {
  segments: [SemSegment!]!
}

type SemSegment {
  carrier: Carrier!
  sections: [SemSection!]!
  baggageCondition: BaggageCondition!
  transportTypes: [TransportType!]!
  duration: Long!
}

type SemSection {
  departureDate: String! @dateISO8601
  arrivalDate: String! @dateISO8601
  departure: Location!
  destination: Location!
  carrier: Carrier!
  flightCode: String!
  transportType: TransportType!
  duration: Long!
}

input SemItinerarySelectionRequest {
  buyPath: Int!
  tripType: TripType!
  itinerarySearchRequest: SemItinerarySelectRequest!
  selectDealSegmentFlightNumbers: [SemSelectDealSegmentFlightNumberRequest!]!
}

input SemItinerarySelectRequest {
  numAdults: Int
  numChildren: Int
  numInfants: Int
  resident: Boolean
  mainAirportsOnly: Boolean
  segments: [SemSelectSegmentRequest!]!
}

input SemSelectSegmentRequest {
  date: String! @yyyyMMdd
  departure: LocationRequest!
  destination: LocationRequest!
}

input SemSelectDealSegmentFlightNumberRequest {
  flightNumbers: [String!]!
}

type SemItinerarySelectionResponse {
  searchId: Long!
  itineraries: [Itinerary!]!
  trackingInfo: TrackingInfo!
}

enum PromoCodeActions {
  ADD
  REMOVE
}

enum ProductActionResponseCode {
  PRODUCT_ADDED
  PRODUCT_NO_ADDED
  PRODUCT_NO_OFFERED
  PRODUCT_REQUEST_NO_VALID
  PROMO_CAMPAIGN_MAX_REACHED
  PROMO_CAMPAIGN_CODE_INVALID
  PROMO_BRAND_ERROR
  PROMO_CAMPAIGN_MAX_EXCEEDED
  PROMO_CAMPAIGN_MAX_USAGES_REACHED
}

enum PromotedItineraryType {
  DEFAULT
  ODI_RATING
  PERSONALIZED
  GREENER_CHOICE
}

input ShoppingBundleRequest {
  shoppingInfo: ShoppingInfo
}

input ShoppingSummaryRequest {
  searchId: ID!
  fareItineraryKey: String!
  segmentKeys: [Int!]!
  feeSelected: FeeSelected!
  collectionMethodId: Int = -1
  isMeta: Boolean = false
}

type ShoppingSummary {
  products: [Product!]!
  buyer: Buyer
  travellers: [ShoppingTraveller!]
  totalNumPassengers: Int!
}

type ShoppingBundle {
  shoppingId: ID!
  membershipPerks: MembershipPerks
  products: [Product!]
  buyer: Buyer
  promoCodeInfo: PromoCodeInfo
  travellers: [ShoppingTraveller]!
  hasSpecialRequirements: Boolean! @deprecated(reason: "Use hasSpecialRequirements in showConfig")
  showConfig: ShowConfig!
  forms: FormProperties
  repricing: RepricingInfo
}

type FormProperties {
  fields: FormGroups!
  requiredInformation: RequiredInformation!
}

type RequiredInformation {
  traveller: [TravellerInformationDescription!]!
  buyer: BuyerInformationDescription!
}

type PromoCodeInfo {
  totalDiscount: Money!
  promoCodes: [PromoCode!]
}

input CreateShoppingBundleRequest {
  shoppingType: ShoppingType!
  searchId: String!
  segmentKey: [String!]!
  promotedItineraryTypes: [PromotedItineraryType!]
  fareItineraryKey: String!
  resident: Boolean = false
  preview: Boolean = false
  extension: [Extension!]
}

input Extension {
  name: String!
  value: String!
}

type CreateShoppingBundleResponse {
  shoppingBundle: ShoppingBundle!
  repricing: RepricingInfo
}

input DuplicateShoppingBundleRequest {
  shoppingId: ID!
  shoppingType: ShoppingType!
}

type DuplicateShoppingBundleResponse {
  shoppingId: ID
}

input AddPersonalInfoRequest {
  shoppingInfo: ShoppingInfo!
  travellers: [ShoppingTravellerInput!]!
  buyer: BuyerInput!
  saveContactDetails: Boolean
}

type AddPersonalInfoResponse {
  shoppingBundle: ShoppingBundle!
}

interface Product {
  id: ProductId
  price: Money
}

input PromoCodeRequest {
  shoppingInfo: ShoppingInfo!
  action: PromoCodeActions!
  promoCode: [String!]!
}

type PromoCodeResponse {
  success: Boolean!
  code: ProductActionResponseCode
  promoCodeInfo: PromoCodeInfo
}

type PromoCode {
  code: String!
  amount: Money
}

input GetShoppingBookingIdRequest {
  shoppingInfo: ShoppingInfo!
}

input ChangePaxNumberRequest {
  shoppingInfo: ShoppingInfo!
  fareItineraryKey: String!
  segmentKeys: [String!]!
  pax: PaxNumberInput!
  flightNumbers: [String!]
  extensions: [Extension!]
  promotedItineraryTypes: [PromotedItineraryType!]
}

type ShoppingCart {
  bookingId: Long!
  membershipPerks: MembershipPerks
  itinerary: Itinerary
  accommodationShoppingItem: AccommodationShoppingItem
  buyer: Buyer
  membershipPerksFee: Float @bigdecimal @deprecated(reason: "perks are included in membershipPerks field")
  travellers: [ShoppingCartTraveller!]! @deprecated(reason: "Use ShoppingBundle query, travellers field")
  requiredTravellerInformation: [TravellerInformationDescription!]!
  requiredBuyerInformation: BuyerInformationDescription!
  totalPrice: Float! @bigdecimal @deprecated(reason: "This attribute will move to price as Money ")
  price: Money!
  baggageTotalFee: Float @bigdecimal
  collectionTotalFee: Float @bigdecimal
  formGroups: FormGroups!
  paymentInformation: ShoppingCartPaymentInformation @deprecated
  collectionMethods: AvailableCollectionMethodsResponse
  nonEssentialProducts: NonEssentialProductsResponse
  marketingRevenueData: MarketingRevenueData
}

input ItineraryTraveller {
  name: String!
  lastNames: String!
}

input CanApplyItineraryDiscountRequest {
  bookingId: Long!
  buyerEmail: String!
  travellers: [ItineraryTraveller!]!
}

type CanApplyItineraryDiscountResponse {
  value: Boolean!
}

input CreateShoppingCartRequest {
  fareItineraryKey: String!
  flightNumbers: [String!]!
  priceWithoutDiscountSelected: Boolean = false
  extensions: [Extension!]
  searchId: String!
  segmentKeys: [String!]!
  promotedItineraryTypes: [PromotedItineraryType!]
  resident: Boolean = false
  preview: Boolean = false
}

type CreateShoppingCartResponse {
  shoppingCart: ShoppingCart!
}

type ShowConfig {
  hasSpecialRequirements: Boolean!
  nonTransparentFeeMessage: Boolean!
  hasPromoCode: Boolean!
  hasIdInParticularInvoice: Boolean!
}

input NewsletterSubscriptionRequest {
  email: String!
  campaign: String!
}

type NewsletterSubscriptionResponse {
  email: String!
  campaign: String!
}

input UnsubscriptionRequest {
  email: String!
  url: String!
}

type UnsubscriptionResponse {
  email: String!
}

type SubscriptionFdoResponse {
  email: String!
}

enum SubscriptionOfferType {
  BASIC
  PLUS
}

enum SubscriptionOfferPeriod {
  FREE_TRIAL
  PAID
}

enum SubscriptionOfferTimeUnit {
  DAYS
  MONTHS
}

type SubscriptionOfferDuration {
  amount: Int!
  timeUnit: SubscriptionOfferTimeUnit!
}

type SubscriptionResponse {
  productId: Long!
  offerId: String!
  fee: Money! @deprecated(reason: "This value is the same as in price, which maps to the real response object.")
  price: Money!
  renewalPrice: Money!
  totalCommitment: Money
  duration: SubscriptionOfferDuration!
  renewalDuration: SubscriptionOfferDuration!
  subscriptionPeriod: SubscriptionOfferPeriod!
  type: SubscriptionOfferType
  catalogueOffer: MembershipOffer
}

type MembershipOffer {
  membershipOfferId: String!
  plan: MembershipPlan!
}

type MembershipPlan {
  planName: PlanName!
  membershipTier: MembershipTier!
}

enum PlanName {
  BASIC
  DISCOVERY
  EMPLOYEE
  PLUS
  UNKNOWN
}

type MembershipTier {
  membershipTierId: String!
  policies: MembershipTierPolicies!
  valueProposition: [MembershipOfferPerk!]!
  loyaltyRewardsProgram: LoyaltyRewardsProgram
}

type MembershipTierPolicies {
  autoRenewalPolicy: AutoRenewalPolicy!
  freeTrialPolicy: FreeTrialPolicy
  durationPolicy: SubscriptionOfferDuration!
}

type AutoRenewalPolicy {
  deactivationConditions: [AutoRenewalDeactivationCondition!]!
}

enum AutoRenewalDeactivationCondition {
  UNKNOWN
  DEACTIVATION_ALLOWED_AFTER_12_CONSECUTIVE_MONTHLY_RENEWALS
  DEACTIVATION_ALLOWED_AFTER_4_CONSECUTIVE_QUARTERLY_RENEWALS
}

type FreeTrialPolicy {
  duration: SubscriptionOfferDuration!
  valueProposition: [MembershipOfferPerk!]!
}

type LimitedMembershipPerk implements BaseMembershipPerk {
  type: MembershipPerkType!
  usageQuota: Int!
}

type UnlimitedMembershipPerk implements BaseMembershipPerk {
  type: MembershipPerkType!
}

union MembershipOfferPerk = LimitedMembershipPerk | UnlimitedMembershipPerk

input PriceAlertRequest {
  departureIata: String!
  arrivalIata: String!
  departureDate: String!
  arrivalDate: String!
  price: Float! @bigdecimal
  searchId: Long
  email: String!
  newsletterAccepted: Boolean!
  headers: Headers
}

type JoinTripAroundTheWorldContestResponse {
  isSubscribed: Boolean!
}

enum LoyaltyReward {
  MONTHLY_PROMO_CODE_REWARD_FOR_YEARLY_SUBSCRIPTION
  WELCOME_PROMO_CODE_REWARD_THREE_MONTHS_CLAIMABLE
  UNKNOWN
}

type LoyaltyRewardsProgram {
  loyaltyRewards: [LoyaltyReward!]!
}

input SubscriptionOffersRequest {
  touchpoint: Touchpoint!
}

input CalculateSubscriptionOfferRequest {
  funnel: Funnel!
  touchPoint: Touchpoint
}

enum Funnel {
  ACCOMMODATION_FUNNEL
  FUNNEL_BOOKING
  PRICE_FREEZE
  STANDALONE_POST_BOOKING
}

type CalculateSubscriptionOfferResponse {
  offerOptions: [OfferOption!]!
}

type OfferOption {
  offerOptionId: ID!
  price: Money!
  renewalPrice: Money!
  plan: PlanName!
  tier: MembershipTier!
}

type TopDestination {
  geoNodeId: Int!
  iataCode: String
  cityName: String
  countryName: String
}

type MarketingRevenueData {
  marketingRevenueList: [MarketingRevenue]
}

type MarketingRevenue {
  type: String!
  value: Float! @bigdecimal
}

enum TravellerAgeType {
  ADULT
  CHILD
  INFANT
}

enum TravellerMealType {
  STANDARD
  KOSHER
  HALAL
  LOW_CHOLESTEROL
  LOW_SODIUM
  VEGAN
  VEGETARIAN
  BABY
  CHILD
  DIABETIC
  GLUTEN_FREE
  HINDU
}

enum IdentificationType {
  PASSPORT
  NIE
  NIF
  CIF
  NATIONAL_ID_CARD
  BIRTH_DATE
}

enum TravellerTitleType {
  MR
  MRS
  MS
}

enum TravellerGender {
  MALE
  FEMALE
}

enum TravellerMeal {
  STANDARD
  KOSHER
  HALAL
  LOW_CHOLESTEROL
  LOW_SODIUM
  VEGAN
  VEGETARIAN
  BABY
  CHILD
  DIABETIC
  GLUTEN_FREE
  HINDU
}

enum ResidentGroup {
  CANARIAS
  BALEARES
  CEUTA
  MELILLA
}

enum TravellerInformationField {
  TITLE
  NAME
  MIDDLE_NAME
  FIRST_LAST_NAME
  SECOND_LAST_NAME
  BIRTH_DATE
  AGE
  GENDER
  COUNTRY_OF_RESIDENCE
  NATIONALITY
  IDENTIFICATION
  IDENTIFICATION_TYPE
  IDENTIFICATION_EXPIRATION_DATE
  IDENTIFICATION_COUNTRY
  RESIDENT
  PHONE_NUMBER
  MOBILE_NUMBER
  FREQUENT_FLYER_CARD_AIRLINE_CODE
  FREQUENT_FLYER_CARD_NUMBER
}

type TravellerInformationDescription {
  travellerType: TravellerAgeType!
  frequentFlyerAirlineGroups: [AirlineGroup!]
  availableMeals: [TravellerMealType!]
  identificationTypes: [IdentificationType!]
  needsTitle: RequiredFieldType!
  needsName: RequiredFieldType!
  needsGender: RequiredFieldType!
  needsNationality: RequiredFieldType!
  needsBirthDate: RequiredFieldType!
  needsCountryOfResidence: RequiredFieldType!
  needsIdentification: RequiredFieldType!
  needsIdentificationExpirationDate: RequiredFieldType!
  needsIdentificationCountry: RequiredFieldType!
  residentGroups: [ResidentGroupContainer]
  conditionallyNeededFields: [TravellerInformationFieldConditionRule]
  baggageConditions: [BaggageConditions!]!
}

type PersonalInfo {
  name: String!
  firstLastName: String
  secondLastName: String
  ageType: TravellerAgeType
  birthDate: String
  title: TravellerTitleType
  travellerGender: TravellerGender
  nationalityCountryCode: String
}

input PersonalInfoInput {
  name: String! @paxName
  firstLastName: String @paxName
  secondLastName: String @paxName
  birthDate: String
  travellerGender: TravellerGender
  ageType: TravellerAgeType
}

type ContactDetails {
  address: String
  city: String
  postalCode: String
  country: String
  phone: Phone
  email: String
}

input ContactDetailsInput {
  address: String
  city: String
  postalCode: String
  country: String
  phone: PhoneInput
  email: String
}

input TravellerInput {
  personalInfo: PersonalInfoInput
  contactDetails: ContactDetailsInput
}

type ShoppingCartTraveller {
  personalInfo: PersonalInfo!
  numPassenger: Int!
  identification: String
  identificationType: IdentificationType
  localityNameOfResidence: String
  localityCodeOfResidence: String
  countryCodeOfResidence: String
  identificationExpirationDate: String
  identificationIssueCountryCode: String
  meal: TravellerMeal
  frequentFlyerNumbers: [FrequentFlyerCard!]
}

type AirlineGroup {
  carriers: [Carrier!]!
}

type FrequentFlyerCard {
  carrier: String
  number: String
}

type ResidentGroupContainer {
  residentLocalities: [ResidentGroupLocality]
  name: ResidentGroup
}

type ResidentGroupLocality {
  code: String
  name: String
}

type TravellerInformationFieldConditionRule {
  travellerInformationFieldConditions: [TravellerInformationFieldCondition]
  conditionallyRequiredTravellerInformationField: TravellerInformationField
}

type TravellerInformationFieldCondition {
  travellerInformationField: String
  value: String
}

type BaggageSelection {
  allowanceChanged: Boolean!
  baggageApplicationLevel: BaggageApplicationLevel
  baggageDescriptorIncludedInPrice: BaggageDescriptor
  selectedBaggageDescriptor: [SelectableBaggageDescriptor!]
  segmentTypeIndex: SegmentTypeIndex
  numPassenger: Int!
}

type ShoppingTraveller {
  personalInfo: PersonalInfo!
  numPassenger: Int!
  identification: String
  identificationType: IdentificationType
  localityNameOfResidence: String
  localityCodeOfResidence: String
  countryCodeOfResidence: String
  identificationExpirationDate: String
  identificationIssueCountryCode: String
  meal: TravellerMeal
  frequentFlyerNumbers: [FrequentFlyerCard!]
  baggageSelections: [BaggageSelection!] @deprecated
}

input ShoppingTravellerInput {
  storedTravellerId: Long
  personalInfo: ShoppingPersonalInfoInput!
  contactDetails: ShoppingContactDetailsInput
  identificationDetails: IdentificationDetailsInput
  frequentFlyer: [FrequentFlyerCardInput!]
  meal: TravellerMeal
  nationalityCountryCode: String
}

input ShoppingPersonalInfoInput {
  title: TravellerTitleType
  name: String! @paxName
  firstLastName: String @paxName
  secondLastName: String @paxName
  middleName: String
  birthDate: String
  travellerGender: TravellerGender
  ageType: TravellerAgeType
}

input ShoppingContactDetailsInput {
  country: String
  localityCode: String
}

input IdentificationDetailsInput {
  identification: String
  identificationType: IdentificationType
  identificationExpirationDate: String
  identificationCountryCode: String
  nationalityCountry: String
}

input FrequentFlyerCardInput {
  carrier: String!
  number: String! @cardNumber
}

enum CrossSellProductType {
  ITINERARY
  ACCOMMODATION
  VEHICLE_RENTAL
}

enum ItineraryStatus {
  CONFIRMED
  PROCESSING
  FAILED
  CANCELLED
  PARTIALLY_CONFIRMED
}

enum AccommodationStatus {
  CONFIRMED
  PROCESSING
  CANCELLED
}

enum VehicleRentalStatus {
  CONFIRMED
  CANCELLED
}

enum ItinerarySectionType {
  FLIGHT
  TRAIN
}

input TravelPlansImportBookingRequest {
  email: String! @email
  bookingId: Long!
}

input TravelPlansImportBookingByTripDetailsTokenRequest {
  token: String!
}

type TravelPlansImportBookingResponse {
  travelPlans: TravelPlansResponse! @deprecated
  bookingId: Long!
}

type TravelPlansResponse {
  upcoming: [TravelPlan!]! @deprecated
}

type TravelPlan {
  id: ID!
  title: String!
  imageUrl: String
  startDateTime: String! @yyyyMMddTHHmmssZZZZZ
  products: [TravelPlanProduct!]! @deprecated
}

interface TravelPlanProduct {
  id: ID!
  type: ProductType!
  booking: Booking! @deprecated(reason: "the booking has to be nullable")
  crossSellRecommendations: [CrossSellProductType!]! @deprecated(reason: "the recommendations have been moved to the travel plan level")
}

type Booking {
  id: Long!
  displayStatus: BookingDisplayStatus! @deprecated(reason: "the display status has been moved to the product level")
  token: String!
}

type TravelPlanItinerary implements TravelPlanProduct {
  id: ID!
  type: ProductType!
  booking: Booking! @deprecated(reason: "the booking has to be nullable")
  crossSellRecommendations: [CrossSellProductType!]!
  firstDepartureDateTime: String! @yyyyMMddTHHmmssZZZZZ
  lastArrivalDateTime: String! @yyyyMMddTHHmmssZZZZZ
  airportCities: [String!]!
}

type TravelPlanAccommodation implements TravelPlanProduct {
  id: ID!
  type: ProductType!
  booking: Booking! @deprecated(reason: "the booking has to be nullable")
  crossSellRecommendations: [CrossSellProductType!]!
  checkInDate: String! @yyyyMMdd
  checkOutDate: String! @yyyyMMdd
  name: String!
  stars: Float
}

type TravelPlanItineraryPriceFreeze implements TravelPlanProduct {
  id: ID!
  type: ProductType!
  booking: Booking! @deprecated(reason: "the booking has to be nullable")
  crossSellRecommendations: [CrossSellProductType!]!
  frozenItinerary: FrozenItinerary!
  expirationDateTime: Long!
}

type FrozenItinerary {
  firstDepartureDateTime: String! @yyyyMMddTHHmmssZZZZZ
  lastArrivalDateTime: String! @yyyyMMddTHHmmssZZZZZ
  airportCities: [String!]!
}

type TravelPlansImportBookingResponseV2 {
  importedBookingId: Long!
  upcoming: [TravelPlanV2!]!
}

type TravelPlansResponseV2 {
  upcoming: [TravelPlanV2!]!
}

type TravelPlanV2 {
  id: ID!
  title: String!
  imageUrl: String
  startDateTime: String! @yyyyMMddTHHmmssZZZZZ
  products: [TravelPlanProductV2!]!
  crossSellRecommendations: [CrossSellProductType!]!
}

interface TravelPlanProductV2 {
  id: ID!
  type: ProductType!
  booking: BookingV2
}

type BookingV2 {
  id: Long!
  token: String!
}

type TravelPlanItineraryV2 implements TravelPlanProductV2 {
  id: ID!
  type: ProductType!
  booking: BookingV2
  status: ItineraryStatus!
  sectionTypes: [ItinerarySectionType!]!
  firstDepartureDateTime: String! @yyyyMMddTHHmmssZZZZZ
  lastArrivalDateTime: String! @yyyyMMddTHHmmssZZZZZ
  cities: [String!]!
}

type TravelPlanAccommodationV2 implements TravelPlanProductV2 {
  id: ID!
  type: ProductType!
  booking: BookingV2
  status: AccommodationStatus!
  checkInDate: String! @yyyyMMdd
  checkOutDate: String! @yyyyMMdd
  name: String!
  stars: Float
}

type TravelPlanItineraryPriceFreezeV2 implements TravelPlanProductV2 {
  id: ID!
  type: ProductType!
  booking: BookingV2
  status: PriceFreezeStatus!
  frozenItinerary: FrozenItinerary!
  expirationDateTime: Long!
}

type TravelPlanVehicleRental implements TravelPlanProductV2 {
  id: ID!
  type: ProductType!
  booking: BookingV2
  status: VehicleRentalStatus!
  pickUpDateTime: String! @yyyyMMddTHHmmssZZZZZ
  dropOffDateTime: String! @yyyyMMddTHHmmssZZZZZ
  modelName: String!
  providerBookingReference: String!
  providerBookingDeeplink: String
}

enum BookingStatus {
  REQUEST
  CONTRACT
  HOLD
  DIDNOTBUY
  PENDING
  RETAINED
  UNKNOWN
  FINAL_RET
}

enum BookingProductStatus {
  CONFIRMED
  PENDING
  CANCELLED
  PARTIALLY_CONFIRMED
}

enum FlightStatus {
  UNKNOWN
  CANCELLED
  ARRIVED
  ACTIVE
  REDIRECTED
  SCHEDULED
  DIVERTED
  DELAYED
  UPDATED
}

enum TripListFilter {
  UPCOMING
  PAST
  MOST_RELEVANT
  UPCOMING_NOT_DIDNOTBUY
}

enum PaymentDetailsType {
  CREDIT_CARD
  PAYPAL
  OTHER
  NO_PAYMENT_TYPE
}

enum BookingDisplayStatus {
  CONFIRMED
  PENDING
  CANCELLED
}

enum SectionType {
  SCALE
  ARRIVAL
  HUB
}

enum TripProductStatus {
  CONTRACT
  DIDNOTBUY
  INIT
  PENDING
  REQUEST
}

type Trip {
  id: ID!
  website: Website!
  userSessionLocale: String!
  bookingUserComment: String
  bookingInterface: String!
  creationDate: Long!
  creationDateISO8601: String!
  bookingStatus: BookingStatus
  bookingProductStatus: BookingProductStatus
  itinerary: TripItinerary
  travellers: [Traveller]!
  buyer: Buyer!
  accommodationBooking: AccommodationBooking @deprecated(reason: "old data structure (from travel-companion), for any new implementation use accommodationProductBooking (from accommodation-booking) instead")
  accommodationProductBooking: AccommodationProductBooking
  accommodationInsuranceTripDetails: AccommodationInsuranceTripDetails
  shoppingBasket: ShoppingBasket
  shoppingBasketsProductDetails: [TripProduct!]!
  serviceOptions: [NonEssentialProduct!]!
  premiumOptions: [NonEssentialProduct!]!
  additions: [NonEssentialProduct!]!
  price: Money!
  prime: Boolean!
  primeMembershipContracted: Boolean!
  tdToken: String!
  mmbToken: String!
  paymentDetails: PaymentDetails
  bookingDisplayStatus: BookingDisplayStatus!
  itineraryPriceFreeze: ItineraryPriceFreezeBooking
  insuranceBookings: InsuranceBookings!
  carriersConfiguration: [CabinBagCarrierConfigurationEntry!]!
  bookingCancellationOptions: [BookingCancellationOption!]!
}

type TripProduct implements Product {
  id: ProductId
  price: Money
  status: TripProductStatus!
}

type PaymentDetails {
  paymentDetailsType: PaymentDetailsType!
  paymentInstrumentToken: String!
  creditCard: CreditCard
}

type CreditCard {
  holder: String!
  expirationMonth: String!
  expirationYear: String!
  first6NumberDigits: String!
  last4NumberDigits: String!
}

type AccommodationBooking {
  id: ID
  bookingStatus: BookingStatus
  bookingRooms: [BookingRoom!]!
  promotions: [Promotion!]
  accommodationDescription: String
  roomsDescription: String!
  city: String!
  address: String!
  postalCode: String
  phoneNumber: String
  countryCode: String!
  countryName: String
  email: String
  accommodationCancelPolicy: String
  roomsGroupCancelPolicy: String
  bookingCancelPolicy: String
  checkInDate: Long!
  checkInDateISO8601: String!
  checkOutDate: Long!
  checkOutDateISO8601: String!
  numberOfRooms: Int!
  numberOfAdults: Int!
  numberOfChildren: Int!
  childrenAges: [Int]
  numberOfInfants: Int!
  locator: String
  accommodationName: String
  category: AccommodationCategory!
  checkIn: String
  checkOut: String
  boardType: BoardType
  location: String
  starRating: StarRating
  hotelImage: HotelImage
  coordinates: GeoCoordinates!
  providerCode: String
  price: AccommodationPriceDetails
  payAtPropertyTax: PayAtDestinationTaxes
  checkinInstructions: String @deprecated(reason: "old data structure, use checkinInstructionPolicy instead")
  fees: String @deprecated(reason: "old data structure, use feesPolicy instead")
  additionalInformation: String @deprecated(reason: "old data structure, use additionalInformationPolicy instead")
  cancellationInformation: CancellationInformation!
  cancellationPolicies: CancellationPolicies!
  cancellationDate: String @dateISO8601
  checkinInstructionPolicy: [String!]!
  feesPolicy: [String!]!
  additionalInformationPolicy: [String!]!
}

type AccommodationTripSummary {
  id: ID!
  bookingStatus: BookingStatus!
  checkInDate: Long!
  checkOutDate: Long!
  category: AccommodationCategory!
  accommodationName: String!
  hotelImage: HotelImage
  tdToken: String!
}

type AccommodationProductBooking {
  totalUnderage: Int!
  productId: String!
  price: AccommodationProductPrice!
  pricePerception: AccommodationProductPricePerception
  cancellationPolicies: CancellationPolicies!
}

type ShoppingBasket {
  products: [ShoppingBasketProduct!]!
  promoCodes: [TripShoppingBasketPromoCode!]!
  totalPrice: Money
  primeDiscountPlusPromoCodes: Money
  showPrimeDiscountPlusPromoCodes: Boolean
  shoppingBasketHasExpectedDelayedCollection: Boolean!
  expectedCollectionExecutionDate: Long
}

type ShoppingBasketProduct {
  id: ID!
  type: String!
  price: Money
}

type TripShoppingBasketPromoCode {
  code: String!
  price: Money!
}

type BookingRoom {
  roomNumber: Int!
  roomDescription: String
  adultsNumber: Int!
  infantsNumber: Int!
  childsNumber: Int!
  cancelPolicy: String
  infoPolicy: String
  taxesPolicy: String
}

type Promotion {
  type: String
  description: String
}

type HotelImage {
  url: String
  thumbnail: String
}

type Website {
  code: String
  brand: String
}

type Traveller {
  numPassenger: Int
  travellerType: String!
  title: String
  name: String!
  firstLastName: String
  secondLastName: String
  nationalityCountryCode: String
  travellerGender: TravellerGender
  seats: [TravellerSeat!]!
  baggages: [TravellerBaggage!]!
  boardingPreferences: [BoardingPreference!]!
  birthDate: String @dateISO8601
  age: Int
}

type BoardingPreference {
  from: Location!
  to: Location!
  sectionId: String!
  boardingType: String!
}

type TripItinerary {
  bookingItemId: Long!
  itineraryType: String
  tripType: TripType!
  destination: Location
  arrivalDate: Long!
  arrivalDateISO8601: String!
  origin: Location
  departureDate: Long!
  departureDateISO8601: String!
  transportTypes: [TransportType!]!
  legs: [TripLeg!]!
  isItineraryCancellationAvailable: Boolean!
}

type TripLeg {
  duration: Int! @deprecated(reason: "old data structure, use originalDurationInMinutes instead")
  originalDurationInMinutes: Int!
  updatedDurationInMinutes: Int!
  transportTypes: [TransportType!]!
  sections: [TripSection!]!
}

type TripSection {
  id: ID!
  departureDate: Long!
  arrivalDate: Long!
  departureDateISO8601: String!
  arrivalDateISO8601: String!
  departure: Location!
  arrival: Location!
  carrier: Carrier!
  operatingCarrier: Carrier
  validatingCarrier: Carrier
  cabinClass: CabinClass
  cabinClassCode: String!
  flightCode: String!
  vehicleModel: String
  transportType: TransportType!
  sectionType: SectionType!
  pnr: String
  additionalPnr: String
  provider: String!
  hasMerchantPayments: Boolean!
  flightStatus: FlightStatus!
  productStatus: String
  providerBookingItemId: ID!
  carrierCustomerAccount: CarrierCustomerAccount
  duration: Long! @deprecated(reason: "old data structure, use originalDurationInMinutes instead")
  originalDurationInMinutes: Long!
  updatedDurationInMinutes: Long!
  stopDurationInMinutes: Long!
  index: Int!
  departureInfo: Departure!
  arrivalInfo: Arrival!
  ticketNumbers: [TicketNumber!]
}

type TicketNumber {
  numPassenger: Int!
  number: Long!
  airlineCode: String!
}

type Departure {
  terminal: String
  gate: String
  updatedTerminal: String
  timeISO8601: String
  timeDelay: String
}

type Arrival {
  terminal: String
  gate: String
  baggageClaim: String
  updatedTerminal: String
  timeISO8601: String
  timeDelay: String
}

type CarrierCustomerAccount {
  username: String!
}

type AccommodationPriceDetails {
  accommodationPrice: AccommodationPrice!
  tax: Money!
  total: Money!
  priceBreakdown: [AccommodationPriceBreakdown]
  priceApplied: CustomerPriceType
}

type AccommodationPriceBreakdown {
  customerPriceType: CustomerPriceType
  accommodationPrice: AccommodationPrice
  tax: Money
  total: Money
}

type AccommodationPrice {
  price: Money
  membershipFee: Money @deprecated(reason: "old data field, use membershipDiscount")
  total: Money!
  membershipDiscount: MembershipDiscount
}

input FindRelatedAccommodationTripRequest {
  email: String!
  bookingId: Long!
}

type FindRelatedAccommodationTripResponse {
  tripSummary: [AccommodationTripSummary!]!
}

type TripResponse {
  trip: Trip!
  messages: [Message!]
  userMembership: UserMembership
}

type EnrichedTrip {
  trip: Trip!
  messages: [Message!]
}

type TripListResponse {
  trips: [EnrichedTrip]
  userMembership: UserMembership
}

type PayAtDestinationTaxes {
  taxes: [Tax!]
  totalCustomerCurrency: Money
  total: Money
}

type Tax {
  type: String!
  amount: Money!
}

type CancellationDetails {
  refunded: Boolean
}

type CancellationInformation {
  cancellableStatus: String!
  cancellationDetails: CancellationDetails
  cancellationOptions: [CancellationOption!]!
}

type CancellationPolicies {
  cancellableStatus: String!
  cancellationOptions: [CancellationOption!]!
}

type CancellationOption {
  from: String!
  until: String!
  refundAmount: Money!
  refundPercentage: Int!
}

interface BookingCancellationOption {
  id: ID!
}

type PrimeVoucherBookingCancellationOption implements BookingCancellationOption {
  id: ID!
  amount: Money!
}

type ItineraryPriceFreezeBooking {
  id: String!
}

type InsuranceBookings {
  bookings: [InsuranceBooking!]!
}

type InsuranceBooking {
  insurance: Insurance!
  providerPricePerTravellerType: [InsuranceBookingCoveragePassengerPrice!]!
  totalPrice: Money!
}

type Insurance {
  id: Long!
  conditionsUrls: [InsuranceUrl!]!
  policy: String!
  provider: String!
  description: String!
}

type InsuranceBookingCoveragePassengerPrice {
  travellerType: TravellerAgeType!
  coverageImport: Money!
  providerPrice: Money!
  paxNum: Int!
}

input TripFilter {
  messageFilter: MessageFilter
}

input MessageFilter {
  providerBookingItemId: Long
}

input PaginationValue {
  offsetPage: Int!
  maxNumBookingsByPage: Int!
}

input MinimalBookingInfoRequest {
  token: String!
}

type TripToken {
  email: String!
  bookingId: Long!
  token: String!
}

type MembershipDiscount {
  discount: Money
  percentage: Int
}

input ItineraryCancellationApplicationRequest {
  email: String!
  bookingId: Long!
}

type ItineraryCancellationApplicationResponse {
  success: Boolean!
}

input PrimeBookingFreeCancellationRequest {
  bookingToken: String!
  cancellationID: ID!
}

type PrimeBookingFreeCancellationResponse {
  success: Boolean!
}

type GenerateBaTokenResponse {
  success: Boolean!
}

type MinimalBookingInfoResponse {
  email: String!
  bookingId: Long!
}

type TrustpilotParamsResponse {
  locale: String!
  language: String!
  href: String!
  businessUnitId: String!
  template: TrustpilotTemplate
}

type TrustpilotTemplate {
  ratingId: String!
  reviewsId: String!
}

enum ChangePasswordType {
  USING_HASH_CODE
  USING_OLD_PASSWORD
}

enum AuthenticationMethod {
  PASSWORD
  GOOGLE
  EMAIL
  APPLE
  FACEBOOK
  UNKNOWN
}

input PasswordLoginRequest {
  email: String!
  password: String!
  recaptchaResponse: String
  persistentLogin: Boolean
  acceptsNewsletter: Boolean
}

input EmailLoginRequest {
  email: String!
  token: String!
}

input FacebookLoginRequest {
  token: String!
  persistentLogin: Boolean
}

input GoogleLoginRequest {
  token: String!
  persistentLogin: Boolean
  acceptsNewsletter: Boolean
}

input GoogleAccessTokenLoginRequest {
  token: String!
  persistentLogin: Boolean
  acceptsNewsletter: Boolean
}

type LoginResponse {
  success: Boolean!
  user: User
  landingPagePath: String
}

type LogoutResponse {
  success: Boolean!
}

input LogoutFromSessionRequest {
  sessionId: String!
}

input RecoverPasswordRequest {
  email: String!
  recaptchaResponse: String
}

type RecoverPasswordResponse {
  success: Boolean!
}

input ChangePasswordRequest {
  type: ChangePasswordType!
  withHashCode: ChangePasswordRequestWithHashCode
  withOldPassword: ChangePasswordRequestWithOldPassword
  newPassword: String!
  persistentLogin: Boolean
}

input ChangePasswordRequestWithHashCode {
  hashCode: String!
}

input ChangePasswordRequestWithOldPassword {
  oldPassword: String!
}

type ChangePasswordResponse {
  success: Boolean!
}

input SendSetPasswordEmailRequest {
  email: String!
  landingPagePath: String
  newsletterSubscribed: Boolean
  recaptchaV2Response: String
}

type SendSetPasswordEmailResponse {
  acknowledged: Boolean!
}

input IsLoginVerifiedRequest {
  email: String!
  token: String!
}

type ListLoginSessionsResponse {
  currentSession: LoginSession!
  remainingActiveSessions: [LoginSession!]!
}

type LoginSession {
  id: String!
  deviceUserAgent: String
  userDeviceOs: String
  nodeId: Int
  creationTimestamp: Long!
}

type AuthenticationMethodResponse {
  authenticationMethod: AuthenticationMethod!
}

input LoginTokenValidationRequest {
  email: String!
  token: String!
}

type LoginTokenValidationResponse {
  success: Boolean!
}

input PasswordSignupRequest {
  email: String!
  password: String!
  acceptsNewsletter: Boolean!
  landingPagePath: String
}

type SignupResponse {
  success: Boolean!
  user: User
}

input ActivateTokenUserRequest {
  activateToken: String!
}

type User {
  id: Long
  email: String
  displayName: String
  membership: Membership
  travellers: [UserTraveller!]
  creditCards: UserCreditCardsResponse
}

type UserTraveller {
  personalInfo: PersonalInfo!
  id: Long!
  buyer: Boolean
  importedFromLocal: Boolean
  email: String
  middleName: String
  prefixPhoneNumber: String
  phoneNumber: String
  prefixAlternatePhoneNumber: String
  mobilePhoneNumber: String
  alternatePhoneNumber: String
  isDefault: Boolean
  isPrimeOwner: Boolean!
  cpf: String
  identificationList: [Identification]
  address: TravellerAddress
  meal: TravellerMeal
  frequentFlyerNumbers: [FrequentFlyerCard!]
}

type Identification {
  identificationType: IdentificationType
  identificationId: String
  identificationExpirationDate: String @dateISO8601
  identificationCountryCode: String
}

type TravellerAddress {
  address: String
  addressType: String
  city: String
  country: String
  postalCode: String
  isPrimary: Boolean
  alias: String
  state: String
}

type Address {
  direction: String
  city: String
  country: String
  postalCode: String
}

type UserInfo {
  id: ID!
  isPrime: Boolean!
  name: String
}

input DeleteUserCreditCardRequest {
  id: [Long!]!
  paymentInstrumentTokens: [String!]
}

input SaveUserCreditCardRequest {
  creditCardsInfo: [UserCreditCardInfo!]!
}

input UserCreditCardInfo {
  paymentInstrumentToken: String!
  creditCardTypeCode: String!
  isDefault: Boolean = false
}

type RecogniseUserResponse {
  isRecognised: Boolean! @deprecated(reason: "old name, recognised instead")
  recognised: Boolean!
}

type UserSegmentResponse {
  segment: String
}

type UserAccountResponse {
  email: String!
  passwordChangeAllowed: Boolean!
  passwordPresent: Boolean!
  isAllowedToDelete: Boolean!
  isLoggedIn: Boolean!
  isRegistered: Boolean!
  userDefaultProfile: UserDefaultProfile
  userTravellers: [UserTraveller]!
  userMembership: UserMembership!
  userPaymentInstruments: [UserPaymentInstrument]!
  userVouchers: UserVouchers! @deprecated(reason: "Use userWallet instead")
  userWallet: UserWallet
}

interface UserPaymentInstrument {
  paymentInstrumentToken: ID!
  isRenewalChargeable: Boolean!
  isRenewalDefault: Boolean!
}

type UserPaymentInstrumentCard implements UserPaymentInstrument {
  isRenewalChargeable: Boolean!
  expirationDate: String! @dateISO8601
  cardHolder: String!
  cardNumberObfuscated: String!
  cardType: CreditCardsType
  paymentInstrumentToken: ID!
  isRenewalDefault: Boolean!
  cardTypeCode: String!
}

type UserPaymentInstrumentPaypal implements UserPaymentInstrument {
  email: String!
  paymentInstrumentToken: ID!
  isRenewalDefault: Boolean!
  isRenewalChargeable: Boolean!
}

type UserPaymentInstrumentIdeal implements UserPaymentInstrument {
  idealIssuerBank: IdealIssuerBankType!
  paymentInstrumentToken: ID!
  isRenewalDefault: Boolean!
  isRenewalChargeable: Boolean!
}

type UserDefaultProfile {
  displayName: String
  names: String
  lastNames: String
  address: Address
  phone: Phone
}

type UserWallet {
  userVouchers: UserVouchers
  userPromoCodes: UserPromoCodes
  totalAmounts: UserWalletAmountPerception
}

type UserWalletAmountPerception {
  allPromoCodesTotalAmount: Money!
  enabledPromoCodesTotalAmount: Money!
  disabledPromoCodesTotalAmount: Money!
}

type UserVouchers {
  vouchers: [Voucher!]! @deprecated(reason: "Use usedVouchers and unusedVouchers instead")
  usedVouchers: [UserVoucher!]!
  unusedVouchers: [UserVoucher!]!
  enabledVouchers: [UserVoucher!]!
  disabledVouchers: [UserVoucher!]!
  totalAmount: Money! @deprecated(reason: "use the type UserWalletTotalAmounts")
}

type UserPromoCodes {
  usedPromoCodes: [UserPromoCode!]!
  unusedPromoCodes: [UserPromoCode!]!
  enabledPromoCodes: [UserPromoCode!]!
  disabledPromoCodes: [UserPromoCode!]!
}

interface Voucher {
  amount: Money!
  isEnabled: Boolean!
}

type MembershipFreeCancellationVoucher implements Voucher {
  amount: Money!
  isEnabled: Boolean!
}

type UserVoucher {
  amount: Money!
  isEnabled: Boolean!
  code: String!
  conditions: VoucherApplicationConditions!
}

type UserPromoCode {
  discount: UserPromoCodeDiscount!
  isEnabled: Boolean!
  code: String!
  prime: Boolean!
  conditions: PromoCodeApplicationConditions!
  sponsor: UserPromoCodeSponsor!
  campaign: UserPromoCodeCampaign!
}

type UserPromoCodeCampaign {
  department: UserPromoCodeDepartment!
}

enum UserPromoCodeDepartment {
  CUSTOMER_CARE
  CRM
  MERCHANDISING
  SOCIAL_MEDIA
  OFFLINE_SALES
  AFFILIATES
  PUBLIC_RELATIONS
  INTERNAL_COMMUNICATIONS
  PRODUCT_MARKETING
  UX_RESEARCH
  PRIME_REFERRAL_REFERRER
  PRIME_REFERRAL_REFERRED
  PRIME_RETENTION_OFFLINE
  PRIME_RETENTION_ONLINE
  TEST
  VOUCHER_VENDOR
  VIP_CASES
  OTHERS
}

interface UserPromoCodeDiscount {
  maxAmount: Money
}

type FixDiscount implements UserPromoCodeDiscount {
  fixDiscount: Money!
  fixDiscountIsPerTraveller: Boolean!
  maxAmount: Money
}

type PercentageDiscount implements UserPromoCodeDiscount {
  percentage: Float! @bigdecimal
  maxAmount: Money
}

type UserPromoCodeSponsor {
  sponsored: Boolean!
  name: String!
}

type VoucherApplicationConditions {
  productTypeConditions: WalletElementProductTypeConditions
  carrierConditions: WalletElementCarrierConditions
  usageDateConditions: UsageDateConditions
  purchaseAmountConditions: WalletElementPurchaseAmountConditions
}

type PromoCodeApplicationConditions {
  productTypeConditions: WalletElementProductTypeConditions
  carrierConditions: WalletElementCarrierConditions
  promoCodeDestinationConditions: PromoCodeDestinationConditions
  promoCodeInterfaceConditions: PromoCodeInterfaceConditions
  usageDateConditions: UsageDateConditions
  purchaseAmountConditions: WalletElementPurchaseAmountConditions
}

type UsageDateConditions {
  requiredUsageDateBefore: String @dateISO8601
  requiredUsageDateAfter: String @dateISO8601
}

type PromoCodeInterfaceConditions {
  interfaces: [PromoCodeInterfaceCondition!]!
}

type PromoCodeDestinationConditions {
  destinations: [PromoCodeDestinationCondition!]!
}

type WalletElementPurchaseAmountConditions {
  purchaseAmounts: [WalletElementPurchaseAmountCondition!]!
}

type WalletElementPurchaseAmountCondition {
  minAmount: Money
  maxAmount: Money
}

type WalletElementProductTypeConditions {
  productTypes: [UserWalletProductType!]!
}

type WalletElementCarrierConditions {
  carriers: [UserWalletCarrier!]!
}

type PromoCodeDestinationCondition {
  name: String!
  code: String!
}

enum PromoCodeInterfaceCondition {
  NATIVE_ANDROID_EDREAMS
  NATIVE_ANDROID_GOV
  NATIVE_ANDROID_OPODO
  NATIVE_ANDROID_TRAVELLINK
  NATIVE_IOS_EDREAMS
  NATIVE_IOS_GOV
  NATIVE_IOS_OPODO
  NATIVE_IOS_TRAVELLINK
  ONE_FRONT_DESKTOP
  ONE_FRONT_SMARTPHONE
}

type UserWalletCarrier {
  id: ID!
  name: String!
}

enum UserWalletProductType {
  DYNPACK
  FLIGHT
}

type UserMembership {
  membershipID: ID!
  isActive: Boolean!
  subscriptionDetails: UserMembershipSubscriptionDetails
  accountDetails: UserMembershipAccountDetails
  availablePlans: [MembershipPlanDetails]!
  associatedBookings: [PrimeBooking!]!
  activeMemberSince: String @dateISO8601
  membershipRewards: MembershipRewards
}

type UserMembershipSubscriptionDetails {
  activationDate: String @dateISO8601
  expirationDate: String @dateISO8601
  isAutoRenewalEnabled: Boolean
  isRemindRenewalEnabled: Boolean
  isFreeTrial: Boolean
  hasValidRenewablePaymentMethod: Boolean!
  status: UserMembershipSubscriptionStatus
  currentPlanDetails: MembershipPlanDetails
  cancellationInfo: CancellationInfo
  collectionDetails: UserMembershipCollectionDetails
  perks: [UserMembershipPerk!]! @deprecated(reason: "Use availablePerks or contractedPerks instead")
  availablePerks: [AvailableMembershipPerk!]!
  contractedPerks: [ContractedMembershipPerk!]!
  loyaltyRewardsProgram: LoyaltyRewardsProgram
  automaticallyCancellable: Boolean
  manuallyCancellable: Boolean!
  committedUntil: String! @dateISO8601
}

enum UserMembershipPerk {
  ITINERARY_DISCOUNT
  ACCOMMODATION_DISCOUNT
  BAGGAGES_DISCOUNT
  SEATS_DISCOUNT
  FRIENDS_AND_FAMILIES
  ITINERARY_SHIPPING_AND_HANDLING_CANCELLATION
  ACCOMMODATION_SHIPPING_AND_HANDLING_CANCELLATION
  ITINERARY_CANCELLATION
  UNLIMITED_PRICE_FREEZE_DISCOUNT
}

interface BaseMembershipPerk {
  type: MembershipPerkType!
}

type LimitedAvailableMembershipPerk implements BaseMembershipPerk {
  type: MembershipPerkType!
  availableQuota: Int!
}

type LimitedContractedMembershipPerk implements BaseMembershipPerk {
  type: MembershipPerkType!
  contractedQuota: Int!
}

type UnlimitedAvailableMembershipPerk implements BaseMembershipPerk {
  type: MembershipPerkType!
}

type UnlimitedContractedMembershipPerk implements BaseMembershipPerk {
  type: MembershipPerkType!
}

union AvailableMembershipPerk = LimitedAvailableMembershipPerk | UnlimitedAvailableMembershipPerk

union ContractedMembershipPerk = LimitedContractedMembershipPerk | UnlimitedContractedMembershipPerk

enum MembershipPerkType {
  FRIENDS_AND_FAMILY_ITINERARY_DISCOUNT
  ITINERARY_CANCELLATIONS_FOR_RENEWABLE_MEMBERSHIP_FREE_TRIAL_PERIOD_ALLOWED
  ITINERARY_CANCELLATIONS_FOR_RENEWABLE_PAID_MEMBERSHIP_ONLY
  ITINERARY_CANCELLATION_FOR_SUBSCRIPTION_PURCHASE
  ONE_ITINERARY_CANCELLATION_FOR_RENEWABLE_MEMBERSHIP
  TWO_ITINERARY_CANCELLATIONS_FOR_NATURAL_YEAR
  UNLIMITED_ACCOMMODATION_DISCOUNT
  UNLIMITED_AIRPORT_FAST_TRACK_DISCOUNT
  UNLIMITED_BAGS_DISCOUNTS
  UNLIMITED_CAR_RENTAL_DISCOUNT
  UNLIMITED_ITINERARY_DISCOUNT
  UNLIMITED_PRICE_FREEZE_DISCOUNT
  UNLIMITED_SEAT_DISCOUNTS
  UNKNOWN
}

type CancellationInfo {
  cancellationDate: String
  isCancellationAvailable: Boolean!
}

interface MembershipPlanDetails {
  tier: SubscriptionOfferType
  renewalPrice: Money
  duration: SubscriptionOfferDuration
  renewalDuration: SubscriptionOfferDuration
  autoRenewalPolicy: AutoRenewalPolicy!
}

type PrimeMemberPlanDetails implements MembershipPlanDetails {
  tier: SubscriptionOfferType
  renewalPrice: Money
  duration: SubscriptionOfferDuration
  renewalDuration: SubscriptionOfferDuration
  autoRenewalPolicy: AutoRenewalPolicy!
}

type SubscriptionPlanDetails implements MembershipPlanDetails {
  id: ID!
  isFreeTrial: Boolean!
  tier: SubscriptionOfferType!
  price: Money!
  renewalPrice: Money!
  duration: SubscriptionOfferDuration!
  renewalDuration: SubscriptionOfferDuration!
  autoRenewalPolicy: AutoRenewalPolicy!
}

type UserMembershipCollectionDetails {
  transactionDate: String! @dateISO8601
  userPaymentInstrument: UserPaymentInstrument!
}

type UserMembershipAccountDetails {
  names: String
  lastNames: String
}

input UserAccountRequest {
  shoppingInfo: ShoppingInfo
  paymentInstrumentFilter: PaymentInstrumentFilter
  walletFilter: UserWalletFilter
}

input UserWalletFilter {
  applicationConditionsFilter: ApplicationConditionsFilter
}

input ApplicationConditionsFilter {
  productTypesFilter: WalletElementProductTypeConditionsFilter
  interfacesFilter: PromoCodeInterfaceConditionsFilter
}

input PromoCodeInterfaceConditionsFilter {
  interfaces: [PromoCodeInterfaceCondition!]!
}

input WalletElementProductTypeConditionsFilter {
  productTypes: [UserWalletProductType!]!
}

enum PaymentInstrumentFilter {
  RECURRING_ONLY
  USER_ONLY
}

enum UserMembershipSubscriptionStatus {
  ACTIVATED
  PTC
  PTA
  EXPIRED
}

type DeleteUserPaymentInstrumentResponse {
  isDeleted: Boolean!
}

input DeleteUserPaymentInstrumentRequest {
  paymentInstrumentToken: ID!
}

interface PrimeBooking {
  bookingId: ID!
}

type ItineraryPrimeBooking implements PrimeBooking {
  bookingId: ID!
  destination: String
  destinationIataCode: String
  origin: String
  departureDate: String @dateISO8601
}

type DeleteUserAccountResponse {
  deleted: Boolean!
}

input MarkUserPaymentInstrumentAsPreferredRequest {
  paymentInstrumentToken: ID!
}

type MarkUserPaymentInstrumentAsPreferredResponse {
  isMarkedAsPreferred: Boolean!
}

enum UserAreaNotAccessibleReason {
  AUTHENTICATION_NEEDED
}

type UserAreaAccess {
  canAccess: Boolean!
  notAccessibleReason: UserAreaNotAccessibleReason
}

input TrackJavaScriptSnippetFinalizedRequest {
  userPaymentInteractionId: String!
  errorMessage: String
}

type TrackJavaScriptSnippetResponse {
  success: Boolean!
}

enum Transmission {
  MANUAL
  AUTOMATIC
}

enum FuelPolicy {
  FULLFULL
  EMPTYEMPTY
  FULLEMPTY
  HALFEMPTY
  QUARTEREMPTY
  HALFHALF
  QUARTERQUARTER
  FREETANK
  FULLEMPTYREFUND
  FULLFULLHYBRID
  CHAUFFULFUL
  CHAUFFUELINC
  UNKNOWN
}

enum RentalOfferTimeUnit {
  DAYS
}

enum FuelType {
  DIESEL
  PETROL
  ELECTRIC
  HYBRID
}

enum VehicleCategory {
  MINI
  MINI_ELITE
  ECONOMY
  ECONOMY_ELITE
  COMPACT
  COMPACT_ELITE
  INTERMEDIATE
  INTERMEDIATE_ELITE
  STANDARD
  STANDARD_ELITE
  FULLSIZE
  FULLSIZE_ELITE
  PREMIUM
  PREMIUM_ELITE
  LUXURY
  LUXURY_ELITE
  OVERSIZE
  SPECIAL
}

enum RentalPriceBreakDownItemType {
  PROVIDER_PRICE
  PRIME_DISCOUNT
  PRIME_PRICE
}

enum RentalPricePerceptionEnum {
  TOTAL_PRIME
  TOTAL_NON_PRIME
  DAILY_PRIME
  DAILY_NON_PRIME
}

enum VehicleRentalBookingStatus {
  CONFIRMED
  CANCELLED
}

input VehicleRentalSearchRequest {
  itineraryId: ID!
}

input VehicleRentalSearchRequestV2 {
  itineraryId: ID!
  touchPoint: VehicleRentalTouchPoint!
}

input VehicleRentalSearchRequestByAccommodationV2 {
  bookingId: ID!
  touchPoint: VehicleRentalTouchPoint!
}

input VehicleSearchCriteriaRequest {
  pickupLocation: LocationRequest!
  pickupAt: String!
  returnLocation: LocationRequest
  returnAt: String
}

type VehicleRentalSearchResponse {
  searchId: String!
  vehicleRentalOffers: [VehicleRentalOffer!]!
}

type VehicleRentalOffer {
  id: ID!
  duration: RentalOfferDuration!
  pricePerceptions: [RentalPricePerception!]!
  rentalCompany: RentalCompany!
  vehicle: Vehicle!
  providerSelectionDeepLink: String
}

type Vehicle {
  modelName: String!
  category: VehicleCategory!
  transmissionType: Transmission!
  pax: String!
  bags: String!
  doors: String!
  pictureUrl: String!
  fuelType: FuelType
}

type RentalOfferDuration {
  amount: Int!
  timeUnit: RentalOfferTimeUnit!
}

type RentalCompany {
  id: String!
  name: String!
  scoreAsRatio: Float!
  logoUrl: String
}

type RentalPricePerception {
  rentalPrice: RentalPrice!
  type: RentalPricePerceptionEnum!
}

type RentalPrice {
  price: Money!
  rentalPriceBreakDown: RentalPriceBreakdown
}

type RentalPriceBreakdown {
  rentalPriceBreakDownItem: [RentalPriceBreakDownItem!]!
}

type RentalPriceBreakDownItem {
  rentalPrice: RentalPrice!
  type: RentalPriceBreakDownItemType!
}

type VehicleRentalResponse {
  results: [VehicleRental!]!
}

input VehicleRentalFindRequest {
  returnDateFromInclusive: String @yyyyMMddTHHmmssZZZZZ
  returnDateToExclusive: String @yyyyMMddTHHmmssZZZZZ
}

type VehicleRental {
  providerBookingReference: ID!
  providerBookingDeeplink: String
  rentalCompany: RentalCompanyV2!
  status: VehicleRentalBookingStatus!
  vehicle: VehicleProduct!
  pickupAt: String! @yyyyMMddTHHmmssZZZZZ
  returnAt: String! @yyyyMMddTHHmmssZZZZZ
  pickupLocation: VehicleRentalLocation!
  returnLocation: VehicleRentalLocation!
}

type RentalCompanyV2 {
  shortName: String!
  rentalCompanyPictureUrl: String
}

type VehicleProduct {
  vehiclePictureUrl: String
  modelName: String!
}

type VehicleRentalLocation {
  name: String!
  address: String
  phoneNumber: String
  coordinates: GeoCoordinates
  closestAirport: VehicleRentalAirport
}

type VehicleRentalAirport {
  geoNodeId: Int!
  iataCode: String
  cityName: String
}

input VehicleRentalTouchPoint {
  page: VehicleRentalTouchPointPage!
}

input VehicleRentalTouchPointPage {
  url: String!
}

input AutoCompleteSearchRequest {
  searchTerm: String! @minLength(len: 3)
  size: Int
}

type AutoCompleteSearchResponse {
  autoCompleteSearchSuggestions: [AutoCompleteSearchSuggestion!]!
}

type AutoCompleteSearchSuggestion {
  propertyMappingId: PropertyMappingId!
  coordinates: GeoCoordinates
  destinationType: DestinationType!
  value: String
  geoNodeId: Int!
  city: String!
  country: String!
}

type PropertyMappingId {
  id: Long
}

enum DestinationType {
  HOTEL
  REGION
}

input AutoCompleteSearchRequestV2 {
  searchTerm: String!
  sizeAccommodation: Int = 5
  sizeRegion: Int = 5
  locale: Locale
}

type AutoCompleteSearchResponseV2 {
  autoCompleteSearchSuggestions: [Geo!]!
}

type Geo {
  id: GeoId!
  geoType: GeoType
  text: String!
  regionType: RegionType
}

enum GeoType {
  ACCOMMODATION
  REGION
  GOOGLE_PLACE
}

type GeoId {
  value: String!
}

enum Locale {
  ar
  ar_AE
  ar_QA
  ar_SA
  ca_ES
  cs_CZ
  da_DK
  de
  de_AT
  de_CH
  de_DE
  el_GR
  en
  en_AE
  en_AU
  en_CA
  en_CZ
  en_DE
  en_DK
  en_EG
  en_ES
  en_FI
  en_FR
  en_GB
  en_HK
  en_HU
  en_ID
  en_IN
  en_IT
  en_KR
  en_NO
  en_NZ
  en_PH
  en_PL
  en_QA
  en_SA
  en_SE
  en_SG
  en_TH
  en_TW
  en_US
  en_ZA
  es
  es_AR
  es_CL
  es_CO
  es_ES
  es_MX
  es_PE
  es_US
  es_VE
  eu_ES
  fi_FI
  fr
  fr_CA
  fr_CH
  fr_FR
  fr_MA
  gl_ES
  hu_HU
  is_IS
  it
  it_CH
  it_IT
  ja_JP
  ko_KR
  nl_NL
  no_NO
  pl_PL
  pt
  pt_BR
  pt_PT
  ro_RO
  ru_RU
  sv_SE
  tr_TR
  zh_CN
  zh_TW
  DEFAULT
}

input GeoAccommodationSearchRequest {
  geoId: String!
  geoType: GeoType
}

input GeoAccommodationLocationRequest {
  geoNodeId: Int
  geoId: String
  geoType: GeoType
  polygon: GeoAccommodationPolygonRequest
}

input GeoAccommodationAssociationsRequest {
  geoId: String!
  geoType: GeoType!
}

input GeoAccommodationRelatedRegionsRequest {
  geoId: String!
  geoType: GeoType!
}

type GeoAccommodationSearchResponse {
  geoAccommodationResponse: GeoAccommodationResponse!
}

type GeoAccommodationResponse {
  geoRegion: GeoRegion
  geoAccommodations: [GeoAccommodation!] @deprecated(reason: "Not needed when we deprecate searchAccommodationByGeoAccommodation")
}

type GeoRegion {
  geoNodeId: Int!
  id: GeoId!
  geoType: GeoType
}

type GeoAccommodation {
  propertyMappingId: Int!
  id: GeoId!
  geoType: GeoType
}

type GeoAccommodationLocationResponse {
  mainRegion: GeoLocationRegion!
  coordinates: GeoCoordinates!
  countryCode: String!
  segments: [GeoLocationRegion!]!
  imageUrl: String
}

type GeoAccommodationAssociationsResponse {
  associations: [Region!]!
}

type GeoAccommodationRelatedRegionsResponse {
  popularPOIs: [Region!]!
  closePOIsAndTransports: [Region!]!
}

type Region {
  id: String!
  coordinates: GeoCoordinates!
  name: String!
  regionType: RegionType!
  countryCode: String!
  translations: [Translation!]!
}

type Translation {
  languageCode: String!
  name: String!
}

type GeoLocationRegion {
  regionId: String!
  name: String!
  regionType: RegionType!
}

enum RegionType {
  AIRPORT
  BUS_STATION
  CITY
  CONTINENT
  COUNTRY
  HIGH_LEVEL_REGION
  METRO_STATION
  MULTI_CITY_VICINITY
  NEIGHBOURHOOD
  POINT_OF_INTEREST
  PROVINCE_STATE
  TRAIN_STATION
}

input AccommodationModificationOptionsRequest {
  productId: ID!
  checkInDate: String!
  checkOutDate: String!
}

input ApplyAccommodationModificationRequest {
  modificationId: ID!
}

type IsAccommodationModifiableResponse {
  isModifiable: Boolean!
}

type AccommodationModificationOptionsResponse {
  accommodationModificationOptions: [AccommodationModificationOption!]!
}

type AccommodationModificationOption {
  id: ID!
  modifiedProductId: ID!
  prices: [AccommodationModificationPrice!]!
  selectedCustomerPriceType: CustomerPriceType!
  productDetails: AccommodationModificationProductDetails
}

type AccommodationModificationPrice {
  customerPriceType: CustomerPriceType!
  total: Money!
  breakdown: AccommodationModificationPriceBreakdown!
}

type AccommodationModificationPriceBreakdown {
  productPrice: Money
  membershipFee: Money
}

type AccommodationModificationProductDetails {
  rooms: [AccommodationModificationRoom!]!
}

type AccommodationModificationRoom {
  description: String
}

input AccommodationSearchPriceAlertNewsletterRequest {
  searchId: Long!
  email: String!
  geoAccommodationRequest: GeoAccommodationRequest
}

input PriceAlertImageRequest {
  geoId: String!
}

type AccommodationSearchPriceAlertNewsletterResponse {
  isSubscribed: Boolean!
}

type PriceAlertImageResponse {
  imageUrl: String
}

input AccommodationRecommendationByIataCodeRequest {
  iataCode: String! @length(len: 3)
}

type AccommodationRecommendationByIataCodeResponse {
  propertyMappingIds: [PropertyMappingId!]!
}

type AccommodationRecommendationResponse {
  searchId: Long
  accommodationRecommendations: [AccommodationRecommendation!]!
}

input AccommodationRecommendationRequest {
  checkInDate: String
  checkOutDate: String
  geoAccommodationRequest: GeoAccommodationRequest!
  roomRequest: RoomRequest
  maxResults: Int
  buyPath: Int
}

type AccommodationRecommendation {
  checkInDate: String!
  checkOutDate: String!
  destination: City!
  price: Money @deprecated
  priceNonPrime: Money @deprecated
  discount: Float @deprecated
  discountAbsolute: Money @deprecated
  priceBreakdown: PriceBreakdown!
  currency: String!
  dedupId: Int!
  contentKey: String
  accommodationInfo: AccommodationDetailsResponse!
}

input TripadvisorReviewRequest {
  propertyMappingId: Int!
  language: Language @deprecated(reason: "The language will be retrieved from the visit")
}

type TripadvisorReviewResponse {
  tripadvisorReview: TripadvisorReview
}

type TripadvisorReview {
  tripadvisorReviewsUrl: String!
  rating: Float!
  bubbleRating: Float!
  totalReviews: Int!
  subRatings: SubRating
  userReviews: [TripadvisorUserReview!]!
  awards: [Award!]!
  cityAccommodationRanking: CityAccommodationRanking!
  tripTypeReviewCountAndPercentage: TripTypeReviewCountAndPercentage!
  highlightedSubRatingTypes: [SubRatingType!]!
}

enum Language {
  EN
  ES
  FR
  DE
  IT
  PT
}

type TripadvisorUserReview {
  username: String!
  userCityAndCountry: String
  rating: Float!
  travelDate: String!
  title: String!
  text: String!
  subRatings: SubRating
  tripType: TripadvisorTripType
  translated: Boolean!
  highlighted: Boolean!
}

type Award {
  type: String!
  year: Int
  imageUrlLarge: String!
}

type SubRating {
  room: Float
  value: Float
  sleep: Float
  location: Float
  cleanliness: Float
  service: Float
}

type CityAccommodationRanking {
  ranking: Int!
  rankingOutOf: Int!
  topRanked: Boolean!
}

type TripTypeReviewCountAndPercentage {
  business: ReviewCountAndPercentage!
  couples: ReviewCountAndPercentage!
  solo: ReviewCountAndPercentage!
  family: ReviewCountAndPercentage!
  friends: ReviewCountAndPercentage!
}

type ReviewCountAndPercentage {
  count: Int!
  percentageOfTotalReviews: Int!
}

enum TripadvisorTripType {
  BUSINESS
  COUPLES
  SOLO
  FAMILY
  FRIENDS
}

enum SubRatingType {
  ROOM
  VALUE
  SLEEP
  LOCATION
  CLEANLINESS
  SERVICE
}

input AccommodationSearchHistoryRequest {
  maxResults: Int
}

type AccommodationSearchHistory {
  searchHistoryId: String!
  totalAdults: Int!
  totalChildren: Int
  rooms: [RoomRequested!]!
  geoAccommodation: GeoAccommodation!
  date: String!
  checkIn: String!
  checkOut: String!
  name: String!
  accommodationImage: AccommodationImage
  accommodationInfo: AccommodationInfo
  searchId: Long
}

type RoomRequested {
  numAdults: Int!
  childrenAges: [Int!]!
}

type AccommodationInfo {
  currency: String!
  priceBreakdown: PriceBreakdown!
  cancellationFree: Boolean!
  cityName: String!
  stars: Int!
  userReview: UserReview!
  distanceFromCenter: Float!
  starsRating: StarRating
}

input DeleteAccommodationSearchHistoryRequest {
  searchHistoryId: String!
}

type DeleteAccommodationSearchHistoryResponse {
  deleted: Boolean!
}

type AccommodationSearchHistoryResponse {
  accommodationSearchHistories: [AccommodationSearchHistory!]!
}

input ConvertSecretHotelIdRequest {
  secretHotelId: String!
}

type ConvertSecretHotelIdResponse {
  propertyMappingId: Int!
}

type TouchPointMessagingResponse {
  isPrimeWithoutPastHotelBooking: Boolean
}

enum AncillariesRetailingType {
  CABIN_BAG @deprecated(reason: "not used, will be removed in future iterations")
  CANCEL_FOR_ANY_REASON
  CANCEL_FOR_ANY_REASON_GUARANTEE @deprecated(reason: "not used, will be removed in future iterations")
  CANCELLATION_AND_ASSISTANCE_INSURANCE @deprecated(reason: "not used, will be removed in future iterations")
  CANCELLATION_INSURANCE @deprecated(reason: "not used, will be removed in future iterations")
  CHECKED_BAG @deprecated(reason: "not used, will be removed in future iterations")
  FARE_PLUS
  FLEXIBLE_DATES_INSURANCE @deprecated(reason: "not used, will be removed in future iterations")
  FLIGHT_CANCELLATION_AND_FLIGHT_CANCELLATION_PLUS_MEDICAL_ASSISTANCE
  INSTANT_DISRUPTION_COMPENSATION
  SEAT @deprecated(reason: "not used, will be removed in future iterations")
  SUPPORT_PACK
}

enum AncillaryType {
  BAG
  FARE_PLUS
  INSURANCE
  SEAT
  SUPPORT_PACK
  AUTOMATIC_CHECK_IN
  INSTANT_DISRUPTION_COMPENSATION
}

input AncillariesRetailingEvaluationRequest {
  shoppingCartId: ID!
}

type AncillariesRetailingEvaluationResponse {
  ancillariesToSkip: [AncillariesRetailingType!]!
}

type AncillariesRetailingEvaluationNavigationTreeResponse {
  evaluation: Evaluation!
}

type Evaluation {
  id: ID!
  navigationTree: NavigationTree!
}

type NavigationTree {
  product: AncillaryProduct!
}

type AncillaryProduct {
  ancillaryType: AncillaryType!
  nextProductWhenAttached: AncillaryProduct
  nextProductWhenNotAttached: AncillaryProduct
}

enum BaggageApplicationLevel {
  SECTION
  SEGMENT
  ITINERARY
}

enum SegmentTypeIndex {
  FIRST
  SECOND
  THIRD
  FOURTH
  FIFTH
  SIXTH
}

type BaggageConditions {
  baggageDescriptorIncludedInPrice: BaggageDescriptor
  selectableBaggageDescriptor: [SelectableBaggageDescriptor!]
  baggageApplicationLevel: BaggageApplicationLevel
  segmentTypeIndex: SegmentTypeIndex
  baggageFeeIncludedInPrice: Money
  baggagePropensity: Float @bigdecimal
  travellerType: TravellerAgeType!
}

type SelectableBaggageDescriptor {
  baggageDescriptor: BaggageDescriptor
  price: Money @deprecated
  primePrice: Money @deprecated
  prices: [AncillaryPriceItem!]!
  pricesPerUnit: [PricePerUnit!]
}

type BaggageDescriptor {
  pieces: Int
  kilos: Int
}

input BaggageRequest {
  segmentTypeIndex: SegmentTypeIndex!
  numPassenger: Int!
  kilos: Int!
  pieces: Int!
  displayedPrice: MoneyRequest
}

type BaggageConditionsTraveller {
  numTraveller: Int!
  baggageConditions: [BaggageConditions!]!
}

type TravellerBaggage {
  from: Location!
  to: Location!
  baggageDescriptionList: [BaggageDescriptor!]!
}

type OneClickCheckedBagDeals {
  checkedBagOffers: [OneClickCheckedBagOffer!]!
}

type OneClickCheckedBagOffer {
  descriptor: BaggageDescriptor!
  tags: [CheckedBagOfferTag!]!
}

type CabinBag {
  debugInfo: String
  carrier: String!
  segment: Int!
  section: Int!
  fee: Money! @deprecated
  totalPrice: Money! @deprecated
  totalPrimePrice: Money @deprecated
  carrierConfiguration: CabinBagCarrierConfiguration!
  priceBreakdown: CabinBagPriceBreakdown! @deprecated
  prices: [AncillaryPriceItem!]!
  pricesPerUnit: [PricePerUnit!]
}

type CabinBagCarrierConfigurationEntry {
  carrierCode: String!
  config: CabinBagCarrierConfiguration!
}

type CabinBagCarrierConfiguration {
  name: String
  smallBagSize: String
  cabinBagSize: String
  cabinBagWeight: String
  penalty: String @deprecated
  penaltyFee: Money
  priorityBoardingIncluded: Boolean
  cabinBagType: CabinBagType!
}

input CabinBagsRequest {
  section: Int!
  numPassenger: Int!
  type: String!
}

type CabinBagsSelection {
  segment: Int!
  section: Int!
  numPassenger: Int!
  fee: Money! @deprecated
  totalPrice: Money! @deprecated
  totalPrimePrice: Money @deprecated
  type: String!
  debugInfo: String
  priceBreakdown: CabinBagPriceBreakdown! @deprecated
  prices: [AncillaryPriceItem!]!
}

type CabinBagPBDConfiguration {
  cabinBagType: CabinBagType
  cabinBagWeight: String
}

type CabinBagPriceBreakdown {
  fee: Money!
  primeFee: Money
  totalPrice: Money!
  totalPrimePrice: Money
}

enum SeatType {
  WINDOW
  MIDDLE
  AISLE
  NO_SEAT
}

enum SeatCharacteristic {
  CHARGEABLE_SEAT
  EXTRA_LEG
  LAVATORY
  GALLEY
  INFANT_ALLOWED
  EXIT
}

type SeatMapSegment {
  segment: Int!
  seatMaps: [SeatMap]!
}

type SeatMap {
  cabins: [Cabin!]!
  section: Int!
}

type Cabin {
  seats: [Seat]!
  distribution: [String!]!
  exitRows: [Int]!
  extraLegSeats: [String]!
  floor: Int!
  seatMapRowFrom: Int!
  seatMapRowTo: Int!
  firstSeatsRow: Int!
  lastSeatsRow: Int!
}

type Seat {
  floor: Int!
  row: Int!
  seatMapRow: Int!
  column: String!
  type: SeatType!
  price: Money! @deprecated
  primePrice: Money @deprecated
  fee: Money! @deprecated
  characteristics: [SeatCharacteristic]!
  prices: [AncillaryPriceItem!]!
}

input PassengerSeatsSelectionRequest {
  passenger: Int!
  selection: [SelectedSeatRequest!]
}

input SelectedSeatRequest {
  section: Int!
  Seat: SeatRequest
}

input SeatRequest {
  floor: Int!
  row: Int!
  seatMapRow: Int!
  column: String!
  displayedPrice: MoneyRequest!
}

type SeatsSelection {
  passenger: Int!
  floor: Int!
  row: Int!
  seatMapRow: Int!
  column: String!
  segment: Int!
  section: Int!
  price: Money! @deprecated
  primePrice: Money @deprecated
  fee: Money! @deprecated
  prices: [AncillaryPriceItem!]!
}

type TravellerSeat {
  from: Location
  to: Location
  sectionId: ID
  seatDescription: TravellerSeatDescription
}

type TravellerSeatDescription {
  rowSelection: String
  columnSelection: String
  assignedSeat: String
}

type SitTogetherOffer {
  price: Money!
  primePrice: Money!
  seats: [SitTogetherSeat!]!
}

type SitTogetherSeat {
  section: Int!
  floor: Int!
  row: Int!
  seatMapRow: Int!
  column: String!
}

enum Consent {
  CASH_REFUND
  AIRLINE_ALTERNATIVE
  CUSTOMER_ALTERNATIVE
}

input UpdateConsentRequest {
  tripDetailsToken: String!
  incidentId: ID!
  consent: Consent!
}

type UpdateConsentResponse {
  incidentId: ID!
}

enum C4ARRedemptionType {
  CASH
  VOUCHER
}

enum NotCancellableReason {
  THIRD_PARTY
  IMMEDIATE_DEPARTURE
  TRIP_IN_THE_PAST
  INCIDENT_PRESENT
  REQUEST_IN_PROGRESS
  UNKNOWN
}

type CancellableResponse {
  cancellable: Boolean!
  notCancellableReason: NotCancellableReason
}

input CancellableRequest {
  bookingId: Long!
  email: String!
}

type ItineraryVoluntaryCancellation {
  cancellationId: String!
  taskOnDemandId: Long
  refundTaskId: Long
}

input ItineraryVoluntaryCancellationRequest {
  bookingId: Long!
  email: String!
  bookingItemId: Long!
  c4arRedemptionApplied: Boolean
  c4arRedemptionType: C4ARRedemptionType
}

input ApplyCancellationOptionRequest {
  bookingId: Long!
  email: String!
  cancellationOptionId: String!
}

type RefundAmountResponse {
  amount: Float! @bigdecimal @deprecated(reason: "used for backward compatibility")
  currency: String! @deprecated(reason: "used for backward compatibility")
  basedOnFareRules: Boolean!
  refundAmount: Money!
}

type VoluntaryCancellationOptionsRetrievementResponse {
  c4arCashRefund: C4arCashRefundOption
  c4arVoucherRefund: C4arVoucherRefundOption
  cancellationCashRefund: CancellationCashRefundOption
  freeCancellationCashRefund: FreeCancellationCashRefundOption
}

type FreeCancellationCashRefundOption {
  cancellationOptionId: String!
  refundAmount: Money!
  hoursLeftToCancel: Int!
}

type CancellationCashRefundOption {
  cancellationOptionId: String!
  refundAmount: Money!
  basedOnProviderRules: Boolean!
}

type C4arCashRefundOption {
  cancellationOptionId: String!
  refundAmount: Money
}

type C4arVoucherRefundOption {
  cancellationOptionId: String!
  refundAmount: Money
}

input VoluntaryCancellationOptionsRetrievementRequest {
  bookingId: Long!
  bookingItemId: Long!
}

type PrimeFreeCancellationResponse {
  compensation: PrimeFreeCancellationCompensation!
}

union PrimeFreeCancellationCompensation = PrimeFreeVoucherCancellationCompensation

type PrimeFreeVoucherCancellationCompensation {
  amount: Money!
}

input PrimeFreeCancellationRequest {
  bookingToken: String!
}

enum FlashOfferProductType {
  SEAT
}

enum FlashOfferType {
  SIT_TOGETHER
}

enum RejectFlashOfferStatus {
  REJECTED
  ERROR
}

enum SelectFlashOfferError {
  INVALID_SELECTION
  TIMED_OUT
  ERROR
}

enum ConfirmFlashOfferStatus {
  CONFIRMED
  USER_INTERACTION_NEEDED
  TIMED_OUT
  ERROR
}

type GetFlashOffersResponse {
  expirationTimestamp: Long
  estimatedExpirationDurationInSeconds: Long
  flashOffers: [FlashOffer!]!
}

interface FlashOffer {
  id: ID!
  productType: FlashOfferProductType!
  offerType: FlashOfferType!
  primePrice: Money!
  nonPrimePrice: Money!
}

type SitTogetherFlashOffer implements FlashOffer {
  id: ID!
  productType: FlashOfferProductType!
  offerType: FlashOfferType!
  primePrice: Money!
  nonPrimePrice: Money!
  seats: [SitTogetherSeat!]!
}

input SelectFlashOfferRequest {
  offerId: ID!
}

type SelectFlashOfferResponse {
  error: SelectFlashOfferError
  offer: FlashOffer
}

type RejectFlashOffersResponse {
  status: RejectFlashOfferStatus!
}

input ConfirmFlashOfferRequest {
  paymentInstrumentToken: String!
}

interface FlashOfferConfirmationProcessResponse {
  status: ConfirmFlashOfferStatus!
  rData: RDataResponse
}

type ConfirmSelectedFlashOfferErrorResponse implements FlashOfferConfirmationProcessResponse {
  status: ConfirmFlashOfferStatus!
  rData: RDataResponse
}

type ConfirmSelectedFlashOfferAuthorizedResponse implements FlashOfferConfirmationProcessResponse {
  status: ConfirmFlashOfferStatus!
  rData: RDataResponse
  offer: FlashOffer!
}

type ConfirmSelectedFlashOfferInteractionNeededResponse implements FlashOfferConfirmationProcessResponse {
  status: ConfirmFlashOfferStatus!
  rData: RDataResponse
  interactionStep: Int!
  interactionType: InteractionType!
  redirectUrl: String
  formSendType: FormSendType
  parameters: [Param!]
}

enum ShoppingBasketCollectionStatus {
  UNKNOWN
  FAILED
  SUCCESS
  USER_PAYMENT_INTERACTION
}

enum ShoppingBasketCollectionFailure {
  UNKNOWN
  ACQUIRER_UNAVAILABLE
  AMOUNT_HIGHER_THAN_ALLOWED
  BUYERS_FUNDING_SOURCE_FAILED
  CARD_EXPIRED
  CARD_NOT_IN_AUTHORIZERS_DB
  DATA_VALIDATION_ERROR
  DECLINED
  FRAUD_SUSPECT
  INSUFFICIENT_CREDIT
  INVALID_AMOUNT
  INVALID_CARD_NUMBER
  INVALID_CURRENCY
  LOST_CARD
  NOT_PERMITTED_TO_CARDHOLDER
  ORDER_ALREADY_USED
  ORDER_NOT_AUTHORIZE
  ORDER_WITHOUT_REFUNDABLE_PAYMENTS
  REJECTED_BY_BANK
  SCHEME_REJECTION
  TRANSACTION_NO_EXIST
  UNEXPECTED_STATUS
  UNKNOWN_ORDER
  UNKNOWN_ORIGIN_IP
  UNSUPPORTED_GATEWAY_COLLECTION_METHOD
  WRONG_CREDITCARD_EXPIRATION_DATE
  WRONG_CVV2
  WRONG_ELV_ACCOUNT
}

enum ShoppingBasketFormSendType {
  GET
  POST
}

enum CheckoutOrigin {
  ITINERARY_PAYMENT
  ACCOMMODATION_PAYMENT
  UNIVERSAL_PAYMENT
  DECOUPLE_PRIME_SUBSCRIPTION_ITINERARY
}

input ShoppingBasketCheckoutRequest {
  shoppingBasketId: ID!
  collectionOptionId: ID!
  paymentInstrumentToken: String!
  invoice: ShoppingBasketInvoiceRequest
  userCollectionTrackingId: ID!
}

input ShoppingBasketInvoiceRequest {
  fiscalCode: String!
  legalName: String!
  address: String!
  city: String!
  country: String!
  email: String!
  required: Boolean!
  postcode: String!
  professional: Boolean!
}

input UserPaymentInteractionParamInput {
  key: String!
  value: String!
}

input ShoppingBasketAddUserPaymentInteractionOutcomeRequest {
  userPaymentInteractionId: ShoppingBasketUserPaymentInteractionIdInput!
  outcome: [UserPaymentInteractionParamInput!]!
}

input ShoppingBasketUserPaymentInteractionRequest {
  userPaymentInteractionId: ShoppingBasketUserPaymentInteractionIdInput!
}

input ShoppingBasketUserPaymentInteractionIdInput {
  id: ID!
}

input ShoppingBasketAddRedirectRequest {
  userPaymentInteractionId: ID!
  redirectType: RedirectType!
  shoppingBasketId: ID!
  checkoutOrigin: CheckoutOrigin!
}

type ShoppingBasketCheckoutResponse {
  collectionInfo: ShoppingBasketCheckoutCollectionInfo!
  userPaymentInteractionId: ID
}

type ShoppingBasketCheckoutCollectionInfo {
  collectionStatus: ShoppingBasketCollectionStatus!
  collectionFailure: ShoppingBasketCollectionFailure
}

type ShoppingBasketAddUserPaymentInteractionOutcomeResponse {
  success: Boolean!
}

input ShoppingBasketResumeRequest {
  shoppingBasketId: ID!
  userPaymentInteractionId: ID!
}

type ShoppingBasketUserPaymentInteractionResponse {
  formSendType: ShoppingBasketFormSendType
  parameters: [UserPaymentInteractionParam!]!
  redirectUrl: String
  javascriptSnippet: String
  paypalUserPaymentInteraction: PaypalUserPaymentInteraction
}

type UserPaymentInteractionParam {
  key: String!
  value: String!
}

type PaypalUserPaymentInteraction {
  merchantId: String
  paypalToken: String
}

type ShoppingBasketAddRedirectResponse {
  success: Boolean!
}

input ShoppingBasketAddCreditCardRequest {
  paymentInstrumentToken: String!
  isDefault: Boolean = false
}

type ShoppingBasketAddCreditCardResponse {
  success: Boolean!
}

input ShoppingBasketUserStoredCreditCardsRequest {
  shoppingBasketId: ID!
}

type ShoppingBasketUserStoredCreditCardsResponse {
  userStoredCreditCards: [ShoppingBasketUserStoredCreditCard!]!
}

type ShoppingBasketUserStoredCreditCard {
  creditCard: ShoppingBasketCreditCard!
  collectionOptionId: String!
}

type ShoppingBasketCreditCard {
  creditCardNumber: String
  expirationDateMonth: String
  expirationDateYear: String
  owner: String
  creditCardTypeId: CreditCardsType
  creditCardCode: String
  paymentInstrumentTokenWithoutCvv: String!
}

input ShoppingBasketUserCollectionBrowser {
  height: String!
  width: String!
}

input ShoppingBasketUserCollectionTrackingRequest {
  shoppingBasketId: ID!
  browserData: ShoppingBasketUserCollectionBrowser
}

type ShoppingBasketUserCollectionTrackingResponse {
  userCollectionTrackingId: String
}

type RecurringCollectionResponse {
  id: ID!
  paymentInstruments: [RecurringCollectionPaymentInstrument]
}

interface RecurringCollectionPaymentInstrument {
  isDefault: Boolean
}

input UpdateRecurringCollectionRequest {
  id: ID!
  paymentInstrumentToken: ID!
}

input RecurringPaymentInstrumentVerifierShoppingBasketCreationRequest {
  crmToken: String!
}

type RecurringPaymentInstrumentVerifierShoppingBasketCreationResponse {
  shoppingBasketId: ID!
}

input RecurringPaymentInstrumentVerifierProductEvaluationRequest {
  creditCardBin: String!
  paymentInstrumentToken: String @deprecated(reason: "Not used, will be removed in next iterations")
  creditCardExpirationDate: String @deprecated(reason: "Not used, will be removed in next iterations")
  membershipId: String @deprecated(reason: "Not used, will be removed in next iterations")
}

type RecurringPaymentInstrumentVerifierProductEvaluationResponse {
  code: RecurringPaymentInstrumentVerifierProductEvaluationCode!
}

enum RecurringPaymentInstrumentVerifierProductEvaluationCode {
  BLOCKING_BIN
  EXPIRING_BEFORE_MEMBERSHIP_RENEWAL
  NO_RISK
  EXISTING_PAYMENT_INSTRUMENT_TOKEN
}

enum AccommodationInsuranceCompanyName {
  AXA
}

enum AccommodationInsuranceProductType {
  ACCOMMODATION_CANCELLATION
  ACCOMMODATION_CANCELLATION_AND_MEDICAL_ASSISTANCE
}

enum AccommodationInsuranceTermsAndConditionsType {
  IMPORTANT_PRODUCT_INFORMATION
  PRE_CONTRACTUAL_INFORMATION
  PRE_CONTRACTUAL_INFORMATION_SUMMARY
  STATUS_DISCLOSURE_INFORMATION
}

enum AccommodationInsurancePriceType {
  NON_PRIME
  PRIME
}

input AccommodationInsurancesRequest {
  shoppingBasketId: ID!
}

type AccommodationInsurancesResponse {
  accommodationInsurances: [AccommodationInsurance!]!
}

type AccommodationInsurance {
  companyName: AccommodationInsuranceCompanyName!
  offerId: String!
  policyCode: String!
  prices: [AccommodationInsurancePrice!]!
  productId: String
  selected: Boolean!
  termsAndConditions: [AccommodationInsuranceTermsAndConditions!]!
  type: AccommodationInsuranceProductType!
}

type AccommodationInsurancePrice {
  perception: PricePerception!
  type: AccommodationInsurancePriceType!
  value: Money!
}

type AccommodationInsuranceTermsAndConditions {
  type: AccommodationInsuranceTermsAndConditionsType!
  url: String!
}

input SelectAccommodationInsuranceRequest {
  offerId: String!
  priceType: AccommodationInsurancePriceType
  shoppingBasketId: ID!
}

input UnselectAccommodationInsuranceRequest {
  productId: String!
  shoppingBasketId: ID!
}

type SelectAccommodationInsuranceResponse {
  productId: String!
}

type UnselectAccommodationInsuranceResponse {
  productId: String!
}

input MembershipStandaloneCampaignRequest {
  campaignCode: String
  token: String
}

type MembershipStandaloneCampaignResponse {
  offer: MembershipStandalonePlanDetails
  personalDetails: PersonalDetails
  campaignCode: String!
  funnel: MembershipStandaloneFunnel!
}

type MembershipStandalonePlanDetails implements MembershipPlanDetails {
  id: ID!
  tier: SubscriptionOfferType!
  renewalPrice: Money!
  discountedPrice: Money!
  originalPrice: Money!
  duration: SubscriptionOfferDuration!
  renewalDuration: SubscriptionOfferDuration!
  discountPercentage: Int!
  autoRenewalPolicy: AutoRenewalPolicy!
  contractedPerks: [ContractedMembershipPerk!]!
}

type PersonalDetails {
  name: String!
  lastName: String!
  email: String!
}

enum MembershipStandaloneFunnel {
  STANDALONE_CAMPAIGN
  STANDALONE_CAMPAIGN_PAYPAL
  STANDALONE_CUSTOMER_SERVICES
  STANDALONE_PARTNER
  UNKNOWN
}

input MembershipStandaloneShoppingBasketCreationRequest {
  token: String
  membershipStandalonePersonalData: MembershipStandalonePersonalDataInput
}

type MembershipStandaloneShoppingBasketCreationResponse {
  shoppingBasketId: ID!
}

input MembershipStandalonePersonalDataInput {
  name: String!
  lastName: String!
  email: String!
  address: String!
  city: String!
  postalCode: String!
  country: String!
  countryCode: String!
  phone: PhoneInput!
}

type MembershipStandalonePersonalData {
  name: String!
  lastName: String!
  email: String!
  address: String!
  city: String!
  postalCode: String!
  country: String!
  countryCode: String!
  phone: Phone!
}

input MembershipStandaloneCheckoutStatusRequest {
  shoppingBasketId: ID!
}

type MembershipStandaloneCheckoutStatusResponse {
  activated: Boolean!
}

input MembershipStandalonePersonalDataRequest {
  shoppingBasketId: ID!
}

type MembershipStandalonePersonalDataResponse {
  membershipStandalonePersonalData: MembershipStandalonePersonalData
}

input MembershipStandaloneOfferDetailsRequest {
  shoppingBasketId: ID!
}

type MembershipStandaloneOfferDetailsResponse {
  offer: MembershipStandalonePlanDetails
}

type RetrievePaypalStandaloneEligibilityResponse {
  eligible: Boolean!
  planDetails: PrimeMemberPlanDetails
}

input MembershipStandalonePostBookingRequest {
  shoppingId: ID!
  expirationDate: String! @dateISO8601
  hash: String!
}

input SelectUnchainedMembershipPostBookingRequest {
  bookingId: ID
  email: String
  unchainedMembershipOfferToken: UnchainedMembershipOfferTokenInput
}

input UnchainedMembershipOfferTokenInput {
  token: String!
}

input RetrieveUnchainedMembershipPostBookingEligibilityRequest {
  bookingId: ID!
  email: String!
}

type RetrieveUnchainedMembershipPostBookingEligibilityResponse {
  eligible: Boolean!
  planDetails: PrimeMemberPlanDetails!
  compensation: [MembershipPostBookingCompensation!]!
  unchainedMembershipOfferToken: UnchainedMembershipOfferToken!
}

type UnchainedMembershipOfferToken {
  token: String!
}

type MembershipPostBookingCompensation {
  type: CompensationType!
  amount: Money!
}

enum CompensationType {
  CASH_BACK
  VOUCHER
}

type SelectUnchainedMembershipPostBookingResponse {
  status: MembershipStandaloneResponseStatus!
  accountDetails: MembershipStandaloneAccountDetails!
  planDetails: PrimeMemberPlanDetails!
  compensation: [MembershipPostBookingCompensation!]!
}

type MembershipStandalonePostBookingResponse {
  status: MembershipStandaloneResponseStatus!
  accountDetails: MembershipStandaloneAccountDetails
  paymentDetails: MembershipStandalonePaymentInstrument
  planDetails: PrimeMemberPlanDetails
}

enum MembershipStandaloneResponseStatus {
  INIT
  PROCESSING
  SUCCESS
}

type MembershipStandaloneAccountDetails {
  name: String!
}

interface MembershipStandalonePaymentInstrument {
  type: PaymentMethod!
}

type MembershipStandalonePaymentCreditCard implements MembershipStandalonePaymentInstrument {
  type: PaymentMethod!
  lastDigits: String!
}

input RetrieveSubscriptionEligibilityOfferDetailsRequest {
  email: String!
  touchpoint: Touchpoint!
}

input CalculatePrimeSubscriptionPostPurchaseOffersRequest {
  email: String
  bookingId: Long
  touchpoint: Touchpoint!
}

input SelectPostBookingSubscriptionOfferRequest {
  token: String!
}

type RetrieveSubscriptionEligibilityOfferDetailsResponse {
  eligible: Boolean!
  token: String!
  offerInformation: PostBookingSubscriptionOffer!
}

type CalculatePrimeSubscriptionPostPurchaseOffersResponse {
  offers: [PostPurchaseSubscriptionOffer!]!
}

type PostPurchaseSubscriptionOffer {
  token: PostPurchaseSubscriptionToken!
  offerInformation: PostBookingSubscriptionOffer!
}

type PostPurchaseSubscriptionToken {
  token: String!
  tokenType: PostPurchaseSubscriptionTokenType!
}

enum PostPurchaseSubscriptionTokenType {
  ZERO_AUTH
  UNCHAINED
}

type SelectPostBookingSubscriptionOfferResponse {
  shoppingBasketId: ID!
  collectionMethodId: String!
  paymentInstrumentToken: String!
  offerInformation: PostBookingSubscriptionOffer!
  checkoutMethod: CheckoutMethod!
  bookingId: Long!
}

enum CheckoutMethod {
  ONLY_3DS
  CVV_WITH_3DS
}

type RetrieveSubscriptionCheckoutDetailsResponse {
  offerInformation: PostBookingSubscriptionOffer!
  status: SubscriptionPBOperationResponseStatus!
  buyer: BuyerCheckoutDetails
}

type BuyerCheckoutDetails {
  name: String
}

input RetrieveSubscriptionCheckoutDetailsRequest {
  shoppingBasketId: ID!
}

enum SubscriptionPBOperationResponseStatus {
  PROCESSING
  SUCCESS
  ERROR
}

type PostBookingSubscriptionOffer {
  price: Money!
  duration: SubscriptionOfferDuration!
  renewalPrice: Money!
  renewalDuration: SubscriptionOfferDuration!
  plan: SubscriptionOfferType!
  rewards: [PostBookingSubscriptionOfferReward!]
}

enum Touchpoint {
  MY_TRIPS @deprecated
  TRIP_LIST
  ACCOUNT_DETAILS @deprecated
  LOGIN_AND_SECURITY
  CONF_PAGE
  MANAGE_BOOKING
  EML @deprecated
  HOME_PAGE
  UNLOCK_VIP_SUPPORT
  PRICE_FREEZE
  FLIGHTS_CONFIRMATION_XSELL
  EMERGING_LAYER_PAYMENT_PAGE
}

type PostBookingSubscriptionOfferReward {
  amount: Money!
  type: PostBookingSubscriptionOfferRewardType!
}

enum PostBookingSubscriptionOfferRewardType {
  VOUCHER
}

type ReferralLinkToken {
  token: String!
}

type VoucherDetails {
  amount: Money!
}

type SelectReferralLinkTokenResponse {
  token: ReferralLinkToken
  voucher: VoucherDetails
}

type SelectReferralLinkTokenResponseV2 {
  token: ReferralLinkToken
  referrerVoucher: [VoucherDetails!]!
  referredVoucher: [VoucherDetails!]!
  maxSaveMoney: Float
  referralSubscriptionOffer: ReferralSubscriptionOffer
}

type ReferralSubscriptionOffer {
  freeTrial: Boolean!
  plan: SubscriptionOfferType!
  durationPolicy: DurationPolicy!
}

input SelectReferralLinkTokenRequestV2CRMFlow {
  userToken: String!
}

input SelectMembershipStandaloneReferralRequest {
  token: String!
}

type SelectMembershipStandaloneReferralResponse {
  status: ReferralStandaloneResponseStatus!
  accountDetails: MembershipStandaloneAccountDetails!
  planDetails: PrimeMemberPlanDetails!
}

enum ReferralStandaloneResponseStatus {
  INIT
  PROCESSING
  SUCCESS
}

input PhoneNumber {
  countryCode: String!
  phone: String!
}

input CreateReferralSubscriptionRequest {
  name: String!
  lastName: String!
  email: String!
  phoneNumber: PhoneNumber!
  offerId: String!
}

enum ValidationMethod {
  SMS
}

type CreateReferralSubscriptionResponse {
  subscriptionId: String!
  validationMethod: ValidationMethod!
}

input CalculateReferralsOffersRequest {
  referrerToken: String!
}

type ReferralSubscription {
  offerId: String!
  freeTrial: Boolean!
  subscriptionPrice: SubscriptionPrice!
  subscriptionPlan: SubscriptionOfferType!
  durationPolicy: DurationPolicy!
}

type DurationPolicy {
  duration: Int
  durationTimeUnit: MembershipDurationTimeUnit
  renewalDuration: Int
  renewalDurationTimeUnit: MembershipDurationTimeUnit
}

type SubscriptionPrice {
  price: Money
  renewalPrice: Money
}

type Compensation {
  amount: Money
}

type ReferralReward {
  referrer: [Compensation!]!
  referred: [Compensation!]!
}

type CalculateReferralsOffersResponse {
  offer: [ReferralSubscription!]!
  reward: ReferralReward
}

input ConfirmReferralSubscriptionRequest {
  subscriptionId: String!
  validationCode: String!
  unsubscribeToCommercials: Boolean
}

enum ValidationCode {
  SUCCESS
  ERROR
  INVALID
  EXPIRED
}

type ConfirmReferralSubscriptionResponse {
  status: ValidationCode!
  subscriptionId: String
}

input GetReferralRewardRequest {
  subscriptionId: String!
}

type GetReferralRewardResponse {
  reward: ReferralReward
  subscription: ReferralSubscription
}

enum PricePerceptionConfig {
  BEST_PRICE
  FULL_PRICE
  DISPLAY_PRICE_WITH_SEPARATED_TAX
  DISPLAY_PRICE_WITHOUT_SEPARATED_TAX
}

enum PriceBreakDownItemType {
  FLIGHT
  INSURANCE
  ADDITION
  BAGGAGE
  SERVICE_FEE
  PAYMENT_METHOD_FEE
  BRAND_PAYMENT_METHOD_DISCOUNT
  PROMO_CODE
  SERVICE_OPTIONS
  SEAT
  ACCOMMODATION
  MEMBERSHIP_SUBSCRIPTION
  HAND_BAGGAGE
  CABIN_BAG
  FARE_RULE
  DISCOUNT
  FAST_TRACK
  ANCILLARY_SERVICE_CHARGES
  FLIGHT_AND_ACCOMMODATION
}

enum DiscountType {
  DEFAULT
  MEMBERSHIP_PERK
  DYNPACK
  PAYMENT_METHOD_FEE
  PROMO_CODE
  VOUCHER
}

enum FeeSelected {
  FULL_PRICE
  PRIME_PRICE
}

enum PriceBreakdownPage {
  PASSENGERS
  PAYMENT
}

enum ShoppingBasketPricePerceptionType {
  NON_PRIME_PRICE_PER_TRAVELLER
  PRIME_PRICE_PER_TRAVELLER
}

enum ShoppingBasketPriceBreakdownItemConcept {
  PROVIDER_PRICE
  SERVICE_FEE
  PRIME_DISCOUNT
  PROMOCODE_DISCOUNT
}

interface PriceSummary {
  amount: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  pricePerception: PricePerceptionConfig!
}

interface PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
}

interface AncillaryProductItem implements PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
  providerPrice: Money
  serviceFeeTaxes: Money
}

type DiscountInfo {
  percentage: Int!
  discount: Money!
  type: DiscountType!
  isApplied: Boolean!
}

type DefaultPriceBreakDownItem implements PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
  tax: Money
  fare: Money
  markup: Money
}

type ItineraryPriceBreakDownItem implements PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
  providerFare: Money
  serviceFeeTaxes: Money
  flightTaxes: Money
  totalTaxes: Money
}

type NonEssentialProductPriceBreakDownItem implements PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
  offerId: String!
}

type InsurancePriceBreakDownItem implements PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
  offerId: String!
  isTripInsurance: Boolean!
}

type BaggagePriceBreakDownItem implements AncillaryProductItem & PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  providerPrice: Money
  serviceFeeTaxes: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
  baggageConditions: [BaggageConditionsTraveller!]! @deprecated
}

type CabinBagPriceBreakDownItem implements AncillaryProductItem & PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  providerPrice: Money
  serviceFeeTaxes: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
  cabinBagPBDConfiguration: CabinBagPBDConfiguration
}

type SeatPriceBreakDownItem implements AncillaryProductItem & PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  providerPrice: Money
  serviceFeeTaxes: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
}

type PromoCodePriceBreakDownItem implements PriceBreakDownItem {
  price: Money! @deprecated
  totalPrice: Money!
  nonDiscountedPrice: Money
  discountedPrice: Money
  type: PriceBreakDownItemType!
  quantity: Int! @deprecated
  discountInfo: [DiscountInfo!]
  code: String!
  id: ID!
}

input PriceBreakDownRequest {
  shoppingInfo: ShoppingInfo
  collectionMethodInfo: CollectionMethodInfo
  feeSelected: FeeSelected = FULL_PRICE
  requestPage: PriceBreakdownPage = PAYMENT
}

type CartPriceBreakDown {
  items: [PriceBreakDownItem!]
  priceSummary: PriceSummary!
}

input ShoppingBasketPriceRequest {
  shoppingInfo: ShoppingInfo!
  products: [ShoppingBasketProductPriceRequest!]
  collectionOptionIdSelected: ID
}

input ShoppingBasketProductPriceRequest {
  productId: ProductIdRequest!
  sellingPrice: String
}

type ShoppingBasketPriceResponse {
  price: ShoppingBasketPrice
  pricePerception: ShoppingBasketPricePerception
}

type ShoppingBasketPricePerception {
  items: [ShoppingBasketPricePerceptionItem!]!
}

type ShoppingBasketPricePerceptionItem {
  type: ShoppingBasketPricePerceptionType!
  price: ShoppingBasketPrice!
}

type ShoppingBasketPrice {
  amount: Money!
  breakdown: ShoppingBasketPriceBreakdownList
}

type ShoppingBasketPriceBreakdownList {
  items: [ShoppingBasketPriceBreakdownItem!]!
}

type ShoppingBasketPriceBreakdownItem {
  concept: String! @deprecated(reason: "Use priceConcept instead")
  priceConcept: ShoppingBasketPriceBreakdownItemConcept!
  price: ShoppingBasketPrice!
}

input DecouplingPrimeSubscriptionFlowStateRequest {
  primeSubscriptionContext: PrimeSubscriptionContext
  mainFunnelContext: MainFunnelContext!
}

input PrimeSubscriptionContext {
  shoppingInfo: ShoppingInfo!
}

input MainFunnelContext {
  shoppingInfo: ShoppingInfo!
}

type DecouplingPrimeSubscriptionFlowStateResponse {
  state: DecouplingPrimeSubscriptionFlowState!
}

enum DecouplingPrimeSubscriptionFlowState {
  FORBIDDEN_MEMBERSHIP_ACTIVATED
  NOT_INITIALIZED
  INITIALIZED
  FINISHED_WAITING_FOR_ACTIVATION
  FINISHED_MEMBERSHIP_ACTIVATED
}

input InitDecouplingPrimeSubscriptionFlowRequest {
  mainFunnelContext: MainFunnelContext!
  primeSubscriptionContext: PrimeSubscriptionContext
  selectedOfferItemRef: String!
}

type InitDecouplingPrimeSubscriptionFlowResponse {
  shoppingBasketId: ID!
}

input ConfirmDecouplingPrimeSubscriptionFlowRequest {
  mainFunnelContext: MainFunnelContext!
  primeSubscriptionContext: PrimeSubscriptionContext!
}

type ConfirmDecouplingPrimeSubscriptionFlowResponse {
  success: Boolean!
}

input CalculatePrimeSubscriptionOfferRequest {
  context: PrimeSubscriptionOfferContext
  evaluationContext: PrimeSubscriptionOfferEvaluationContext
}

input PrimeSubscriptionOfferContext {
  funnel: PrimeSubscriptionOfferContextFunnel
  touchpoint: PrimeSubscriptionOfferContextTouchPoint
}

input PrimeSubscriptionOfferEvaluationContext {
  paymentInstrumentToken: String
  creditCardBin: String
  creditCardDate: String
  shoppingInfo: ShoppingInfo!
  selectedOfferItemRef: String!
}

enum PrimeSubscriptionOfferContextTouchPoint {
  ACCOUNT_DETAILS
  EMERGING_LAYER_PAYMENT_PAGE
  MANAGE_BOOKING
  MY_TRIPS
  PRICE_FREEZE
}

enum PrimeSubscriptionOfferContextFunnel {
  ACCOMMODATION
  ITINERARY
  PRICE_FREEZE
}

type CalculatePrimeSubscriptionOfferResponse {
  offer: PrimeSubscriptionOffer!
  evaluationCode: MembershipProductEvaluationCode
}

type PrimeSubscriptionOffer {
  offerItems: [PrimeSubscriptionOfferItem!]!
}

type PrimeSubscriptionOfferItem {
  itemRef: String!
  planName: PrimeSubscriptionOfferItemPlanName!
  tier: PrimeSubscriptionOfferItemTier!
  price: Money!
}

type PrimeSubscriptionOfferItemTier {
  valueProposition: PrimeSubscriptionOfferTierValueProposition!
  conditions: [PrimeSubscriptionOfferTierCondition!]!
}

interface PrimeSubscriptionOfferTierCondition {
  code: PrimeSubscriptionOfferTierConditionCode!
}

type PrimeSubscriptionOfferTierFreeTrialCondition implements PrimeSubscriptionOfferTierCondition {
  code: PrimeSubscriptionOfferTierConditionCode!
  period: String! @period
}

type PrimeSubscriptionOfferTierRenewalCondition implements PrimeSubscriptionOfferTierCondition {
  code: PrimeSubscriptionOfferTierConditionCode!
  price: Money!
  period: String! @period
  commitmentPeriod: String! @period
}

type PrimeSubscriptionOfferTierYearlyWithMonthlyCollectionCondition implements PrimeSubscriptionOfferTierCondition {
  code: PrimeSubscriptionOfferTierConditionCode!
}

type PrimeSubscriptionOfferTierYearlyWithQuarterlyCollectionCondition implements PrimeSubscriptionOfferTierCondition {
  code: PrimeSubscriptionOfferTierConditionCode!
}

enum PrimeSubscriptionOfferItemPlanName {
  BASIC
  PLUS
}

type PrimeSubscriptionOfferTierValueProposition {
  perks: [PrimeSubscriptionOfferTierValuePropositionPerk!]!
}

interface PrimeSubscriptionOfferTierValuePropositionPerk {
  type: PrimeOfferTierValuePropositionPerkType!
}

type LimitedPrimeSubscriptionOfferTierValuePropositionPerk implements PrimeSubscriptionOfferTierValuePropositionPerk {
  type: PrimeOfferTierValuePropositionPerkType!
  usageQuota: Int!
}

type UnlimitedPrimeSubscriptionOfferTierValuePropositionPerk implements PrimeSubscriptionOfferTierValuePropositionPerk {
  type: PrimeOfferTierValuePropositionPerkType!
}

enum PrimeOfferTierValuePropositionPerkType {
  FRIENDS_AND_FAMILY_ITINERARY_DISCOUNT
  ITINERARY_CANCELLATIONS_FOR_RENEWABLE_MEMBERSHIP_FREE_TRIAL_PERIOD_ALLOWED
  ITINERARY_CANCELLATIONS_FOR_RENEWABLE_PAID_MEMBERSHIP_ONLY
  ITINERARY_CANCELLATION_FOR_SUBSCRIPTION_PURCHASE
  ONE_ITINERARY_CANCELLATION_FOR_RENEWABLE_MEMBERSHIP
  TWO_ITINERARY_CANCELLATIONS_FOR_NATURAL_YEAR
  UNLIMITED_ACCOMMODATION_DISCOUNT
  UNLIMITED_BAGS_DISCOUNTS
  UNLIMITED_CAR_RENTAL_DISCOUNT
  UNLIMITED_ITINERARY_DISCOUNT
  UNLIMITED_PRICE_FREEZE_DISCOUNT
  UNLIMITED_SEAT_DISCOUNTS
  UNLIMITED_FAST_TRACK_DISCOUNT
  UNLIMITED_AIRPORT_FAST_TRACK_DISCOUNT
}

enum PrimeSubscriptionOfferTierConditionCode {
  FREE_TRIAL_PERIOD
  YEARLY_WITH_MONTHLY_COLLECTION
  YEARLY_WITH_QUARTERLY_COLLECTION
  RENEWAL
  DEACTIVATE_AUTO_RENEWAL
}

input PrimeSubscriptionPostPurchaseTokenRequest {
  bookingId: ID!
  email: String!
}

input PrimeSubscriptionPostPurchaseOfferRequest {
  token: String!
}

input PrimeSubscriptionPostPurchaseRequest {
  token: String!
}

type PrimeSubscriptionPostPurchaseTokenResponse {
  primeSubscriptionPostPurchaseToken: PrimeSubscriptionPostPurchaseToken!
}

type PrimeSubscriptionPostPurchaseToken {
  token: String!
}

type PrimeSubscriptionPostPurchaseOfferResponse {
  eligible: Boolean!
  planDetails: PrimeMemberPlanDetails!
  compensation: [PrimeSubscriptionPostPurchaseCompensation!]!
}

type PrimeSubscriptionPostPurchaseResponse {
  status: MembershipStandaloneResponseStatus!
  accountDetails: MembershipStandaloneAccountDetails!
  planDetails: PrimeMemberPlanDetails!
  compensation: [PrimeSubscriptionPostPurchaseCompensation!]!
}

type PrimeSubscriptionPostPurchaseCompensation {
  type: PrimeSubscriptionPostPurchaseCompensationType!
  amount: Money!
}

enum PrimeSubscriptionPostPurchaseCompensationType {
  VOUCHER
}

input SearchItineraryRequest {
  buyPath: Int
  tripType: TripType!
  itinerary: ItinerarySearchItineraryRequest!
  unbundledMappingGrouping: UnbundledMappingGroupingType! = DEFAULT
}

input ItinerarySearchItineraryRequest {
  numAdults: Int!
  numChildren: Int!
  numInfants: Int!
  cabinClass: String
  segments: [SegmentItineraryRequest!]!
  externalSelection: ExternalSelectionRequest
  excludeCarriers: Boolean
}

input SegmentItineraryRequest {
  date: String! @yyyyMMddTHHmmssZZZZZ
  departure: LocationRequest!
  destination: LocationRequest!
}

type SearchItineraryResponse {
  searchId: Long!
  searchCode: SearchCode
  priceTypeDisplayed: ItineraryResultPriceType
  itineraries: [SearchItineraryResult!]!
  externalSelection: ExternalSelection
  insuranceOffers: [InsuranceOfferValue!]!
  carbonFootprints: [CarbonFootprintValue!]!
  campaignConfigs: [CampaignConfigValue!]!
  trackingInfo: TrackingInfo
  campaignsItineraryLists: [Campaign!]!
  freeCancellationItineraryIds: [String!]
  segments: [SegmentValue!]!
  sections: [SectionValue!]!
  carriers: [CarrierValue!]!
  locations: [LocationValue!]!
  unbundledMapping: [UnbundledMapping!]!
}

type SearchItineraryResult {
  key: ID!
  ticketsLeft: Int!
  legs: [SearchItineraryResultLeg!]
  transportTypes: [TransportType!]!
  meRating: Float! @bigdecimal
  fees: [SearchResponseFee!]!
  perks: Perks
  carbonFootprintId: ID
  campaignConfigId: ID
  hotelXSellingEnabled: Boolean!
  isFareUpgradeAvailable: Boolean!
}

type SegmentValue {
  id: ID!
  segment: SearchItineraryResultSegment!
}

type SectionValue {
  id: ID!
  section: SearchItineraryResultSection!
}

type SearchItineraryResultLeg {
  segmentKey: ID!
  segmentId: ID!
}

type SearchItineraryResultSegment {
  id: ID!
  carrierId: ID!
  duration: Long
  sections: [ID!]!
  baggageCondition: BaggageCondition!
  transportTypes: [TransportType!]!
  ticketsLeft: Int!
}

type SearchItineraryResultSection {
  id: ID!
  arrivalDate: String! @yyyyMMddTHHmmssZZZZZ
  departureDate: String! @yyyyMMddTHHmmssZZZZZ
  departureId: ID!
  destinationId: ID!
  arrivalTerminal: String
  departureTerminal: String
  carrierId: ID!
  operatingCarrierId: ID
  commercialBrandId: ID
  cabinClass: CabinClass!
  flightCode: String!
  duration: Long
  insuranceOfferId: ID
  technicalStops: [TechnicalStop!]!
  transportType: TransportType!
  vehicleModel: String
}

type UnbundledMapping {
  outboundSegmentId: ID!
  cheapestFees: [SearchResponseFee!]!
  bestMeRating: Float! @bigdecimal
  compatibleInboundSegments: [CompatibleInboundSegment!]!
}

type CompatibleInboundSegment {
  inboundSegmentId: ID!
  itineraryKey: ID!
  fees: [SearchResponseFee!]!
}

enum UnbundledMappingGroupingType {
  DEFAULT
  TRANSPORT_TYPES
}

"""
Input for the searchTrain query. Includes all fields from the standard
itinerary, using the specific itineraryRequest for trains.
"""
input SearchTrainsRequest {
  buyPath: Int
  tripType: TripType!
  itinerary: TrainSearchItineraryRequest!
}

"""
Input for the itinerary train search. Includes all fields from the standard
itinerary search (except numAdults, numChildren and numInfants) plus a train passengers request with their specific type and age.
"""
input TrainSearchItineraryRequest {
  passengers: [TrainPassengerRequest!]!
  cabinClass: String
  segments: [SegmentItineraryRequest!]!
  excludeCarriers: Boolean
}

"""Request for the passenger age and type."""
input TrainPassengerRequest {
  travellerType: TravellerType!
  age: Int!
}

"""Enum for the travellerType."""
enum TravellerType {
  ADULT
  CHILD
  INFANT
}

enum ProductType {
  ACCOMMODATION
  AIRPORT_FAST_TRACK
  BAGGAGE
  INSURANCE
  ITINERARY
  ITINERARY_PRICE_FREEZE
  MEMBERSHIP_SUBSCRIPTION
  SEAT
  SERVICE_OPTION
  MEMBERSHIP_RENEWAL
  BOARDING_OPTION
  ADDITIONAL_PRODUCT
  ADDITIONAL_FARE_RULE
  PROMO_CODE
  RECURRING_PAYMENT_INSTRUMENT_VERIFIER
  VEHICLE_RENTAL
}

enum ItemCheckoutFlow {
  UNKNOWN
  ACCOMMODATION_BOOKING_FLOW
  ACCOMMODATION_SHOPPING_CART_FLOW
  ACCOMMODATION_MODIFICATION_FLOW
  AIRPORT_FAST_TRACK_FLOW
  BAGGAGE_BOOKING_FLOW
  FLIGHT_UPDATE_SMS_FLOW
  INSURANCE_FLOW
  INSURANCE_SHOPPING_CART_FLOW
  ITINERARY_BOOKING_FLOW
  ITINERARY_PRICE_FREEZE_FLOW
  ITINERARY_PRICE_FREEZE_REDEMPTION_FLOW
  POSTSELL_SERVICE_OPTION_SHOPPING_CART_FLOW
  PRIME_ACCOUNT_DISABLE_AUTO_RENEWAL_FLOW
  PRIME_MEMBERSHIP_RENEWAL_FLOW
  PRIME_MEMBERSHIP_RETENTION_FLOW
  PRIME_SUBSCRIPTION_CAMPAIGN_FLOW
  PRIME_SUBSCRIPTION_FLOW
  PROMO_CODE_FLOW
  RECURRING_PAYMENT_INSTRUMENT_VERIFIER_FLOW
  SEAT_BOOKING_FLOW
  WALLET_FUND_FLOW
  WALLET_REDEMPTION_SHOPPING_CART_FLOW
  WALLET_WITHDRAWAL_FLOW
}

input ShoppingBasketRequest {
  shoppingType: ShoppingType
  shoppingBasketId: String!
}

type ShoppingBasketResponse {
  shoppingBasketId: String!
  shoppingBasketToken: ShoppingBasketToken!
  insurances: [InsuranceProduct] @deprecated
  accommodations: [AccommodationProduct]
  fastTracks: [FastTrackShoppingBasketProduct]
  products: [ProductId!]!
  promoCodes: [ShoppingBasketPromoCode!]!
  priceBreakdown: ShoppingBasketPriceBreakdown!
  membershipSubscription: MembershipSubscriptionProduct
  buyer: Buyer
  userId: String
  totalPrice: Money
}

type ShoppingBasketToken {
  token: String!
}

type ShoppingBasketPriceBreakdown {
  priceBreakDownByProductType: [ShoppingBasketProductTypePriceBreakdown!]!
  price: ShoppingBasketPrice!
}

type ShoppingBasketProductTypePriceBreakdown {
  productType: ProductType!
  products: [ShoppingBasketProductPriceBreakdown!]!
  totalPrice: Money! @deprecated(reason: "Use price field instead")
  price: ShoppingBasketPrice!
}

type ShoppingBasketProductPriceBreakdown {
  productId: ProductId!
  totalPrice: Money! @deprecated(reason: "Use price field instead")
  price: ShoppingBasketPrice!
}

input CreateShoppingBasketRequest {
  shoppingType: ShoppingType
  bundleId: BundleId
}

input RemoveProductFromShoppingBasketRequest {
  shoppingType: ShoppingType
  shoppingBasketId: String!
  product: ProductIdRequest!
}

input AddProductToShoppingBasketRequest {
  shoppingType: ShoppingType
  shoppingBasketId: String!
  product: ProductIdRequest!
  totalPrice: MoneyRequest
}

type ProductId {
  id: String!
  type: ProductType!
}

input ProductIdRequest {
  id: String!
  type: ProductType!
}

input BundleId {
  id: String!
}

input AvailableCollectionMethodsRequest {
  shoppingId: String!
  shoppingType: ShoppingType
}

type AvailableCollectionMethodsResponse {
  collectionOptions: [CollectionMethod!]!
  delayedCollectionOptions: [CollectionMethod!]!
  selectableDelayedCollectionItems: [SelectableDelayedCollectionItem!]!
  priceLogic: PriceLogic
}

type SelectableDelayedCollectionItem {
  id: ID!
  checkoutFlow: ItemCheckoutFlow!
  date: String!
}

input UpdateProductsInShoppingBasketRequest {
  shoppingId: String!
  productsToAdd: [ProductIdRequest]!
  productsToRemove: [ProductIdRequest]!
}

type UpdateProductsInShoppingBasketActionStatus {
  productId: ProductId!
  success: Boolean!
}

type UpdateProductsInShoppingBasketResponse {
  status: [UpdateProductsInShoppingBasketActionStatus]!
}

input AddContactDetailsToShoppingBasketRequest {
  shoppingId: String!
  name: String!
  lastName: String
  email: String
  address: String
  cityName: String
  country: String
  postcode: String
  phoneNumber: String
  countryPhoneNumber: String
  typePhoneNumber: String
  countryCode: String
}

input ResumeShoppingBasketRequest {
  shoppingId: ID!
  userPaymentInteractionIdInput: UserPaymentInteractionIdInput
}

input CancelShoppingBasketCheckoutRequest {
  shoppingId: ID!
  userPaymentInteractionIdInput: UserPaymentInteractionIdInput
}

input AddBookingBuyerToShoppingBasketRequest {
  bookingId: Long!
  email: String!
}

type ShoppingBasketPromoCode {
  id: ID!
  code: String!
  amount: Money!
}

input AddShoppingBasketPromoCodeRequest {
  code: String!
  shoppingBasketId: ID!
}

type AddShoppingBasketPromoCodeResponse {
  shoppingBasketPromoCode: ShoppingBasketPromoCode!
}

input RemoveShoppingBasketPromoCodeRequest {
  id: ID!
  shoppingBasketId: ID!
}

type RemoveShoppingBasketPromoCodeResponse {
  success: Boolean!
}

input ShoppingBasketTokenByPayByLinkContentIdRequest {
  payByLinkContentId: ID!
}

type ShoppingBasketTokenByPayByLinkContentIdResponse {
  shoppingBasketToken: ShoppingBasketToken!
}

enum UniversalShoppingBasketProductType {
  MEMBERSHIP_RENEWAL
  MEMBERSHIP_SUBSCRIPTION
  ACCOMMODATION
  SEAT
  BAGGAGE
  ITINERARY_PRICE_FREEZE
  AIRPORT_FAST_TRACK
  RECURRING_PAYMENT_INSTRUMENT_VERIFIER
}

enum UniversalShoppingBasketCheckoutStatus {
  NOT_STARTED
  STARTED
  FINISHED
  ROLLED_BACK
  PENDING_COLLECTION
  USER_PAYMENT_INTERACTION
}

enum UniversalShoppingBasketBundleCheckoutFlow {
  ANCILLARY_BUNDLE_FLOW
}

enum UniversalShoppingBasketBundleType {
  ANCILLARY_BUNDLE
}

input UniversalShoppingBasketRequest {
  shoppingBasketId: ID!
}

input UniversalShoppingBasketCheckoutOptionsRequest {
  shoppingBasketId: ID!
}

input UniversalShoppingBasketByTokenRequest {
  shoppingBasketToken: String!
}

type UniversalShoppingBasketToken {
  token: String!
}

type UniversalShoppingBasketProduct {
  id: ID!
  type: UniversalShoppingBasketProductType!
}

type UniversalShoppingBasketBundle {
  id: ID!
  checkoutFlow: UniversalShoppingBasketBundleCheckoutFlow!
  type: UniversalShoppingBasketBundleType!
}

type UniversalShoppingBasketCheckoutOptionsResponse {
  collectionOptions: UniversalShoppingBasketCollectionOptions!
}

type UniversalShoppingBasketCollectionOptions {
  creditCardCollectionOptions: [UniversalShoppingBasketCreditCardCollectionOption!]!
  paypalCollectionOptions: [UniversalShoppingBasketPaypalCollectionOption!]!
  applePayCollectionOptions: [UniversalShoppingBasketApplePayCollectionOption!]!
  googlePayCollectionOptions: [UniversalShoppingBasketGooglePayCollectionOption!]!
  idealCollectionOptions: [UniversalShoppingBasketIdealCollectionOption!]!
}

type UniversalShoppingBasketCreditCardCollectionOption {
  id: ID!
  creditCardType: UniversalShoppingBasketCreditCardType!
}

type UniversalShoppingBasketCreditCardType {
  scheme: String!
  category: String!
  code: MethodTypeCode
  name: String!
}

type UniversalShoppingBasketPaypalCollectionOption {
  id: ID!
}

type UniversalShoppingBasketApplePayCollectionOption {
  id: ID!
}

type UniversalShoppingBasketGooglePayCollectionOption {
  id: ID!
}

type UniversalShoppingBasketIdealCollectionOption {
  id: ID!
}

type UniversalShoppingBasketContactDetails {
  name: String!
  lastName: String!
  email: String!
  address: String!
  cityName: String!
  country: String
  postcode: String
  phoneNumber: String
  countryPhoneNumber: String
  typePhoneNumber: String
  countryCode: String!
}

type UniversalShoppingBasketPriceBreakdown {
  priceBreakDownByProductType: [UniversalShoppingBasketProductTypePriceBreakdown!]!
  priceBreakDownByBundleType: [UniversalShoppingBasketBundleTypePriceBreakdown!]!
  price: ShoppingBasketPrice!
}

type UniversalShoppingBasketProductTypePriceBreakdown {
  productType: UniversalShoppingBasketProductType!
  products: [UniversalShoppingBasketProductPriceBreakdown!]!
  price: ShoppingBasketPrice!
}

type UniversalShoppingBasketProductPriceBreakdown {
  productId: UniversalShoppingBasketProduct!
  price: ShoppingBasketPrice!
}

type UniversalShoppingBasketBundleTypePriceBreakdown {
  bundleType: UniversalShoppingBasketBundleType!
  bundles: [UniversalShoppingBasketBundlePriceBreakdown!]!
  price: ShoppingBasketPrice!
}

type UniversalShoppingBasketBundlePriceBreakdown {
  bundleId: UniversalShoppingBasketBundle!
  price: ShoppingBasketPrice!
}

type UniversalShoppingBasketPromoCode {
  id: ID!
  code: String!
  amount: Money!
}

type UniversalShoppingBasketResponse {
  shoppingBasketId: ID!
  userId: ID
  shoppingBasketToken: UniversalShoppingBasketToken!
  products: [UniversalShoppingBasketProduct!]!
  bundles: [UniversalShoppingBasketBundle!]!
  promoCodes: [UniversalShoppingBasketPromoCode!]!
  priceBreakdown: UniversalShoppingBasketPriceBreakdown!
  contactDetails: UniversalShoppingBasketContactDetails
  checkoutStatus: UniversalShoppingBasketCheckoutStatus!
}

type UniversalShoppingBasketForTrackingResponse {
  bookingId: ID!
  promoCodes: [UniversalShoppingBasketPromoCode!]!
  priceBreakdown: UniversalShoppingBasketPriceBreakdown!
}

input UniversalShoppingBasketProductRequest {
  id: ID!
  type: UniversalShoppingBasketProductType!
}

input AddProductToUniversalShoppingBasketRequest {
  shoppingBasketId: ID!
  product: UniversalShoppingBasketProductRequest!
}

input RemoveProductFromUniversalShoppingBasketRequest {
  shoppingBasketId: ID!
  product: UniversalShoppingBasketProductRequest!
}

input AddUniversalShoppingBasketPromoCodeRequest {
  code: String!
  shoppingBasketId: ID!
}

input RemoveUniversalShoppingBasketPromoCodeRequest {
  id: ID!
  shoppingBasketId: ID!
}

type UniversalShoppingBasketProductResponse {
  success: Boolean!
}

type UniversalShoppingBasketPromoCodeResponse {
  success: Boolean!
}

input ContactDetailsToUniversalShoppingBasketRequest {
  name: String!
  lastName: String!
  email: String!
  address: String!
  cityName: String!
  country: String
  postcode: String
  phoneNumber: String
  countryPhoneNumber: String
  typePhoneNumber: String
  countryCode: String!
}

input AddContactDetailsToUniversalShoppingBasketRequest {
  shoppingBasketId: ID!
  contactDetails: ContactDetailsToUniversalShoppingBasketRequest!
}

type UniversalContactDetailsResponse {
  success: Boolean!
}

input UniversalRevenueForTrackingRequest {
  products: [UniversalRevenueProductPerType!]!
}

input UniversalRevenueProductPerType {
  productType: UniversalShoppingBasketProductType!
  products: [UniversalRevenueProduct!]!
}

input UniversalRevenueProduct {
  totalPrice: UniversalShoppingBasketMoneyRequest!
  revenue: Float! @bigdecimal
}

type UniversalRevenueForTrackingResponse {
  rMarketing: Float! @bigdecimal
  rSem: Float! @bigdecimal
}

input UniversalShoppingBasketMoneyRequest {
  amount: Float! @bigdecimal
  currency: String!
}

input ProductsForTrackingRequest {
  bookingToken: String!
}

type ProductsForTrackingResponse {
  products: [ProductForTracking!]!
}

type ProductForTracking {
  productId: String!
  productType: ProductType
}

type ShoppingBundleForTracking {
  shoppingId: ID!
  products: [Product!]
  promoCodeInfo: PromoCodeInfo
  totalPrice: Money!
}

input ShoppingBundleForTrackingRequest {
  shoppingInfo: ShoppingInfo
  collectionMethodInfo: CollectionMethodInfo
  feeSelected: FeeSelected = FULL_PRICE
}

enum AccommodationProductPricePerceptionType {
  PRIME
  NON_PRIME
  PAY_AT_DESTINATION
  PAY_AT_DESTINATION_CUSTOMER_CURRENCY
}

enum AccommodationProductPriceConcept {
  TAXES
  ROOM_PRICE
  MEMBERSHIP_DISCOUNT
  PROPERTY_FEE
  RESORT_FEE
  CITY_TAX
  OTHER
}

type AccommodationProductPrice {
  amount: Money!
  breakdown: AccommodationProductPriceBreakdown
}

type AccommodationProductPriceBreakdown {
  items: [AccommodationProductPriceBreakdownItem!]!
}

type AccommodationProductPriceBreakdownItem {
  concept: AccommodationProductPriceConcept!
  price: AccommodationProductPrice!
  percentage: Int
}

type AccommodationProductPricePerception {
  items: [AccommodationProductPricePerceptionItem!]!
}

type AccommodationProductPricePerceptionItem {
  type: AccommodationProductPricePerceptionType!
  price: AccommodationProductPrice!
}

input GetCancellationPoliciesRequest {
  tripDetailsToken: String!
}

type GetCancellationPoliciesResponse {
  cancellationPolicies: CancellationPolicies
}

type AccommodationInsuranceTripDetails {
  policyNumber: Long!
  mainGuestName: String!
  numberOfGuests: Int!
  hotelCity: String!
  checkInDate: String!
  checkOutDate: String!
}

enum MessageType {
  CANCELLATION
  MODIFICATION
  REIMBURSEMENT
  BOOKING_STATUS
  UNKNOWN
}

enum MessageStatus {
  OPEN_TICKET_PENDING
  CONTACT_AIRLINE
  BANKRUPTCY
  MANAGED_BY_TOUCHLESS
  MANAGED_BY_ICM
  MANUAL_AIRLINE_ALTERNATIVE
  REFUND_WAITING_CONSENT
  REFUND_NOT_MANAGED_BY_EDO
  CANCELLED
  REFUND_MERCHANT
  REFUND_NO_MERCHANT
  REFUND_WITH_STATUS
  REFUND_VOLUNTARY
  CHECKING_REFUND
  RESOLVED
  RESOLVED_BY_CUSTOMER
  REDEMPTION_PENDING
  PENDING_CLASSIFICATION
  MODIFICATION
  CUSTOMER_ALTERNATIVE_REQUESTED
  TRIP_DATES_CHANGE
  REIMBURSEMENT
  PENDING
  MANUAL_RECOVERY
  PARTIALLY_CONFIRMED
  REFUND_VOLUNTARY_AS_VOUCHER
  OPEN_TICKET_ACCEPTED
  CUSTOMER_ALTERNATIVE_ISSUED
  CONFIRMED
  ALL_CRITICAL
  ALL_OPEN_TICKET_PENDING
  ALL_CONTACT_AIRLINE
  ALL_BANKRUPTCY
  ALL_MANAGED_BY_TOUCHLESS
  ALL_MANAGED_BY_ICM
  ALL_MANUAL_AIRLINE_ALTERNATIVE
  ALL_REFUND_WAITING_CONSENT
  ALL_REFUND_NOT_MANAGED_BY_EDO
  ALL_INFORMATIVE
  ALL_REFUND
  ALL_RESOLVED
  ALL_RESOLVED_BY_CUSTOMER
  ALL_REDEMPTION_PENDING
  ALL_PENDING_CLASSIFICATION
  ALL_CUSTOMER_ALTERNATIVE_REQUESTED
  ALL_SUCCESSFUL
  ALL_OPEN_TICKET_ACCEPTED
  ALL_CUSTOMER_ALTERNATIVE_ISSUED
  UNKNOWN
}

enum MessageSemantic {
  INFORMATIVE
  CRITICAL
  SUCCESSFUL
  UNKNOWN
}

enum CancellationType {
  VOLUNTARY
  INVOLUNTARY
  UNKNOWN
}

enum CancellationStatus {
  BANKRUPTCY
  CONTACT_AIRLINE
  CUSTOMER_ALTERNATIVE_ISSUED
  CUSTOMER_ALTERNATIVE_REQUESTED
  MANAGED_BY_TOUCHLESS
  MANAGED_BY_ICM
  MANUAL_AIRLINE_ALTERNATIVE
  MULTIPLE_CANCELLATIONS
  OPEN_TICKET_ACCEPTED
  OPEN_TICKET_PENDING
  PENDING_CLASSIFICATION
  REDEMPTION_PENDING
  REFUND_MERCHANT
  REFUND_NO_MERCHANT
  REFUND_NOT_MANAGED_BY_EDO
  REFUND_WAITING_CONSENT
  REFUND_WITH_STATUS
  RESOLVED
  RESOLVED_BY_CUSTOMER
  CHECKING_REFUND
  PRIME_PLUS_REFUNDED_AS_VOUCHER
  UNKNOWN
}

enum CancellationProviderItemResolutionType {
  BSP_LINK
  MANAGED_BY_TOUCHLESS
  MANAGED_BY_ICM
  MANUAL
  NOT_VALID
  OPEN_TICKET_WITH_CONSENT
  OPEN_TICKET_WITHOUT_CONSENT
  REFUND_NOT_MANAGED_BY_EDO
  REFUND_WAITING_CONSENT
  RESOLVED
  RESOLVED_BY_CUSTOMER
  CUSTOMER_ALTERNATIVE_ISSUED
  VOLUNTARY
  PRIME_PLUS_REFUNDED_AS_VOUCHER
  UNKNOWN
  CASH_ONLY
}

enum CancellationProviderItemClassification {
  AIRLINE_ALTERNATIVE
  ATC_AUTOMATIC
  ATC_MANUAL
  BANKRUPTCY
  BSP_EXTERNAL
  BSP_LCC
  BSP_LINK
  CASHOUT
  COMMERCIAL_RELATIONSHIP
  CUSTOMER_ALTERNATIVE_REQUESTED
  CUSTOMER_DIRECT_RESOLUTION
  FREE_REBOOKING_MANUAL
  MANUAL
  NO_CASH
  OPEN_TICKET_ERROR
  OPEN_TICKET_WITH_CONSENT
  OPEN_TICKET_WITHOUT_CONSENT
  RESOLVED
  SEND_TO_AIRLINES
  TF_AUTOMATIC
  TF_BSM
  VOLUNTARY
  LC_CASH_REFUND
  MANUAL_REFUND
  REFUND_CHECK
  PRIME_PLUS_REFUNDED_AS_VOUCHER
  UNKNOWN
}

enum CancellationRefundStatus {
  REFUND_REQUESTED
  REFUND_PRIORITISING
  REFUND_PROCESSING
  REFUND_AIRLINE_REQUESTED
  REFUND_AIRLINE_PENDING
  REFUND_AIRLINE_APPROVED
  REFUND_FINALIZING
  UNKNOWN
}

enum IncidentStatus {
  CUSTOMER_CANCELLATION_CHOSEN
  WAITING_FOR_CUSTOMER_CHOICE
  UNKNOWN
}

enum ModificationRequestStatus {
  REQUESTED
  PRIORITISING
  PROCESSING
  AGENT_REVIEW
  UNKNOWN
}

enum ModificationCategory {
  TRIP_DATES_CHANGE
  UNKNOWN
}

enum ModificationType {
  VOLUNTARY
  INVOLUNTARY
  UNKNOWN
}

enum RetailBookingStatus {
  CANCELLED
  CONFIRMED
  MANUAL_RECOVERY
  PARTIALLY_CONFIRMED
  PENDING
  UNKNOWN
}

interface Message {
  bookingId: Long!
  type: MessageType!
  status: MessageStatus!
  semantic: MessageSemantic!
  priority: Int!
  extraHeader: Boolean!
}

type CancellationMessage implements Message {
  bookingId: Long!
  type: MessageType!
  status: MessageStatus!
  semantic: MessageSemantic!
  priority: Int!
  extraHeader: Boolean!
  cancellationType: CancellationType!
  cancellations: [Cancellation]!
}

type ModificationMessage implements Message {
  bookingId: Long!
  type: MessageType!
  status: MessageStatus!
  semantic: MessageSemantic!
  priority: Int!
  extraHeader: Boolean!
  modification: Modification!
  modificationCategory: ModificationCategory!
  modificationType: ModificationType!
}

type ReimbursementMessage implements Message {
  bookingId: Long!
  type: MessageType!
  status: MessageStatus!
  semantic: MessageSemantic!
  priority: Int!
  extraHeader: Boolean!
  reimbursements: [Reimbursement!]!
}

type BookingStatusMessage implements Message {
  bookingId: Long!
  type: MessageType!
  status: MessageStatus!
  semantic: MessageSemantic!
  priority: Int!
  extraHeader: Boolean!
  partialRebookUrl: String
  bookingStatus: RetailBookingStatus
}

type Reimbursement {
  creationDate: String!
}

type Modification {
  status: ModificationRequestStatus
  lastUpdated: String @dateISO8601
}

type Cancellation {
  cancellationStatus: CancellationStatus
  cancellationId: CancellationId
  cancellationProviderItem: CancellationProviderItem
  cancellationRefund: CancellationRefund
  incidents: [Incident]
  bookingItemId: Long!
  providerBookingItemId: Long
  pnr: String
  merchant: Boolean!
}

type CancellationId {
  id: String!
}

type CancellationProviderItem {
  resolutionType: CancellationProviderItemResolutionType
  classification: CancellationProviderItemClassification
  topUpVoucherAmount: Money
  topUpVoucherMinBasketAmount: Money
  openTicketAmount: Money
  primeSubscriptionAmount: Money
  cashRefundAmount: Money
  openTicketTotalAmount: Money
  openTicketPrimeTotalAmount: Money
}

type CancellationRefund {
  status: CancellationRefundStatus!
  statusDateList: [CancellationRefundStatusDateMapEntry]
}

type CancellationRefundStatusDateMapEntry {
  key: CancellationRefundStatus!
  value: String @dateISO8601
}

type Incident {
  incidentId: IncidentId!
  flightNumber: String
  departureDate: String!
  incidentStatus: IncidentStatus
  consent: IncidentConsent
  source: String
  creationDate: String!
}

type IncidentId {
  id: String!
}

type IncidentConsent {
  flexibleTicketAccepted: Boolean
  voucherAccepted: Boolean
  emdAccepted: Boolean
  cashRefundAccepted: Boolean
  airlineAlternativeAccepted: Boolean
}

type GetCancellationMessageResponse {
  messages: [Message]!
}

enum PurchasedQuantity {
  NONE
  SOME
  ALL
}

input GetAncillariesPurchaseStateRequest {
  token: ID!
}

type AncillariesPurchaseStateResponse {
  itineraryTravellers: Long!
  seats: AncillaryPurchaseState!
  bags: AncillaryPurchaseState!
}

type AncillaryPurchaseState {
  productType: ProductType!
  purchasedQuantity: PurchasedQuantity!
  anyOtherProductPurchasable: Boolean!
}`